/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable */
import React, { useState, useMemo, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { supabase } from "./supabase";
 
// ─── DATA ────────────────────────────────────────────────────────────────────
const CAP_LIMIT = 1340000;
 
const TEAMS = [
  { id:"bos", name:"Boston Fleet",          abbr:"BOS", color:"#4a9eff", colorLight:"#1d4ed8", coach:"Kris Sparre",        gm:"Danielle Marmer",     logo:"/logos/bos.png" },
  { id:"min", name:"Minnesota Frost",        abbr:"MIN", color:"#43d98c", colorLight:"#15803d", coach:"Ken Klee",           gm:"Natalie Darwitz",     logo:"/logos/min.png" },
  { id:"mtl", name:"Montreal Victoire",      abbr:"MTL", color:"#ef5350", colorLight:"#b91c1c", coach:"Kori Cheverie",      gm:"Danièle Sauvageau",   logo:"/logos/mtl.png" },
  { id:"ny",  name:"New York Sirens",        abbr:"NYS", color:"#7986cb", colorLight:"#4338ca", coach:"Jamie Dowler",       gm:"Pascal Daoust",       logo:"/logos/ny.png" },
  { id:"ott", name:"Ottawa Charge",          abbr:"OTT", color:"#ff7043", colorLight:"#c2410c", coach:"Gilles Bouchard",    gm:"Michael Hirshfeld",   logo:"/logos/ott.png" },
  { id:"tor", name:"Toronto Sceptres",       abbr:"TOR", color:"#4a9eff", colorLight:"#1d4ed8", coach:"Troy Ryan",          gm:"Gina Kingsbury",      logo:"/logos/tor.png" },
  { id:"sea", name:"Seattle Torrent",        abbr:"SEA", color:"#26c6da", colorLight:"#0e7490", coach:"Steve O\'Rourke",   gm:"Meghan Turner",       logo:"/logos/sea.png" },
  { id:"van", name:"Vancouver Goldeneyes",   abbr:"VAN", color:"#66bb6a", colorLight:"#15803d", coach:"Craig MacTavish",    gm:"Cara Gardner Morey",  logo:"/logos/van.png" },
];
 
const PLAYERS = [
  { id:1,  num:13, name:"Marie-Philip Poulin",     team:"mtl", pos:"F", sub:"C",  age:33, dob:"1991-01-28", ht:"5'6", wt:163, clause:"NMC", agent:"Pat Brisson",    status:"UFA",    sal:92000,  yrs:1, exp:"2026", transactions:[{date:"Aug 2024",type:"Signed",detail:"Re-signed MTL · 1yr / $92,000"},{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MTL"}]},
  { id:2,  num:19, name:"Taylor Heise",            team:"min", pos:"F", sub:"C",  age:23, dob:"2001-04-08", ht:"5'5", wt:157, clause:"—",   agent:"Allison Alter",  status:"RFA",    sal:88000,  yrs:2, exp:"2027", transactions:[{date:"Jul 2024",type:"Signed",detail:"Extended MIN · 2yr / $88,000"}]},
  { id:3,  num:21, name:"Hilary Knight",           team:"sea", pos:"F", sub:"RW", age:35, dob:"1989-07-12", ht:"5'11", wt:172, clause:"NTC", agent:"Neil Sheehy",    status:"UFA",    sal:80000,  yrs:1, exp:"2026", transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded BOS → SEA · Expansion"},{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  { id:4,  num:7,  name:"Sarah Fillier",           team:"ny",  pos:"F", sub:"C",  age:24, dob:"2000-08-22", ht:"5'9", wt:165, clause:"—",   agent:"Dan Milstein",   status:"RFA",    sal:78000,  yrs:1, exp:"2026", transactions:[{date:"Nov 2024",type:"Signed",detail:"Signed NYS · 1yr / $78,000"}]},
  { id:5,  num:17, name:"Emily Clark",             team:"ott", pos:"F", sub:"RW", age:29, dob:"1996-01-11", ht:"5'8", wt:160, clause:"NMC", agent:"Ben Hankinson",  status:"Signed", sal:101000, yrs:2, exp:"2027", transactions:[{date:"Aug 2025",type:"Signed",detail:"Extended OTT · 2yr / $101,000 — PWHL record"},{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · OTT"}]},
  { id:6,  num:19, name:"Brianne Jenner",          team:"ott", pos:"F", sub:"C",  age:32, dob:"1992-05-02", ht:"5'9", wt:163, clause:"NTC", agent:"JP Barry",       status:"UFA",    sal:85000,  yrs:1, exp:"2026", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · OTT"}]},
  { id:7,  num:26, name:"Kendall Coyne Schofield", team:"min", pos:"F", sub:"C",  age:31, dob:"1994-05-26", ht:"5'8", wt:163, clause:"NMC", agent:"Kurt Overhardt", status:"Signed", sal:100000, yrs:1, exp:"2026", transactions:[{date:"Sep 2025",type:"Signed",detail:"Re-signed MIN · 1yr / $100,000"}]},
  { id:8,  num:10, name:"Alex Carpenter",          team:"sea", pos:"F", sub:"C",  age:29, dob:"1996-05-10", ht:"5'8", wt:158, clause:"—",   agent:"JP Barry",       status:"RFA",    sal:82000,  yrs:1, exp:"2026", transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded NYS → SEA · Expansion"}]},
  { id:9,  num:18, name:"Sarah Nurse",             team:"van", pos:"F", sub:"RW", age:29, dob:"1996-06-21", ht:"5'10", wt:168, clause:"—",   agent:"Mike Liut",      status:"Signed", sal:85000,  yrs:2, exp:"2027", transactions:[{date:"Aug 2025",type:"Signed",detail:"Signed VAN · 2yr / $85,000"}]},
  { id:10, num:20, name:"Abby Roque",              team:"mtl", pos:"F", sub:"LW", age:27, dob:"1998-04-10", ht:"5'7", wt:155, clause:"—",   agent:"Neil Sheehy",    status:"RFA",    sal:79000,  yrs:1, exp:"2026", transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded NYS → MTL"}]},
  { id:11, num:22, name:"Danielle Serdachny",      team:"sea", pos:"F", sub:"C",  age:23, dob:"2002-03-20", ht:"5'7", wt:155, clause:"—",   agent:"Allison Alter",  status:"RFA",    sal:84000,  yrs:1, exp:"2026", transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded OTT → SEA"}]},
  { id:12, num:5,  name:"Megan Keller",            team:"bos", pos:"D", sub:"RD", age:27, dob:"1997-10-10", ht:"5'8", wt:163, clause:"NMC", agent:"Kurt Overhardt", status:"Signed", sal:88000,  yrs:2, exp:"2027", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  { id:13, num:6,  name:"Savannah Harmon",         team:"ott", pos:"D", sub:"RD", age:29, dob:"1996-06-04", ht:"5'7", wt:160, clause:"—",   agent:"Ben Hankinson",  status:"RFA",    sal:80000,  yrs:1, exp:"2026", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · OTT"}]},
  { id:14, num:3,  name:"Sophie Jaques",           team:"bos", pos:"D", sub:"LD", age:23, dob:"2001-08-14", ht:"5'5", wt:150, clause:"—",   agent:"Pat Brisson",    status:"RFA",    sal:80000,  yrs:1, exp:"2026", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  { id:15, num:4,  name:"Ella Shelton",            team:"ny",  pos:"D", sub:"LD", age:24, dob:"2001-01-11", ht:"5'5", wt:152, clause:"—",   agent:"Mike Liut",      status:"RFA",    sal:75000,  yrs:1, exp:"2026", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · NYS"}]},
  { id:16, num:31, name:"Aerin Frankel",           team:"bos", pos:"G", sub:"G",  age:27, dob:"1997-01-04", ht:"5'9", wt:163, clause:"NMC", agent:"JP Barry",       status:"Signed", sal:88000,  yrs:2, exp:"2027", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  { id:17, num:35, name:"Emerance Maschmeyer",     team:"van", pos:"G", sub:"G",  age:31, dob:"1993-01-23", ht:"5'10", wt:165, clause:"NMC", agent:"Neil Sheehy",    status:"Signed", sal:90000,  yrs:2, exp:"2027", transactions:[{date:"Aug 2025",type:"Signed",detail:"Signed VAN · 2yr / $90,000"}]},
  { id:18, num:33, name:"Corinne Schroeder",       team:"sea", pos:"G", sub:"G",  age:25, dob:"2000-06-20", ht:"5'9", wt:163, clause:"—",   agent:"Mike Liut",      status:"Signed", sal:60000,  yrs:2, exp:"2027", transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded NYS → SEA"}]},
  { id:19, num:29, name:"Ann-Renée Desbiens",      team:"min", pos:"G", sub:"G",  age:31, dob:"1994-06-18", ht:"5'7", wt:160, clause:"—",   agent:"Pat Brisson",    status:"RFA",    sal:80000,  yrs:1, exp:"2026", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MIN"}]},
  { id:20, num:30, name:"Gwyneth Philips",         team:"ott", pos:"G", sub:"G",  age:25, dob:"2000-07-28", ht:"5'9", wt:165, clause:"—",   agent:"Ben Hankinson",  status:"RFA",    sal:75000,  yrs:1, exp:"2026", transactions:[{date:"Aug 2024",type:"Signed",detail:"Re-signed OTT after playoff MVP"}]},
  { id:21, num:14, name:"Jamie Lee Rattray",       team:"bos", pos:"F", sub:"LW", age:32, dob:"1992-01-17", ht:"5'9", wt:163, clause:"—",   agent:"JP Barry",       status:"UFA",    sal:80000,  yrs:1, exp:"2026", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  { id:22, num:88, name:"Gabbie Hughes",           team:"ott", pos:"F", sub:"LW", age:24, dob:"2001-02-06", ht:"5'5", wt:152, clause:"—",   agent:"Ben Hankinson",  status:"RFA",    sal:82000,  yrs:1, exp:"2026", transactions:[{date:"Aug 2024",type:"Signed",detail:"Re-signed OTT · 1yr / $82,000"}]},
  { id:23, num:10, name:"Alina Muller",            team:"bos", pos:"F", sub:"LW", age:26, dob:"1999-05-05", ht:"5'5", wt:150, clause:"—",   agent:"Pat Brisson",    status:"Signed", sal:80000,  yrs:2, exp:"2027", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  { id:24, num:16, name:"Liz Schepers",            team:"bos", pos:"F", sub:"RW", age:28, dob:"1996-08-27", ht:"5'7", wt:158, clause:"—",   agent:"Kurt Overhardt", status:"RFA",    sal:80000,  yrs:1, exp:"2026", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  { id:25, num:27, name:"Jennifer Gardiner",       team:"van", pos:"F", sub:"LW", age:23, dob:"2002-03-06", ht:"5'6", wt:148, clause:"—",   agent:"Allison Alter",  status:"RFA",    sal:50000,  yrs:1, exp:"2026", transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded MTL → VAN"}]},
  { id:26, num:8,  name:"Ronja Savolainen",        team:"ott", pos:"D", sub:"LD", age:24, dob:"2001-10-14", ht:"5'6", wt:152, clause:"—",   agent:"Ben Hankinson",  status:"RFA",    sal:52000,  yrs:1, exp:"2026", transactions:[{date:"Nov 2025",type:"Signed",detail:"Extension OTT · 1yr"}]},
];
 
// Draft picks now loaded from Supabase `draft_picks` table
 
const CBA_RULES = [
  {q:"What is the PWHL salary cap?",      a:"Each team has a $1.3M USD team cap for 2025–26, increasing 3% annually through 2031."},
  {q:"What is the minimum salary?",       a:"$35,000 USD minimum. At least 6 players per team must earn $80,000+. Team average must hit $60,099.98."},
  {q:"What is an RFA?",                   a:"Restricted Free Agent — their team retains rights and can match any offer sheet from another team."},
  {q:"What is a UFA?",                    a:"Unrestricted Free Agent — can sign with any team freely when their contract expires."},
  {q:"What is an NMC?",                   a:"No-Movement Clause — team cannot trade, waive, or assign the player without their explicit consent."},
  {q:"What is an NTC?",                   a:"No-Trade Clause — player can block trades to specific teams or entirely, depending on the specific terms."},
  {q:"How does salary retention work?",   a:"New in 2025–26: a trading team can retain part of a player's salary. Retained amount still counts against their cap."},
  {q:"What is the Gold Plan?",            a:"Once eliminated from playoffs, remaining standings points become Draft Order Points — keeping teams competing rather than tanking."},
  {q:"How does 3-2-1-0 scoring work?",   a:"3pts regulation win · 2pts OT/SO win · 1pt OT/SO loss · 0pts regulation loss."},
  {q:"How long is the current CBA?",      a:"Eight years through 2030–31, with 3% annual salary increases at every tier built in."},
];
 
const SEASONS = ["Career","2025-26","2024-25","2024-25-playoffs","2023-24","2023-24-playoffs"];
 
// ─── DB HELPERS ──────────────────────────────────────────────────────────────
async function dbFetchPlayers() {
  const { data, error } = await supabase
    .from('players')
    .select('*')
    .order('team_id')
    .order('pos')
    .order('last_name');
  if (error) { console.error('fetchPlayers error:', error); return null; }
  return data;
}
 
async function dbFetchSkaterStats(season='2025-26') {
  const { data, error } = await supabase
    .from('stats_skaters')
    .select('*, players(id, first_name, last_name, team_id, pos, sub_pos, num, photo_url)')
    .eq('season', season);
  if (error) { console.error('fetchSkaterStats error:', error); return []; }
  return data || [];
}
 
async function dbFetchGoalieStats(season='2025-26') {
  const { data, error } = await supabase
    .from('stats_goalies')
    .select('*, players(id, first_name, last_name, team_id, pos, sub_pos, num, photo_url)')
    .eq('season', season);
  if (error) { console.error('fetchGoalieStats error:', error); return []; }
  return data || [];
}
 
// Map DB player row to app format (merges real DB data with placeholder contract data)
function dbPlayerToApp(dbP, contractMap) {
  const name = `${dbP.first_name} ${dbP.last_name}`.trim();
  const contract = contractMap[name] || {};
  return {
    id:       dbP.id,
    num:      dbP.num,
    name,
    firstName: dbP.first_name,
    lastName:  dbP.last_name,
    team:      dbP.team_id,
    pos:       dbP.pos || 'F',
    sub:       dbP.sub_pos || dbP.pos || 'F',
    age:       dbP.birthdate ? Math.floor((new Date() - new Date(dbP.birthdate)) / (365.25*24*60*60*1000)) : (dbP.age || null),
    dob:       dbP.birthdate || null,
    ht:        dbP.height || null,
    wt:        dbP.weight || null,
    shoots:    dbP.shoots || null,
    nationality: dbP.nationality || null,
    hometown:  dbP.birthplace || dbP.hometown || null,
    photoUrl:  dbP.photo_url || null,
    // Contract defaults — overridden by DB contracts in second pass
    sal:       contract.sal || 0,
    yrs:       contract.yrs || 1,
    exp:       contract.exp || '2026',
    clause:    contract.clause || '—',
    agent:     contract.agent || '—',
    status:    contract.status || 'RFA',
    transactions: contract.transactions || [],
    injuryStatus: dbP.injury_status || null,
    injuryNote:   dbP.injury_note || null,
    injuryDate:   dbP.injury_date || null,
  };
}
 
// Real salary data (2024-25 disclosed + estimated 2025-26 with 3% CBA raise)
const CONTRACT_DATA = {
  // BOS
  "Hilary Knight":            {sal:106090, yrs:1, exp:"2026", clause:"NMC", agent:"Neil Sheehy",    status:"UFA",    transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded BOS → SEA · Expansion"},{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  "Megan Keller":             {sal:95481,  yrs:2, exp:"2027", clause:"NMC", agent:"Kurt Overhardt", status:"Signed", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  "Alina Müller":             {sal:87034,  yrs:2, exp:"2027", clause:"—",   agent:"Pat Brisson",    status:"Signed", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  "Aerin Frankel":            {sal:84872,  yrs:2, exp:"2027", clause:"NMC", agent:"JP Barry",       status:"Signed", transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  "Jamie Lee Rattray":        {sal:84872,  yrs:1, exp:"2026", clause:"—",   agent:"JP Barry",       status:"UFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  "Susanna Tapani":           {sal:74263,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"UFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  "Loren Gabel":              {sal:68959,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · BOS"}]},
  // MIN
  "Kendall Coyne Schofield":  {sal:100786, yrs:1, exp:"2026", clause:"NMC", agent:"Kurt Overhardt", status:"Signed", transactions:[{date:"Sep 2025",type:"Signed",detail:"Re-signed MIN · 1yr"}]},
  "Taylor Heise":             {sal:90707,  yrs:2, exp:"2027", clause:"—",   agent:"Allison Alter",  status:"Signed", transactions:[{date:"Jul 2024",type:"Signed",detail:"Extended MIN · 2yr"}]},
  "Lee Stecklein":            {sal:90177,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MIN"}]},
  "Nicole Hensley":           {sal:86463,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MIN"}]},
  "Kelly Pannek":             {sal:84872,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MIN"}]},
  "Grace Zumwinkle":          {sal:84872,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MIN"}]},
  // MTL
  "Marie-Philip Poulin":      {sal:125217, yrs:3, exp:"2028", clause:"NMC", agent:"Pat Brisson",    status:"UFA",    transactions:[{date:"Aug 2025",type:"Signed",detail:"Extended MTL · 3yr / $125,217"},{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MTL"}]},
  "Ann-Renée Desbiens":       {sal:97821,  yrs:1, exp:"2026", clause:"—",   agent:"Pat Brisson",    status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MTL"}]},
  "Laura Stacey":             {sal:92673,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MTL"}]},
  "Erin Ambrose":             {sal:84872,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MTL"}]},
  "Maureen Murphy":           {sal:84872,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · MTL"}]},
  "Abby Roque":               {sal:116599, yrs:1, exp:"2026", clause:"—",   agent:"Neil Sheehy",    status:"RFA",    transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded NYS → MTL (salary retained)"}]},
  // NY
  "Sarah Fillier":            {sal:120000, yrs:2, exp:"2027", clause:"NMC", agent:"Dan Milstein",   status:"Signed", transactions:[{date:"Aug 2025",type:"Signed",detail:"Record extension NYS · 3yr / $120,000"}]},
  "Micah Zandee-Hart":        {sal:96434,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · NYS"}]},
  "Ella Shelton":             {sal:87524,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · NYS"}]},
  "Jaime Bourbonnais":        {sal:84872,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · NYS"}]},
  "Jessie Eldridge":          {sal:84872,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded NYS → SEA · Expansion"}]},
  "Alex Carpenter":           {sal:100786, yrs:1, exp:"2026", clause:"—",   agent:"JP Barry",       status:"RFA",    transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded NYS → SEA · Expansion"}]},
  // OTT
  "Brianne Jenner":           {sal:121954, yrs:1, exp:"2026", clause:"NTC", agent:"JP Barry",       status:"UFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · OTT"}]},
  "Emily Clark":              {sal:106090, yrs:2, exp:"2027", clause:"NMC", agent:"Ben Hankinson",  status:"Signed", transactions:[{date:"Aug 2025",type:"Signed",detail:"Extended OTT · 2yr / PWHL record"}]},
  "Jocelyne Larocque":        {sal:86993,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"UFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · OTT"}]},
  "Gabbie Hughes":            {sal:84872,  yrs:1, exp:"2026", clause:"—",   agent:"Ben Hankinson",  status:"RFA",    transactions:[{date:"Aug 2024",type:"Signed",detail:"Re-signed OTT · 1yr"}]},
  "Rebecca Leslie":           {sal:38625,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · OTT"}]},
  // TOR
  "Daryl Watts":              {sal:87550,  yrs:2, exp:"2027", clause:"—",   agent:"JP Barry",       status:"Signed", transactions:[{date:"Aug 2024",type:"Signed",detail:"Re-signed TOR · 2yr"}]},
  "Natalie Spooner":          {sal:75000,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"UFA",    transactions:[{date:"Jan 2024",type:"Signed",detail:"Signed inaugural PWHL contract · TOR"}]},
  // SEA
  "Corinne Schroeder":        {sal:53560,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded NYS → SEA · Expansion"}]},
  "Hannah Murphy":            {sal:37750,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Aug 2025",type:"Signed",detail:"Signed SEA · 1yr"}]},
  // VAN
  "Mikyla Grant-Mentis":      {sal:37132,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Aug 2025",type:"Signed",detail:"Signed VAN · 1yr"}]},
  "Emily Brown":              {sal:49440,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Aug 2025",type:"Traded",detail:"Traded BOS → SEA · later VAN"}]},
  "Cayla Barnes":             {sal:55620,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Aug 2025",type:"Signed",detail:"Signed SEA · 1yr"}]},
  "Carly Jackson":            {sal:37132,  yrs:1, exp:"2026", clause:"—",   agent:"—",              status:"RFA",    transactions:[{date:"Aug 2025",type:"Signed",detail:"Signed VAN · 1yr"}]},
};
 
// ─── FAKE STATS ───────────────────────────────────────────────────────────────
const rnd  = (id,sc,off=0) => Math.round((((id*7*9301+49297)%233280)/233280)*sc+off);
const rndF = (id,sc,off=0) => Math.round(((((id*7*9301+49297)%233280)/233280)*sc+off)*10)/10;
function genSkater(p,season){
  const s=season==="Career"?3:1,b=p.id;
  const gp=Math.min(30*s,rnd(b+season.length,10*s,18*s));
  const g=rnd(b+1,12*s,2*s),a=rnd(b+2,16*s,4*s);
  return{gp,g,a,pts:g+a,pm:rnd(b+3,20,-10),pim:rnd(b+4,18,0),
    shots:rnd(b+5,60*s,20*s),spct:rndF(b+6,18,5),toi:rndF(b+7,8,12),
    esg:Math.round(g*.7),esa:Math.round(a*.7),ppg:Math.round(g*.25),ppa:Math.round(a*.25),
    shg:rnd(b+8,2,0),sha:rnd(b+9,1,0),
    cf:rndF(b+10,15,45),ff:rndF(b+11,14,46),gf:rndF(b+12,18,42),
    zs:rndF(b+13,30,35),p60:rndF(b+14,2,1.2),pdo:rndF(b+15,4,98)};
}
function genGoalie(p,season){
  const s=season==="Career"?3:1,b=p.id;
  const gp=Math.min(28*s,rnd(b+1,10*s,12*s));
  const w=Math.round(gp*rndF(b+2,.3,.45));
  return{gp,w,l:Math.round((gp-w)*.7),otl:gp-w-Math.round((gp-w)*.7),
    ga:rnd(b+4,30*s,20*s),gaa:rndF(b+5,1.5,1.8),svp:rndF(b+6,4,91)/100,so:rnd(b+7,4*s,0)};
}
 
// ─── HELPERS ──────────────────────────────────────────────────────────────────
const fmt    = n => n>0 ? "$"+n.toLocaleString() : "—";
const fmtSal = (p) => {
  if(!p.sal || p.sal===0) return {text:"Undisclosed",color:"var(--text3)",est:true,src:null};
  if(p.isEstimate) return {text:"$"+p.sal.toLocaleString(),color:"var(--ye)",est:true,src:"est."};
  const src = p.source?.match(/\[(.*?)\]/)?.[1] || "Disclosed";
  return {text:"$"+p.sal.toLocaleString(),color:"var(--text)",est:false,src};
};
const gT     = id => TEAMS.find(t=>t.id===id);
// gP and tSpent will use a dynamic player list set at runtime
let _PLAYERS = [];
let _THEME = 'dark';
const gP     = id => _PLAYERS.find(p=>p.id===id);
const tSpent = id => _PLAYERS.filter(p=>p.team===id).reduce((a,p)=>a+p.sal,0);
const tColor = t => t ? (_THEME==='light' ? (t.colorLight||t.color) : t.color) : '#888';
const scls   = s => s==="UFA"?"sc-ufa":s==="RFA"?"sc-rfa":"sc-sig";
const txCol  = t => t==="Signed"?"var(--gr)":t==="Traded"?"var(--ac)":"var(--ye)";
 
function buildLines(tp){
  const fwds=[...tp.filter(p=>p.pos==="F")];
  const defs=[...tp.filter(p=>p.pos==="D")];
  const gs=[...tp.filter(p=>p.pos==="G")];
  const fL=[[null,null,null],[null,null,null],[null,null,null],[null,null,null]];
  fwds.forEach((p,i)=>{const l=Math.floor(i/3),s=i%3;if(l<4)fL[l][s]=p.id;});
  const dL=[[null,null],[null,null],[null,null]];
  defs.forEach((p,i)=>{const l=Math.floor(i/2),s=i%2;if(l<3)dL[l][s]=p.id;});
  return{fL,dL,gL:[gs[0]?.id||null,gs[1]?.id||null]};
}
 
// ─── CSS ──────────────────────────────────────────────────────────────────────
const CSS=`
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root,[data-theme="dark"]{
  --bg:#0d1117;--bg2:#161b27;--bg3:#1c2336;--bg4:#222840;--bg5:#28304a;
  --border:rgba(255,255,255,.09);--border2:rgba(255,255,255,.18);
  --text:#e2e8f0;--text2:#94a3b8;--text3:#64748b;
  --ac:#4fc3f7;--gr:#43d98c;--ye:#f5c842;--rd:#ef5350;--or:#ff8a65;
  --ff:'IBM Plex Sans',sans-serif;--fm:'IBM Plex Mono',monospace;
}
[data-theme="light"]{
  --bg:#f1f5f9;--bg2:#ffffff;--bg3:#f8fafc;--bg4:#e2e8f0;--bg5:#cbd5e1;
  --border:rgba(0,0,0,.08);--border2:rgba(0,0,0,.15);
  --text:#0f172a;--text2:#334155;--text3:#64748b;
  --ac:#0369a1;--gr:#15803d;--ye:#a16207;--rd:#b91c1c;--or:#c2410c;
}
html,body{background:var(--bg);color:var(--text);font-family:var(--ff);font-size:14px;overflow-x:hidden;max-width:100vw;-webkit-font-smoothing:antialiased}
button{cursor:pointer;border:none;background:none;font-family:var(--ff);color:inherit}
select,input{font-family:var(--ff)}
.shell{display:flex;flex-direction:column;min-height:100vh;width:100%;overflow-x:hidden}
.bar{height:46px;display:flex;align-items:stretch;background:var(--bg2);border-bottom:1px solid var(--border);position:sticky;top:0;z-index:100;overflow:hidden;width:100%}
.bar-inner{display:flex;align-items:stretch;padding:0 12px;gap:2px;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scrollbar-width:none;flex:1;min-width:0}
.bar-inner::-webkit-scrollbar{display:none}
.logo{display:flex;align-items:center;gap:7px;font-size:16px;font-weight:700;color:var(--text);cursor:pointer;white-space:nowrap;flex-shrink:0;margin-right:16px}
.logo-dot{width:6px;height:6px;border-radius:50%;background:var(--ac);box-shadow:0 0 8px var(--ac)}
.logo em{color:var(--ac);font-style:normal}
.nb{display:flex;align-items:center;padding:0 12px;font-size:13px;font-weight:500;color:var(--text2);border-bottom:2px solid transparent;transition:color .12s,border-color .12s;white-space:nowrap;flex-shrink:0}
.nb:hover{color:var(--text)}.nb.on{color:var(--ac);border-bottom-color:var(--ac)}
.stag{flex-shrink:0;align-self:center;margin-left:auto;margin-right:4px;font-family:var(--fm);font-size:10px;color:var(--text3);border:1px solid var(--border2);padding:2px 7px;border-radius:3px;white-space:nowrap}
.main{flex:1;max-width:1160px;width:100%;margin:0 auto;padding:20px 14px 60px;overflow-x:hidden}
.ph{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:16px;flex-wrap:wrap;gap:6px}
.ph h1{font-size:18px;font-weight:700;letter-spacing:-.3px}
.ph-sub{font-size:11px;color:var(--text3);font-family:var(--fm)}
.slbl{font-family:var(--fm);font-size:9px;letter-spacing:1.8px;text-transform:uppercase;color:var(--text3);display:block;margin-bottom:7px}
.sstrip{display:grid;grid-template-columns:repeat(5,1fr);gap:1px;background:var(--border);border:1px solid var(--border);border-radius:6px;overflow:hidden;margin-bottom:18px}
.sc{background:var(--bg2);padding:12px 14px}
.sc-l{font-family:var(--fm);font-size:9px;letter-spacing:1.2px;text-transform:uppercase;color:var(--text3);margin-bottom:3px}
.sc-v{font-size:20px;font-weight:700;line-height:1}
.sc-n{font-size:10px;color:var(--text3);margin-top:2px}
.c-ac{color:var(--ac)}.c-gr{color:var(--gr)}.c-rd{color:var(--rd)}.c-ye{color:var(--ye)}
.cb{background:var(--bg5);border-radius:2px;overflow:hidden;margin:5px 0}
.cbi{height:100%;border-radius:2px;transition:width .5s}
.crd{background:var(--bg2);border:1px solid var(--border);border-radius:6px;overflow:hidden}
.crd-h{padding:10px 14px;background:var(--bg3);border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap}
.crd-t{font-size:13px;font-weight:600}
.tbl-scroll{overflow-x:auto;-webkit-overflow-scrolling:touch;width:100%}
.tbar{padding:9px 12px;background:var(--bg3);border-bottom:1px solid var(--border);display:flex;gap:7px;flex-wrap:wrap}
.ts{background:var(--bg4);border:1px solid var(--border2);border-radius:4px;padding:6px 9px;font-size:13px;color:var(--text);outline:none;flex:1;min-width:140px}
.ts::placeholder{color:var(--text3)}
.sel{background:var(--bg4);border:1px solid var(--border2);border-radius:4px;padding:6px 8px;font-size:12px;color:var(--text2);outline:none}
table{width:100%;border-collapse:collapse;min-width:560px}
thead tr{background:var(--bg3);border-bottom:1px solid var(--border2)}
th{padding:8px 11px;text-align:left;font-family:var(--fm);font-size:9px;letter-spacing:1px;text-transform:uppercase;color:var(--text3);white-space:nowrap;cursor:pointer;user-select:none}
th.r{text-align:right}
td{padding:8px 11px;font-size:13px;color:var(--text2);border-bottom:1px solid var(--border);white-space:nowrap}
td.b{color:var(--text);font-weight:500}td.m{font-family:var(--fm);font-size:12px}td.r{text-align:right}
th.sal-col,td.sal-col{text-align:right;width:100px;min-width:100px;max-width:100px;font-family:var(--fm);font-size:12px;font-variant-numeric:tabular-nums;white-space:nowrap}
.roster-tbl{width:100%}
.roster-tbl th,.roster-tbl td{padding:6px 8px}
tr.sec-hdr th{font-family:var(--fm);font-size:10px;letter-spacing:1px;text-transform:uppercase;color:var(--text3);padding:4px 8px;border-bottom:1px solid var(--border)}
table[style*="table-layout"] td{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.roster-tbl th:nth-child(1),.roster-tbl td:nth-child(1){width:45px}
.roster-tbl th:nth-child(3),.roster-tbl td:nth-child(3){width:40px}
.roster-tbl th:nth-child(4),.roster-tbl td:nth-child(4){width:100px;text-align:right;font-family:var(--fm);font-variant-numeric:tabular-nums}
.roster-tbl th:nth-child(5),.roster-tbl td:nth-child(5){width:35px}
.roster-tbl th:nth-child(6),.roster-tbl td:nth-child(6){width:50px}
.roster-tbl th:nth-child(7),.roster-tbl td:nth-child(7){width:65px}
.roster-tbl th:nth-child(8),.roster-tbl td:nth-child(8){width:55px}
tr:last-child td{border-bottom:none}
tbody tr:hover td{background:rgba(255,255,255,.02);cursor:pointer}
.bx{display:inline-flex;align-items:center;padding:1px 6px;border-radius:3px;font-family:var(--fm);font-size:10px;font-weight:500;white-space:nowrap}
.b-rfa{background:rgba(245,200,66,.1);color:var(--ye)}.b-ufa{background:rgba(239,83,80,.1);color:var(--rd)}
.b-sig{background:rgba(67,217,140,.1);color:var(--gr)}.b-f{background:rgba(79,195,247,.08);color:var(--ac)}
.b-d{background:rgba(167,139,250,.08);color:#a78bfa}.b-g{background:rgba(255,138,101,.08);color:var(--or)}
.b-pk{background:rgba(79,195,247,.07);color:var(--ac)}
.sc-ufa{background:rgba(239,83,80,.1);color:var(--rd)}
.sc-rfa{background:rgba(245,200,66,.1);color:var(--ye)}
.sc-sig{background:rgba(67,217,140,.1);color:var(--gr)}
.tgrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:9px}
.tcard{background:var(--bg2);border:1px solid var(--border);border-radius:6px;padding:14px;cursor:pointer;transition:all .15s;position:relative;overflow:hidden}
.tcard::before{content:'';position:absolute;left:0;top:0;bottom:0;width:3px;background:var(--tc,var(--ac))}
.tcard:hover{border-color:var(--border2);background:var(--bg3)}
.tc-name{font-size:15px;font-weight:700;margin-bottom:10px;padding-left:4px}
.tc-row{display:flex;justify-content:space-between;font-size:12px;margin-bottom:3px}
.tc-lbl{color:var(--text3)}.tc-val{font-family:var(--fm);font-size:11px}
.two{display:grid;grid-template-columns:1fr 290px;gap:14px;align-items:start}
.tdh{background:var(--bg2);border:1px solid var(--border);border-radius:6px;padding:16px;margin-bottom:16px;border-left:3px solid var(--tc,var(--ac))}
.tdn{font-size:24px;font-weight:700;letter-spacing:-.5px;margin-bottom:10px}
.tds{display:flex;gap:24px;flex-wrap:wrap;margin-bottom:10px}
.tds-l{font-family:var(--fm);font-size:9px;letter-spacing:1px;text-transform:uppercase;color:var(--text2);margin-bottom:3px}
.tds-v{font-size:18px;font-weight:700}
.pk-list{padding:10px 12px;display:flex;flex-direction:column;gap:4px}
.pk-row{display:flex;justify-content:space-between;align-items:center;padding:6px 9px;border-radius:4px;background:var(--bg3);font-size:12px}
.yr-wrap{width:100%;overflow:hidden}
.yr-track{display:flex;overflow-x:auto;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;scrollbar-width:none}
.yr-track::-webkit-scrollbar{display:none}
.yr-card{flex:0 0 100%;scroll-snap-align:start;padding:14px 16px}
.yr-inner{background:var(--bg3);border:1px solid var(--border);border-radius:8px;padding:16px}
.yr-lbl{font-family:var(--fm);font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:var(--text3);margin-bottom:6px}
.yr-sal{font-size:30px;font-weight:700;color:var(--text);margin-bottom:3px}
.yr-dots{display:flex;gap:5px;justify-content:center;padding:8px 0 2px}
.yr-dot{width:6px;height:6px;border-radius:50%;background:var(--bg5);transition:background .2s}.yr-dot.on{background:var(--ac)}
.yr-hint{text-align:center;font-family:var(--fm);font-size:9px;color:var(--text3);letter-spacing:1px;margin-bottom:8px;text-transform:uppercase}
.cbar{padding:12px 16px}.cbar-track{display:flex;gap:4px;margin-bottom:6px}
.cbar-seg{flex:1;height:8px;border-radius:4px}.cbar-lbls{display:flex;justify-content:space-between;font-family:var(--fm);font-size:9px;color:var(--text3)}
.player-hero{background:var(--bg2);border:1px solid var(--border);border-radius:6px;padding:20px;margin-bottom:16px;position:relative;overflow:hidden}
.p-num-bg{font-family:var(--fm);font-size:80px;font-weight:700;color:rgba(255,255,255,.04);position:absolute;right:12px;bottom:-10px;line-height:1;pointer-events:none}
.p-name{font-size:26px;font-weight:700;letter-spacing:-.5px;margin-bottom:4px}
.p-sub{font-size:13px;color:var(--text3);margin-bottom:16px;display:flex;gap:10px;flex-wrap:wrap;align-items:center}
.p-stats-row{display:grid;grid-template-columns:repeat(auto-fill,minmax(110px,1fr));gap:8px}
.pstat{background:var(--bg3);border:1px solid var(--border);border-radius:5px;padding:10px 12px}
.pstat-l{font-family:var(--fm);font-size:9px;letter-spacing:1px;text-transform:uppercase;color:var(--text3);margin-bottom:3px}
.pstat-v{font-size:18px;font-weight:700}
.tx{padding:10px 14px;border-bottom:1px solid var(--border);display:flex;gap:10px;align-items:flex-start}
.tx:last-child{border-bottom:none}
.tx-dot{width:7px;height:7px;border-radius:50%;margin-top:4px;flex-shrink:0}
.tx-type{font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px}
.tx-detail{font-size:12px;color:var(--text2)}
.tx-date{font-family:var(--fm);font-size:10px;color:var(--text3);white-space:nowrap;flex-shrink:0;text-align:right}
.pdgrid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:16px}
.pcc{background:var(--bg2);border:1px solid var(--border);border-radius:6px;padding:14px}
.pcc-r{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid var(--border);font-size:13px}
.pcc-r:last-child{border-bottom:none}
.pcc-k{color:var(--text3)}.pcc-v{font-family:var(--fm);font-size:12px;font-weight:500;color:var(--text)}
 
/* ── SLOT CARD ── */
.slot{
  background:var(--bg2);border:1.5px solid var(--border);
  border-radius:8px;padding:8px 10px;
  height:76px;display:flex;flex-direction:row;align-items:center;gap:8px;overflow:hidden;
  position:relative;transition:border-color .15s,background .15s,transform .1s,box-shadow .15s;
  user-select:none;-webkit-user-select:none;cursor:pointer;
}
.slot:hover{border-color:var(--border2);background:var(--bg3)}
.slot.drag-over{border-color:var(--ac)!important;background:rgba(79,195,247,.08)!important;box-shadow:0 0 0 2px var(--ac);transform:scale(1.02)}
.slot.is-dragging{opacity:.4;border-style:dashed;border-color:var(--ac);transform:scale(.96)}
.slot.empty-slot{border-style:dashed;opacity:.35;cursor:default}
.slot-pos{font-family:var(--fm);font-size:13px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:var(--text3);margin-bottom:6px;text-align:center}
.slot-num{font-family:var(--fm);font-size:10px;font-weight:600;color:var(--text3);background:var(--bg5);padding:1px 6px;border-radius:3px;margin-bottom:4px}
.slot-name{font-size:11px;font-weight:700;color:var(--text);text-align:center;line-height:1.2;width:100%;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
.slot-meta{display:flex;gap:4px;align-items:center;justify-content:center;margin-top:5px;flex-wrap:wrap}
.slot-sal{font-family:var(--fm);font-size:10px;color:var(--text3)}
.slot-sc{font-family:var(--fm);font-size:9px;font-weight:600;padding:1px 5px;border-radius:3px}
.slot-clause{font-family:var(--fm);font-size:9px;color:var(--ye)}
.slot-hint{position:absolute;bottom:4px;right:6px;font-size:8px;color:var(--text3);font-family:var(--fm);opacity:0;transition:opacity .15s}
.slot-num-bg{color:rgba(255,255,255,.1)}
[data-theme="light"] .slot-num-bg{color:rgba(0,0,0,.08)}
.slot:hover .slot-hint{opacity:1}
 
/* LINE LAYOUT */
.lines-wrap{display:flex;flex-direction:column;gap:8px;padding:14px}
.pos-hdr{font-family:var(--fm);font-size:10px;letter-spacing:2px;text-transform:uppercase;color:var(--text3);margin-bottom:7px;margin-top:6px;display:flex;align-items:center;gap:8px}
.pos-hdr::after{content:'';flex:1;height:1px;background:var(--border)}
.line-row{display:grid;gap:7px;margin-bottom:7px}
.line-row.fwd{grid-template-columns:32px 1fr 1fr 1fr}
.line-row.def{grid-template-columns:32px 1fr 1fr}
.line-row.goal{grid-template-columns:32px 1fr 1fr}
.line-num{display:flex;align-items:center;justify-content:center;font-family:var(--fm);font-size:9px;color:var(--text3);writing-mode:vertical-rl;transform:rotate(180deg);letter-spacing:1px;white-space:nowrap}
 
/* BENCH */
.bench-wrap{margin:0 14px 14px;background:var(--bg3);border:1px solid var(--border);border-radius:7px;overflow:hidden}
.bench-hdr{padding:7px 12px;font-family:var(--fm);font-size:9px;letter-spacing:1.5px;text-transform:uppercase;color:var(--text3);border-bottom:1px solid var(--border)}
.bench-grid{display:flex;flex-wrap:wrap;gap:5px;padding:10px}
.bench-chip{display:flex;align-items:center;gap:5px;padding:5px 10px;border-radius:5px;background:var(--bg4);border:1.5px solid var(--border);cursor:grab;transition:all .15s;font-size:12px}
.bench-chip:hover{border-color:var(--border2);background:var(--bg5)}
.bench-chip.is-dragging{opacity:.4;cursor:grabbing}
.bench-num{font-family:var(--fm);font-size:10px;color:var(--text3)}
 
/* PLAYER POPUP */
.pop-overlay{position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:300;display:flex;align-items:center;justify-content:center;padding:16px;backdrop-filter:blur(6px)}
.pop{background:var(--bg2);border:1px solid var(--border2);border-radius:10px;padding:20px;width:100%;max-width:340px;position:relative}
.pop-close{position:absolute;top:10px;right:10px;font-size:16px;color:var(--text3);width:26px;height:26px;display:flex;align-items:center;justify-content:center;border-radius:4px;transition:background .1s}
.pop-close:hover{background:var(--bg4);color:var(--text)}
.pop-num-bg{font-family:var(--fm);font-size:60px;font-weight:700;color:rgba(255,255,255,.04);position:absolute;right:14px;top:8px;line-height:1;pointer-events:none}
.pop-pos{font-family:var(--fm);font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:var(--text3);margin-bottom:4px}
.pop-name{font-size:20px;font-weight:700;letter-spacing:-.3px;margin-bottom:14px}
.pop-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:14px}
.pop-stat{background:var(--bg3);border:1px solid var(--border);border-radius:6px;padding:9px 11px}
.pop-stat-l{font-family:var(--fm);font-size:9px;letter-spacing:1px;text-transform:uppercase;color:var(--text3);margin-bottom:3px}
.pop-stat-v{font-size:16px;font-weight:700}
.pop-btns{display:flex;gap:8px}
.pop-btn-profile{flex:1;padding:9px;border-radius:6px;background:rgba(79,195,247,.08);color:var(--ac);border:1px solid rgba(79,195,247,.2);font-size:13px;font-weight:600;transition:background .12s}
.pop-btn-profile:hover{background:rgba(79,195,247,.16)}
.pop-btn-close{padding:9px 14px;border-radius:6px;background:var(--bg3);color:var(--text3);border:1px solid var(--border);font-size:13px;transition:background .12s}
.pop-btn-close:hover{background:var(--bg4)}
 
/* DRAG GHOST */
.drag-ghost{position:fixed;pointer-events:none;z-index:500;background:var(--bg2);border:2px solid var(--ac);border-radius:8px;padding:7px 12px;font-size:12px;font-weight:600;color:var(--text);box-shadow:0 8px 24px rgba(0,0,0,.5);white-space:nowrap;opacity:.9;transform:rotate(2deg);font-family:var(--ff)}
 
/* TABS */
.tab-group{display:flex;gap:2px;background:var(--bg4);padding:3px;border-radius:5px}
.tab-btn{padding:5px 14px;border-radius:4px;font-size:12px;font-weight:500;color:var(--text3);transition:all .12s;white-space:nowrap}
.tab-btn.on{background:var(--bg2);color:var(--text);box-shadow:0 1px 3px rgba(0,0,0,.4)}
 
/* STATS */
.stats-toolbar{padding:10px 14px;background:var(--bg3);border-bottom:1px solid var(--border);display:flex;gap:8px;align-items:center;flex-wrap:wrap}
.yr-sel{background:var(--bg4);border:1px solid var(--border2);border-radius:4px;padding:5px 9px;font-size:12px;color:var(--text2);outline:none;margin-left:auto}
.stat-note-row{padding:8px 14px;background:var(--bg3);border-bottom:1px solid var(--border);font-size:11px;color:var(--text3);font-family:var(--fm);display:flex;align-items:center;gap:6px;flex-wrap:wrap}
.adv-pill{display:inline-flex;align-items:center;padding:1px 7px;border-radius:3px;font-family:var(--fm);font-size:10px;font-weight:500}
.adv-hi{background:rgba(67,217,140,.1);color:var(--gr)}.adv-md{background:rgba(245,200,66,.1);color:var(--ye)}.adv-lo{background:rgba(239,83,80,.1);color:var(--rd)}
 
/* PLAYER STATS TABLE — fixed widths for alignment */
.pstats-tbl{white-space:nowrap}
.pstats-tbl th,.pstats-tbl td{text-align:center;padding:8px 6px}
.pstats-tbl th:first-child,.pstats-tbl td:first-child{text-align:left;min-width:80px}
.pstats-tbl .season-col{width:80px;text-align:left!important}
.pstats-tbl .team-col{width:60px;text-align:center!important}
.pstats-tbl .stat-col{width:52px}
.pstats-tbl .stat-col-wide{width:58px}
.pstats-season{font-family:var(--fm);font-size:11px;color:var(--ac);font-weight:600}
.pstats-team-badge{font-family:var(--fm);font-size:10px;padding:1px 5px;border-radius:3px;background:var(--bg4)}
.pstats-playoff{color:var(--ye)!important;font-style:italic}
.pstats-career td{border-top:2px solid var(--border2)!important;font-weight:600!important;color:var(--text)!important}
.pstats-section-hdr{padding:7px 14px;border-top:1px solid var(--border);background:var(--bg3);font-size:9px;font-family:var(--fm);color:var(--text3);letter-spacing:1.5px;text-transform:uppercase}
 
/* TRADE */
.trlayout{display:grid;grid-template-columns:1fr 44px 1fr;gap:0;align-items:start}
.trpanel{background:var(--bg2);border:1px solid var(--border);border-radius:6px;overflow:hidden}
.trph{padding:10px 13px;background:var(--bg3);border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between}
.trsel{width:100%;background:var(--bg4);border:1px solid var(--border2);border-radius:4px;padding:7px 9px;font-size:13px;color:var(--text);outline:none;margin:9px 0}
.trsec{font-family:var(--fm);font-size:9px;letter-spacing:1.5px;text-transform:uppercase;color:var(--text3);padding:7px 13px 3px}
.trpr{display:flex;align-items:center;justify-content:space-between;padding:7px 13px;cursor:pointer;transition:background .1s;border-bottom:1px solid var(--border)}
.trpr:last-child{border-bottom:none}.trpr:hover{background:var(--bg3)}.trpr.on{background:rgba(79,195,247,.06);border-left:2px solid var(--ac)}
.trpn{font-size:12px;font-weight:500}.trpi{font-size:10px;color:var(--text3);margin-top:1px}.trps{font-family:var(--fm);font-size:11px;color:var(--text2)}
.trarr{display:flex;align-items:center;justify-content:center;padding-top:72px;color:var(--text3);font-size:18px}
.trresult{background:var(--bg2);border:1px solid var(--border);border-radius:6px;padding:15px;margin-top:14px}
.trr{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid var(--border);font-size:13px}
.trr:last-child{border-bottom:none}.trl{color:var(--text3)}.trv{font-family:var(--fm);font-size:12px}
.verdict{margin-top:11px;padding:9px 13px;border-radius:4px;font-family:var(--fm);font-size:11px;text-align:center}
.v-ok{background:rgba(67,217,140,.08);color:var(--gr);border:1px solid rgba(67,217,140,.2)}.v-bad{background:rgba(239,83,80,.08);color:var(--rd);border:1px solid rgba(239,83,80,.2)}
 
/* ARMCHAIR */
.agm-layout{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.agm-sum{background:var(--bg2);border:1px solid var(--border);border-radius:6px;padding:14px;margin-bottom:12px}
.agm-num{font-size:28px;font-weight:700;margin:4px 0}
.agm-row{display:flex;align-items:center;gap:9px;padding:8px 13px;border-bottom:1px solid var(--border)}
.agm-row:last-child{border-bottom:none}
.agm-fa{display:flex;align-items:center;justify-content:space-between;padding:7px 13px;border-bottom:1px solid var(--border);font-size:12px;transition:background .1s}
.agm-fa:last-child{border-bottom:none}.agm-fa:hover{background:var(--bg3);cursor:pointer}
.agm-add{font-size:10px;padding:3px 7px;border-radius:3px;font-weight:600;background:rgba(79,195,247,.08);color:var(--ac);border:1px solid rgba(79,195,247,.2)}
.agm-add:disabled{opacity:.3;cursor:not-allowed}
 
/* CBA */
.cba-item{border:1px solid var(--border);border-radius:5px;overflow:hidden;margin-bottom:7px}
.cba-q{padding:11px 14px;display:flex;justify-content:space-between;align-items:center;cursor:pointer;font-size:13px;font-weight:500;background:var(--bg2);transition:background .12s}
.cba-q:hover{background:var(--bg3)}.cba-chev{font-size:11px;color:var(--text3);transition:transform .18s}.cba-chev.op{transform:rotate(180deg)}
.cba-a{padding:11px 14px;font-size:13px;color:var(--text2);line-height:1.7;background:var(--bg3);border-top:1px solid var(--border)}
 
.alert{padding:8px 11px;border-radius:4px;font-size:12px;margin-top:10px}
.alert-ok{background:rgba(67,217,140,.07);color:var(--gr);border:1px solid rgba(67,217,140,.18)}
.alert-bad{background:rgba(239,83,80,.07);color:var(--rd);border:1px solid rgba(239,83,80,.18)}
.back{display:inline-flex;align-items:center;gap:5px;font-size:12px;color:var(--text3);margin-bottom:14px;padding:3px 0;transition:color .12s}
.back:hover{color:var(--ac)}
.foot{border-top:1px solid var(--border);padding:16px;text-align:center;font-family:var(--fm);font-size:11px;color:var(--text3)}
.foot a{color:var(--ac)}
@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
/* PLAYER PHOTO */
.player-photo-wrap{position:absolute;right:16px;top:12px;width:130px;height:130px;border-radius:50%;overflow:hidden;border:2px solid var(--border2);background:var(--bg4);pointer-events:none;flex-shrink:0}
.player-photo-img{width:100%;height:100%;object-fit:cover;object-position:top center}
/* CONTRACT BAR */
.cbar-wrap{padding:14px 16px}
.cbar-track{display:flex;gap:4px;margin-bottom:8px}
.cbar-seg{flex:1;height:28px;border-radius:4px;display:flex;align-items:center;justify-content:center;font-family:var(--fm);font-size:10px;font-weight:600;letter-spacing:.5px;transition:all .15s;position:relative;overflow:hidden}
.cbar-seg.current{background:var(--ac);color:#0d1117;box-shadow:0 0 12px rgba(79,195,247,.3)}
.cbar-seg.future{background:rgba(79,195,247,.15);color:var(--ac);border:1px solid rgba(79,195,247,.2)}
.cbar-seg.past{background:var(--bg5);color:var(--text3)}
.cbar-labels{display:flex;gap:4px}
.cbar-lbl{flex:1;text-align:center;font-family:var(--fm);font-size:9px;color:var(--text3)}
.cbar-sal{text-align:center;font-family:var(--fm);font-size:11px;color:var(--text2);margin-top:6px}
/* NEXT GAME */
.next-game{display:flex;flex-direction:column;align-items:center;gap:6px;padding:18px 32px;background:var(--bg3);border:1px solid var(--border);border-radius:10px;min-width:220px;text-align:center}
.ng-status{font-family:var(--fm);font-size:11px;letter-spacing:1.5px;text-transform:uppercase;font-weight:700}
.ng-live{color:#ef5350;animation:pulse 1.5s infinite}
.ng-matchup{display:flex;align-items:center;gap:10px;font-size:18px;font-weight:700;color:var(--text)}
.ng-score{display:flex;align-items:center;justify-content:center;gap:0}
.ng-period{font-family:var(--fm);font-size:12px;color:var(--text3)}
.ng-date{font-family:var(--fm);font-size:15px;color:var(--text2);font-weight:500}
.ng-time{font-family:var(--fm);font-size:13px;color:var(--text3)}
.ng-venue{font-family:var(--fm);font-size:10px;color:var(--text3);margin-top:2px}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
/* COACH */
.coach-badge{display:inline-flex;align-items:center;gap:5px;background:var(--bg4);border:1px solid var(--border);border-radius:4px;padding:3px 9px;font-size:11px}
.coach-lbl{color:var(--text2);font-family:var(--fm);font-size:9px;letter-spacing:1px;text-transform:uppercase}
 
@keyframes fu{from{opacity:0;transform:translateY(7px)}to{opacity:1;transform:none}}
.fu{animation:fu .22s ease}
@keyframes pop-in{from{opacity:0;transform:scale(.94)}to{opacity:1;transform:scale(1)}}
.pop{animation:pop-in .15s ease}
@media(max-width:900px){.two,.trlayout,.pdgrid,.agm-layout{grid-template-columns:1fr}.trarr{display:none}.sstrip{grid-template-columns:repeat(3,1fr)}}
@media(max-width:540px){.sstrip{grid-template-columns:repeat(2,1fr)}.tgrid{grid-template-columns:1fr 1fr}.line-row.fwd{grid-template-columns:1fr 1fr 1fr!important}.line-row.def{grid-template-columns:1fr 1fr!important}.line-row.goal{grid-template-columns:1fr 1fr!important}.line-num{display:none!important}.slot{height:72px;padding:6px 8px;gap:6px}}
@media(max-width:380px){.tgrid{grid-template-columns:1fr}}
/* THEME TOGGLE */
.theme-toggle{display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:6px;background:var(--bg4);border:1px solid var(--border);cursor:pointer;flex-shrink:0;align-self:center;margin-left:6px;font-size:14px;transition:background .15s}
.theme-toggle:hover{background:var(--bg5)}
/* HAMBURGER MENU */
.ham{display:none;flex-direction:column;gap:4px;padding:8px;cursor:pointer;align-self:center;flex-shrink:0}
.ham span{width:18px;height:2px;background:var(--text2);border-radius:1px;transition:all .2s}
.mob-nav{display:none;position:fixed;top:46px;left:0;right:0;bottom:0;background:var(--bg);z-index:99;padding:20px;flex-direction:column;gap:4px;overflow-y:auto}
.mob-nav.open{display:flex}
.mob-nav button{padding:14px 16px;text-align:left;font-size:15px;font-weight:500;color:var(--text2);border-bottom:1px solid var(--border);transition:color .12s}
.mob-nav button:hover,.mob-nav button.on{color:var(--ac)}
@media(max-width:640px){
  .nav-desk{display:none!important}
  .ham{display:flex}
  .stag{display:none}
}
@media(min-width:641px){.mob-nav{display:none!important}}
/* CONTRAST FIXES */
.b-rfa{background:rgba(245,200,66,.12);color:var(--ye)}.b-ufa{background:rgba(239,83,80,.12);color:var(--rd)}
.b-sig{background:rgba(67,217,140,.12);color:var(--gr)}
.sc-ufa{background:rgba(239,83,80,.12);color:var(--rd)}
.sc-rfa{background:rgba(245,200,66,.12);color:var(--ye)}
.sc-sig{background:rgba(67,217,140,.12);color:var(--gr)}
[data-theme="light"] .b-rfa{background:rgba(161,98,7,.12);color:#854d0e}
[data-theme="light"] .b-ufa{background:rgba(185,28,28,.1);color:#991b1b}
[data-theme="light"] .b-sig{background:rgba(21,128,61,.1);color:#166534}
[data-theme="light"] .b-f{background:rgba(3,105,161,.1);color:#075985}
[data-theme="light"] .b-d{background:rgba(109,40,217,.1);color:#5b21b6}
[data-theme="light"] .b-g{background:rgba(194,65,12,.1);color:#9a3412}
[data-theme="light"] .sc-ufa{background:rgba(185,28,28,.1);color:#991b1b}
[data-theme="light"] .sc-rfa{background:rgba(161,98,7,.12);color:#854d0e}
[data-theme="light"] .sc-sig{background:rgba(21,128,61,.1);color:#166534}
[data-theme="light"] .pstats-season{color:#075985}
[data-theme="light"] .pstats-playoff{color:#854d0e!important}
[data-theme="light"] .player-hero{border-color:var(--border2)}
[data-theme="light"] .cbar-seg.current{color:#fff}
[data-theme="light"] .p-num-bg{color:rgba(0,0,0,.06)}
[data-theme="light"] .pop-num-bg{color:rgba(0,0,0,.06)}
`;
 
// ─── SHARED COMPONENTS ────────────────────────────────────────────────────────
function CapBar({spent,cap,h=4}){
  const p=Math.min(Math.round(spent/cap*100),100);
  const c=p>=98?"var(--rd)":p>=88?"var(--ye)":"var(--gr)";
  return <div className="cb" style={{height:h}}><div className="cbi" style={{width:p+"%",background:c,height:"100%"}}/></div>;
}
function Badge({type}){
  const m={UFA:"b-ufa",RFA:"b-rfa",Signed:"b-sig",F:"b-f",D:"b-d",G:"b-g",Pick:"b-pk"};
  return <span className={`bx ${m[type]||""}`}>{type}</span>;
}

function InjuryBadge({player}){
  if(!player.injuryStatus) return null;
  const colors = {LTIR:'#ef5350',IR:'#ff9800',DTD:'#ffc107'};
  const color = colors[player.injuryStatus]||'#ef5350';
  const dateStr = player.injuryDate ? new Date(player.injuryDate).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}) : '';
  const [show,setShow]=useState(false);
  const [pos,setPos]=useState({x:0,y:0});
  const ref=useRef(null);
  const handleEnter=()=>{
    if(ref.current){
      const r=ref.current.getBoundingClientRect();
      setPos({x:r.left+r.width/2, y:r.top});
    }
    setShow(true);
  };
  return(
    <span style={{display:'inline-flex',alignItems:'center',marginLeft:6,verticalAlign:'middle'}}>
      <span ref={ref} onMouseEnter={handleEnter} onMouseLeave={()=>setShow(false)} onClick={e=>e.stopPropagation()}
        style={{display:'inline-flex',alignItems:'center',justifyContent:'center',width:18,height:18,borderRadius:'50%',border:`2px solid ${color}`,fontSize:12,fontWeight:800,cursor:'help',fontFamily:'var(--fm)',lineHeight:1,background:'rgba(239,83,80,.1)',color}}>+</span>
      {show&&ReactDOM.createPortal(
        <div style={{position:'fixed',left:pos.x,top:pos.y-10,transform:'translate(-50%,-100%)',background:'#151823',border:`2px solid ${color}`,borderRadius:10,padding:'14px 18px',fontSize:14,fontFamily:'var(--fm)',color:'#f1f5f9',whiteSpace:'nowrap',zIndex:99999,boxShadow:'0 8px 30px rgba(0,0,0,.7)',lineHeight:1.6,pointerEvents:'none'}}>
          <div style={{fontWeight:700,color,fontSize:16,marginBottom:4}}>{player.injuryStatus}</div>
          {player.injuryNote&&<div style={{fontSize:14,color:'#e2e8f0'}}>{player.injuryNote}</div>}
          {dateStr&&<div style={{fontSize:12,color:'#94a3b8',marginTop:4}}>Since {dateStr}</div>}
          <div style={{position:'absolute',top:'100%',left:'50%',transform:'translateX(-50%)',width:0,height:0,borderLeft:'8px solid transparent',borderRight:'8px solid transparent',borderTop:`8px solid ${color}`}}/>
        </div>,
        document.body
      )}
    </span>
  );
}

// ─── NEXT GAME / LIVE SCORE (FIXED — always polls) ─────────────────────────
const HT_TEAM_MAP = {bos:'1',min:'2',mtl:'3',ny:'4',ott:'5',tor:'6',sea:'8',van:'9'};
function NextGame({teamId}){
  const [game,setGame]=useState(null);
  const [standing,setStanding]=useState(null);
  const [loading,setLoading]=useState(true);
  const [showBox,setShowBox]=useState(false);
  const htId = HT_TEAM_MAP[teamId];
  const intervalRef = useRef(null);

  useEffect(()=>{
    const fetchGame = async ()=>{
      try{
        const url=`/api/scorebar`;
        const res=await fetch(url);
        const data=await res.json();
        const games=data?.SiteKit?.Scorebar||[];
        
        console.log(`[NextGame:${teamId}] fetched ${games.length} games, looking for htId=${htId}`);

        // Build standings from real standings API
        try{
          const stRes=await fetch('/api/standings');
          const stData=await stRes.json();
          const stTeams=stData?.teams||[];
          const HT_MAP={'1':'bos','2':'min','3':'mtl','4':'ny','5':'ott','6':'tor','8':'sea','9':'van'};
          const myTeam=stTeams.find(t=>String(t.team_id)===String(htId));
          if(myTeam){
            const rank=parseInt(myTeam.rank)||0;
            const w=parseInt(myTeam.wins)||0;
            const otw=(parseInt(myTeam.ot_wins)||0)+(parseInt(myTeam.shootout_wins)||0);
            const l=parseInt(myTeam.losses)||0;
            const otl=(parseInt(myTeam.ot_losses)||0)+(parseInt(myTeam.shootout_losses)||0);
            const regW=w-otw;
            const pts=parseInt(myTeam.points)||(regW*3+otw*2+otl);
            setStanding({rank,pts,w:regW,otw,l,otl,total:stTeams.length,clinched:myTeam.clinched||''});
          }
        }catch(e){ console.error('[NextGame] standings fetch error:',e); }

        // Find next/live game for this team
        const now=new Date();
        let found=null;
        for(const g of games){
          const isHome = String(g.HomeID) === String(htId);
          const isAway = String(g.VisitorID) === String(htId);
          if(!isHome && !isAway) continue;

          const status    = String(g.GameStatus||'');
          const statusStr = String(g.GameStatusString||'');
          const statusLong= String(g.GameStatusStringLong||'');
          const homeGoals = parseInt(g.HomeGoals)||0;
          const awayGoals = parseInt(g.VisitorGoals)||0;
          const hasGoals  = homeGoals > 0 || awayGoals > 0;

          console.log(`[NextGame:${teamId}] game:`, {
            id: g.ID || g.GameID, home: g.HomeCode, away: g.VisitorCode,
            status, statusStr, statusLong, homeGoals, awayGoals,
            GameClock: g.GameClock, Period: g.PeriodNameLong || g.PeriodNameShort,
          });

          // Detect live — broad matching for HockeyTech's various status formats
          const isLive = status==='2' || status==='3'
            || statusStr.toLowerCase().includes('progress')
            || statusStr.toLowerCase().includes('live')
            || statusLong.toLowerCase().includes('period')
            || statusLong.toLowerCase().includes('overtime')
            || statusLong.toLowerCase().includes('intermission')
            // Fallback: not scheduled, not final, but goals exist → probably live
            || (status !== '1' && status !== '4' && hasGoals && !statusStr.toLowerCase().includes('final'));

          // Detect final
          const isFinal = status==='4'
            || statusStr.toLowerCase().includes('final');

          const gameDate=new Date(g.GameDateISO8601||g.Date);
          const isToday=gameDate.toDateString()===now.toDateString();
          const isFuture = status==='1' || (!isLive && !isFinal && gameDate > now);

          console.log(`[NextGame:${teamId}] → isLive=${isLive} isFinal=${isFinal} isFuture=${isFuture}`);
          
          // Priority: live > today's final > next upcoming
          if(isLive){
            found={...g,isHome,isLive:true,isFinal:false};
            break;
          }
          if(isFinal && isToday && !found){
            found={...g,isHome,isLive:false,isFinal:true};
          }
          if(isFuture && !found){
            found={...g,isHome,isLive:false,isFinal:false};
          }
        }

        console.log(`[NextGame:${teamId}] selected:`, found ? {isLive:found.isLive,isFinal:found.isFinal,home:found.HomeCode,away:found.VisitorCode} : 'none');

        setGame(found);
        setLoading(false);
      }catch(e){
        console.error('[NextGame] fetch error:',e);
        setLoading(false);
      }
    };

    fetchGame();

    // Always poll every 60s — catches scheduled → live → final transitions
    intervalRef.current = setInterval(fetchGame, 60000);

    return ()=>{
      if(intervalRef.current){ clearInterval(intervalRef.current); intervalRef.current=null; }
    };
  },[htId]);

  if(loading || (!game && !standing)) return null;

  const opp = game ? (game.isHome ? game.VisitorCode : game.HomeCode) : '';
  const oppLong = game ? (game.isHome ? game.VisitorNickname : game.HomeNickname) : '';
  const oppTeam = TEAMS.find(t=>t.abbr===opp||t.abbr===opp+'S'||t.id===(opp||'').toLowerCase()) || {abbr:opp,name:oppLong||opp};
  const homeScore = game ? parseInt(game.HomeGoals)||0 : 0;
  const awayScore = game ? parseInt(game.VisitorGoals)||0 : 0;
  const teamScore = game?.isHome ? homeScore : awayScore;
  const oppScore = game?.isHome ? awayScore : homeScore;
  const isWinning = teamScore > oppScore;
  const isLosing = teamScore < oppScore;

  const dateStr = game?.GameDate || '';
  const timeStr = game?.GameStatusStringLong || game?.ScheduledFormattedTime || '';
  const periodStr = game?.PeriodNameLong || game?.PeriodNameShort || '';

  const OppLogo = () => oppTeam.logo
    ? <img src={oppTeam.logo} alt="" style={{width:28,height:28,objectFit:"contain"}}/>
    : null;

  const gameId = game?.ID || game?.GameID || game?.game_id;
  const isClickable = game && (game.isLive || game.isFinal) && gameId;

  return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6}}>
      {game&&<div className="next-game" onClick={()=>{if(isClickable)setShowBox(true);}} style={{cursor:isClickable?"pointer":"default",transition:"transform .1s"}} onMouseEnter={e=>{if(isClickable)e.currentTarget.style.transform="scale(1.02)";}} onMouseLeave={e=>{e.currentTarget.style.transform="scale(1)";}}>
        {game.isLive ? (
          <>
            <div className="ng-status ng-live">● LIVE</div>
            <div className="ng-matchup">
              <span>{game.isHome?'vs':'@'}</span>
              <OppLogo/>
              <span>{oppTeam.abbr||opp}</span>
            </div>
            <div className="ng-score">
              <span style={{color:isWinning?"var(--gr)":isLosing?"var(--rd)":"var(--text)",fontWeight:700,fontSize:28}}>{teamScore}</span>
              <span style={{color:"var(--text3)",margin:"0 6px",fontSize:20}}>–</span>
              <span style={{color:isLosing?"var(--gr)":isWinning?"var(--rd)":"var(--text)",fontWeight:700,fontSize:28}}>{oppScore}</span>
            </div>
            <div className="ng-period">{(!game.GameClock||game.GameClock==='00:00'||game.GameClock==='0:00')?`End of ${periodStr}`:(`${periodStr} · ${game.GameClock}`)}</div>
            <div style={{fontSize:9,color:"var(--ac)",fontFamily:"var(--fm)",marginTop:2}}>TAP FOR BOX SCORE</div>
          </>
        ) : game.isFinal ? (
          <>
            <div className="ng-status" style={{color:"var(--text3)"}}>FINAL</div>
            <div className="ng-matchup">
              <span>{game.isHome?'vs':'@'}</span>
              <OppLogo/>
              <span>{oppTeam.abbr||opp}</span>
            </div>
            <div className="ng-score">
              <span style={{color:isWinning?"var(--gr)":"var(--rd)",fontWeight:700,fontSize:28}}>{teamScore}</span>
              <span style={{color:"var(--text3)",margin:"0 6px",fontSize:20}}>–</span>
              <span style={{fontWeight:700,fontSize:28}}>{oppScore}</span>
            </div>
            <div className="ng-period">{teamScore>oppScore?"W":"L"}</div>
            <div style={{fontSize:9,color:"var(--ac)",fontFamily:"var(--fm)",marginTop:2}}>TAP FOR BOX SCORE</div>
          </>
        ) : (
          <>
            <div className="ng-status" style={{color:"var(--text3)"}}>NEXT GAME</div>
            <div className="ng-matchup">
              <span>{game.isHome?'vs':'@'}</span>
              <OppLogo/>
              <span>{oppTeam.abbr||opp}</span>
            </div>
            <div className="ng-date">{dateStr}</div>
            <div className="ng-time">{timeStr}</div>
            {game.Venue&&<div className="ng-venue">{game.Venue}</div>}
          </>
        )}
      </div>}
      {showBox&&gameId&&<GameBoxScore gameId={gameId} game={game} onClose={()=>setShowBox(false)} isLive={game.isLive}/>}
      {standing&&(
        <div style={{display:"flex",gap:12,alignItems:"center",fontFamily:"var(--fm)",fontSize:14}}>
          <span style={{color:"var(--ac)",fontWeight:700,fontSize:16}}>#{standing.rank}<span style={{color:"var(--text3)",fontWeight:500}}>/{standing.total}</span></span>
          {standing.clinched==='x'&&<span style={{color:"var(--gr)",fontSize:10,fontWeight:600}}>CLINCHED</span>}
          {standing.clinched==='e'&&<span style={{color:"var(--rd)",fontSize:10,fontWeight:600}}>ELIMINATED</span>}
          <span style={{color:"var(--text)",fontWeight:700}}>{standing.pts} pts</span>
          <span style={{color:"var(--text2)",fontWeight:600}}>{standing.w}-{standing.otw}-{standing.l}-{standing.otl}</span>
        </div>
      )}
    </div>
  );
}

// ─── GAME BOX SCORE MODAL ─────────────────────────────────────────────────
function GameBoxScore({gameId,game,onClose,isLive}){
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState(null);
  const [tab,setTab]=useState("summary");
  const [skSort,setSkSort]=useState({away:{col:"toi",dir:-1},home:{col:"toi",dir:-1}});
  const intervalRef=useRef(null);

  const fetchData=async()=>{
    try{
      const res=await fetch(`/api/game-summary?id=${gameId}`);
      const json=await res.json();
      setData(json);
      setLoading(false);
    }catch(e){ setError(e.message); setLoading(false); }
  };

  useEffect(()=>{
    fetchData();
    if(isLive){ intervalRef.current=setInterval(fetchData,20000); }
    return()=>{if(intervalRef.current)clearInterval(intervalRef.current);};
  },[gameId,isLive]);

  if(!data&&loading) return ReactDOM.createPortal(
    <div className="pop-overlay" onClick={onClose} style={{zIndex:400}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"var(--bg2)",borderRadius:10,padding:40,textAlign:"center"}}>
        <div style={{width:24,height:24,border:"3px solid var(--border2)",borderTop:"3px solid var(--ac)",borderRadius:"50%",animation:"spin 0.8s linear infinite",margin:"0 auto 12px"}}/>
        <div style={{fontFamily:"var(--fm)",fontSize:11,color:"var(--text3)"}}>Loading box score...</div>
      </div>
    </div>, document.body);

  const details=data?.details||{};
  const home=data?.homeTeam||{};
  const away=data?.visitingTeam||{};
  const periods=data?.periods||[];
  const hInfo=home.info||{};
  const aInfo=away.info||{};
  const hStats=home.stats||{};
  const aStats=away.stats||{};
  const hSkaters=home.skaters||[];
  const aSkaters=away.skaters||[];
  const hGoalies=home.goalies||[];
  const aGoalies=away.goalies||[];
  const hLogo=TEAMS.find(t=>t.abbr===hInfo.abbreviation||t.id===(hInfo.abbreviation||'').toLowerCase())?.logo;
  const aLogo=TEAMS.find(t=>t.abbr===aInfo.abbreviation||t.id===(aInfo.abbreviation||'').toLowerCase())?.logo;
  const hGoals=parseInt(hStats.goals)||0;
  const aGoals=parseInt(aStats.goals)||0;
  let statusText=details.status||game?.GameStatusStringLong||'';
  // Clean up "In Progress (0:00 remaining in 1st)" → "End of 1st"
  if(statusText.includes('0:00 remaining')){
    const m=statusText.match(/remaining in (.+?)[\)]/);
    if(m) statusText=`End of ${m[1]}`;
    else statusText=statusText.replace(/In Progress \(0:00 remaining/,'End of period');
  }
  const isFinal=details.final==='1'||statusText.toLowerCase().includes('final');
  const isInProgress=details.started==='1'&&!isFinal;

  // Collect all goals from all periods
  const allGoals=[];
  periods.forEach(p=>{
    (p.goals||[]).forEach(g=>allGoals.push({...g,period:p.info?.longName||p.info?.shortName||''}));
  });
  const allPenalties=[];
  periods.forEach(p=>{
    (p.penalties||[]).forEach(pen=>allPenalties.push({...pen,period:p.info?.longName||p.info?.shortName||''}));
  });

  // Parse TOI "MM:SS" to seconds for sorting
  const toiToSec=(t)=>{if(!t)return 0;const p=(t||'').split(':');return(parseInt(p[0])||0)*60+(parseInt(p[1])||0);};
  const skCols=[
    {key:"jerseyNumber",label:"#",w:30,align:"center",getter:s=>parseInt(s.info?.jerseyNumber)||0},
    {key:"name",label:"Player",w:null,align:"left",getter:s=>`${s.info?.lastName||''}, ${s.info?.firstName||''}`},
    {key:"pos",label:"Pos",w:34,align:"center",getter:s=>s.info?.position||''},
    {key:"g",label:"G",w:30,align:"center",getter:s=>parseInt(s.stats?.goals)||0},
    {key:"a",label:"A",w:30,align:"center",getter:s=>parseInt(s.stats?.assists)||0},
    {key:"pts",label:"P",w:30,align:"center",getter:s=>(parseInt(s.stats?.goals)||0)+(parseInt(s.stats?.assists)||0)},
    {key:"pm",label:"+/-",w:32,align:"center",getter:s=>parseInt(s.stats?.plusMinus)||0},
    {key:"sog",label:"SOG",w:34,align:"center",getter:s=>parseInt(s.stats?.shots)||0},
    {key:"hit",label:"HIT",w:32,align:"center",getter:s=>parseInt(s.stats?.hits)||0},
    {key:"blk",label:"BLK",w:32,align:"center",getter:s=>parseInt(s.stats?.blockedShots)||0},
    {key:"pim",label:"PIM",w:32,align:"center",getter:s=>parseInt(s.stats?.penaltyMinutes)||0},
    {key:"toi",label:"TOI",w:44,align:"center",getter:s=>toiToSec(s.stats?.toi)},
    {key:"fo",label:"FO",w:38,align:"center",getter:s=>parseInt(s.stats?.faceoffWins)||0},
  ];
  const sortSkaters=(list,side)=>{
    const sort=skSort[side]||{col:"toi",dir:-1};
    return [...list].sort((a,b)=>{
      const col=skCols.find(c=>c.key===sort.col);
      const av=col?.getter(a); const bv=col?.getter(b);
      if(typeof av==='string'&&typeof bv==='string') return sort.dir*av.localeCompare(bv);
      return sort.dir*((parseFloat(av)||0)-(parseFloat(bv)||0));
    });
  };
  const SkTh=({col,side})=>{
    const c=skCols.find(x=>x.key===col);
    const sort=skSort[side]||{col:"toi",dir:-1};
    const active=sort.col===col;
    return(
      <th onClick={()=>setSkSort(prev=>({...prev,[side]:prev[side]?.col===col?{col,dir:-prev[side].dir}:{col,dir:-1}}))}
        style={{padding:"8px 4px",fontSize:10,fontFamily:"var(--fm)",color:active?"var(--ac)":"var(--text3)",textAlign:c.align,width:c.w||undefined,cursor:"pointer",userSelect:"none",whiteSpace:"nowrap",borderBottom:"2px solid "+(active?"var(--ac)":"var(--border2)"),background:"var(--bg3)",position:"sticky",top:0}}>
        {c.label}{active?(sort.dir===-1?" ↓":" ↑"):""}
      </th>
    );
  };
  const SkaterRow=({s,idx})=>{
    const i=s.info||{};
    const st=s.stats||{};
    const g=parseInt(st.goals)||0, a=parseInt(st.assists)||0, pts=g+a;
    const pm=parseInt(st.plusMinus)||0;
    const hasPoints=pts>0;
    const stripe=idx%2===0?"transparent":"rgba(255,255,255,.02)";
    return(
      <tr style={{borderBottom:"1px solid var(--border)",background:hasPoints?"rgba(79,195,247,.05)":stripe}}>
        <td style={{padding:"7px 4px",fontFamily:"var(--fm)",fontSize:12,color:"var(--text3)",textAlign:"center",width:30}}>{i.jerseyNumber}</td>
        <td style={{padding:"7px 6px",fontSize:13,fontWeight:hasPoints?700:400,color:hasPoints?"var(--ac)":"var(--text)",whiteSpace:"nowrap"}}>{i.firstName} {i.lastName}{s.starting===1?<span style={{fontSize:9,color:"var(--ye)",marginLeft:4}}>★</span>:null}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:11,color:"var(--text2)",width:34}}>{i.position}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:13,color:g>0?"var(--gr)":"var(--text3)",fontWeight:g>0?700:400,width:30}}>{g}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:13,color:a>0?"var(--ac)":"var(--text3)",fontWeight:a>0?600:400,width:30}}>{a}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:13,fontWeight:700,color:pts>0?"var(--text)":"var(--text3)",width:30}}>{pts}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:pm>0?"var(--gr)":pm<0?"var(--rd)":"var(--text3)",width:32}}>{pm>0?"+":""}{pm}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:parseInt(st.shots||0)>0?"var(--text2)":"var(--text3)",width:34}}>{st.shots||0}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:parseInt(st.hits||0)>0?"var(--text2)":"var(--text3)",width:32}}>{st.hits||0}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:parseInt(st.blockedShots||0)>0?"var(--text2)":"var(--text3)",width:32}}>{st.blockedShots||0}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:parseInt(st.penaltyMinutes||0)>0?"var(--ye)":"var(--text3)",width:32}}>{st.penaltyMinutes||0}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:"var(--text)",fontWeight:500,width:44}}>{st.toi||''}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:11,color:"var(--text3)",width:38}}>{st.faceoffWins||0}/{st.faceoffAttempts||0}</td>
      </tr>
    );
  };

  const GoalieRow=({g})=>{
    const i=g.info||{};
    const st=g.stats||{};
    const sa=parseInt(st.shotsAgainst)||0;
    const svs=parseInt(st.saves)||0;
    const ga=parseInt(st.goalsAgainst)||0;
    const svPct=sa>0?((sa-ga)/sa):0;
    const isStarter=g.starting===1;
    return(
      <tr style={{borderBottom:"1px solid var(--border)",background:isStarter?"rgba(79,195,247,.03)":"transparent"}}>
        <td style={{padding:"6px 6px",fontFamily:"var(--fm)",fontSize:11,color:"var(--text3)",width:28,textAlign:"center"}}>{i.jerseyNumber}</td>
        <td style={{padding:"6px 6px",fontSize:13,fontWeight:600,color:isStarter?"var(--text)":"var(--text3)"}}>{i.firstName} {i.lastName}{isStarter?<span style={{fontSize:8,color:"var(--ye)",marginLeft:4}}>★</span>:null}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:"var(--text2)",width:36}}>{sa}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:"var(--text2)",width:36}}>{svs}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:ga>0?"var(--rd)":"var(--gr)",fontWeight:600,width:36}}>{ga}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12,color:"var(--text)",fontWeight:600,width:48}}>{svPct>0?`.${Math.round(svPct*1000)}`:"—"}</td>
        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:11,color:"var(--text2)",width:48}}>{st.timeOnIce||''}</td>
      </tr>
    );
  };

  const StatBar=({label,away:av,home:hv,pct,text})=>{
    if(text){
      return(
        <div style={{display:"flex",alignItems:"center",gap:10,padding:"6px 0",borderBottom:"1px solid var(--border)"}}>
          <span style={{fontFamily:"var(--fm)",fontSize:14,fontWeight:700,width:40,textAlign:"right"}}>{av}</span>
          <div style={{flex:1,textAlign:"center",fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1.5px",color:"var(--text3)",textTransform:"uppercase"}}>{label}</div>
          <span style={{fontFamily:"var(--fm)",fontSize:14,fontWeight:700,width:40}}>{hv}</span>
        </div>
      );
    }
    const total=pct?100:(av+hv||1);
    const aW=pct?av:(av/total*100);
    const hW=pct?hv:(hv/total*100);
    return(
      <div style={{display:"flex",alignItems:"center",gap:10,padding:"6px 0",borderBottom:"1px solid var(--border)"}}>
        <span style={{fontFamily:"var(--fm)",fontSize:14,fontWeight:700,width:40,textAlign:"right",color:av>hv?"var(--text)":"var(--text3)"}}>{pct?`${av}%`:av}</span>
        <div style={{flex:1,position:"relative"}}>
          <div style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1.5px",color:"var(--text3)",textTransform:"uppercase",marginBottom:4}}>{label}</div>
          <div style={{display:"flex",height:6,borderRadius:3,overflow:"hidden",background:"var(--bg5)"}}>
            <div style={{width:`${aW}%`,background:"var(--or)",transition:"width .5s"}}/>
            <div style={{flex:1}}/>
            <div style={{width:`${hW}%`,background:"var(--ac)",transition:"width .5s"}}/>
          </div>
        </div>
        <span style={{fontFamily:"var(--fm)",fontSize:14,fontWeight:700,width:40,color:hv>av?"var(--text)":"var(--text3)"}}>{pct?`${hv}%`:hv}</span>
      </div>
    );
  };

  return ReactDOM.createPortal(
    <div className="pop-overlay" onClick={onClose} style={{zIndex:400}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:10,width:"100%",maxWidth:720,maxHeight:"90vh",overflow:"auto",position:"relative"}}>

        {/* Header */}
        <div style={{padding:"12px 16px",borderBottom:"1px solid var(--border)",position:"sticky",top:0,background:"var(--bg2)",zIndex:1,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {isInProgress&&<span className="ng-live" style={{fontSize:10,fontFamily:"var(--fm)"}}>● LIVE</span>}
            {isFinal&&<span style={{fontSize:10,fontFamily:"var(--fm)",color:"var(--text3)"}}>FINAL</span>}
            <span style={{fontFamily:"var(--fm)",fontSize:11,color:"var(--text3)"}}>{details.date||''}</span>
          </div>
          <button className="pop-close" onClick={onClose} style={{position:"static"}}>✕</button>
        </div>

        {/* Scoreboard */}
        <div style={{padding:"16px 20px 8px",display:"flex",alignItems:"center",justifyContent:"center",gap:16}}>
          <div style={{display:"flex",alignItems:"center",gap:10,flex:1,justifyContent:"flex-end"}}>
            {aLogo&&<img src={aLogo} alt="" style={{width:40,height:40,objectFit:"contain"}}/>}
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:14,fontWeight:700}}>{aInfo.abbreviation||'AWAY'}</div>
              <div style={{fontSize:10,color:"var(--text3)",fontFamily:"var(--fm)"}}>{away.seasonStats?.teamRecord?.formattedRecord||''}</div>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:40,fontWeight:800,fontFamily:"var(--fm)",color:aGoals>hGoals?"var(--gr)":aGoals<hGoals?"var(--rd)":"var(--text)"}}>{aGoals}</span>
            <span style={{fontSize:20,color:"var(--text3)"}}>–</span>
            <span style={{fontSize:40,fontWeight:800,fontFamily:"var(--fm)",color:hGoals>aGoals?"var(--gr)":hGoals<aGoals?"var(--rd)":"var(--text)"}}>{hGoals}</span>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10,flex:1}}>
            <div>
              <div style={{fontSize:14,fontWeight:700}}>{hInfo.abbreviation||'HOME'}</div>
              <div style={{fontSize:10,color:"var(--text3)",fontFamily:"var(--fm)"}}>{home.seasonStats?.teamRecord?.formattedRecord||''}</div>
            </div>
            {hLogo&&<img src={hLogo} alt="" style={{width:40,height:40,objectFit:"contain"}}/>}
          </div>
        </div>

        {/* Status + Venue */}
        <div style={{textAlign:"center",padding:"0 20px 12px"}}>
          <div style={{fontFamily:"var(--fm)",fontSize:11,color:isInProgress?"var(--rd)":"var(--text3)"}}>{statusText}</div>
          {details.venue&&<div style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",marginTop:2}}>{details.venue}{details.attendance>0?` · ${details.attendance.toLocaleString()} fans`:''}</div>}
        </div>

        {/* Tabs */}
        <div style={{display:"flex",borderBottom:"1px solid var(--border)",padding:"0 16px"}}>
          {["summary","skaters","goalies"].map(t=>(
            <button key={t} onClick={()=>setTab(t)} style={{padding:"8px 16px",fontSize:11,fontFamily:"var(--fm)",fontWeight:600,letterSpacing:"1px",textTransform:"uppercase",color:tab===t?"var(--ac)":"var(--text3)",borderBottom:tab===t?"2px solid var(--ac)":"2px solid transparent",transition:"all .12s"}}>{t}</button>
          ))}
        </div>

        <div style={{padding:"12px 16px"}}>

          {/* ── SUMMARY TAB ── */}
          {tab==="summary"&&(
            <>
              {/* Period linescore */}
              {periods.length>0&&(
                <div style={{display:"flex",justifyContent:"center",marginBottom:16}}>
                  <table style={{minWidth:200}}>
                    <thead><tr>
                      <th style={{padding:"4px 12px",fontSize:9,fontFamily:"var(--fm)",color:"var(--text3)",textAlign:"left"}}>Team</th>
                      {periods.map((p,i)=><th key={i} style={{padding:"4px 10px",fontSize:9,fontFamily:"var(--fm)",color:"var(--text3)",textAlign:"center"}}>{p.info?.longName||`P${i+1}`}</th>)}
                      <th style={{padding:"4px 10px",fontSize:9,fontFamily:"var(--fm)",color:"var(--ac)",textAlign:"center"}}>T</th>
                    </tr></thead>
                    <tbody>
                      <tr style={{borderBottom:"1px solid var(--border)"}}>
                        <td style={{padding:"4px 12px",fontSize:12,fontWeight:600}}>{aInfo.abbreviation}</td>
                        {periods.map((p,i)=><td key={i} style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12}}>{p.stats?.visitingGoals||0}</td>)}
                        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:13,fontWeight:700,color:"var(--ac)"}}>{aGoals}</td>
                      </tr>
                      <tr>
                        <td style={{padding:"4px 12px",fontSize:12,fontWeight:600}}>{hInfo.abbreviation}</td>
                        {periods.map((p,i)=><td key={i} style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:12}}>{p.stats?.homeGoals||0}</td>)}
                        <td style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:13,fontWeight:700,color:"var(--ac)"}}>{hGoals}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* Team stats comparison */}
              <div style={{marginBottom:16,padding:"8px 0"}}>
                <div style={{fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)",marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                  <span style={{color:"var(--or)"}}>{aInfo.abbreviation}</span>
                  <span>Team Stats</span>
                  <span style={{color:"var(--ac)"}}>{hInfo.abbreviation}</span>
                  <div style={{flex:1,height:1,background:"var(--border)"}}/>
                </div>
                <StatBar label="Shots" away={parseInt(aStats.shots)||0} home={parseInt(hStats.shots)||0}/>
                <StatBar label="Hits" away={parseInt(aStats.hits)||0} home={parseInt(hStats.hits)||0}/>
                <StatBar label="Power Play" away={`${aStats.powerPlayGoals||0}/${aStats.powerPlayOpportunities||0}`} home={`${hStats.powerPlayGoals||0}/${hStats.powerPlayOpportunities||0}`} text/>
                <StatBar label="PIM" away={parseInt(aStats.penaltyMinuteCount)||0} home={parseInt(hStats.penaltyMinuteCount)||0}/>
                <StatBar label="Faceoff %" away={parseFloat(aStats.faceoffWinPercentage)||0} home={parseFloat(hStats.faceoffWinPercentage)||0} pct/>
              </div>

              {/* Scoring plays */}
              {allGoals.length>0&&(
                <div style={{marginBottom:16}}>
                  <div style={{fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)",marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                    Scoring<div style={{flex:1,height:1,background:"var(--border)"}}/>
                  </div>
                  {allGoals.map((g,i)=>{
                    const scorer=g.scoredBy||g.goal_scorer||{};
                    const scorerName=scorer.firstName?`${scorer.firstName} ${scorer.lastName}`:(scorer.name||'Unknown');
                    const assists=(g.assists||[]).map(a=>a.firstName?`${a.firstName} ${a.lastName}`:a.name).filter(Boolean);
                    const teamAbbr=g.team?.abbreviation||'';
                    const isHomeGoal=teamAbbr===hInfo.abbreviation;
                    const isPP=(g.properties?.isPowerPlay==='1'||g.isPowerPlay);
                    const isSH=(g.properties?.isShortHanded==='1'||g.isShortHanded);
                    const isEN=(g.properties?.isEmptyNet==='1'||g.isEmptyNet);
                    return(
                      <div key={i} style={{display:"flex",gap:10,padding:"6px 0",borderBottom:"1px solid var(--border)",fontSize:12}}>
                        <div style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",width:50,flexShrink:0,textAlign:"right"}}>
                          {g.period} {g.time||''}
                        </div>
                        <div style={{width:3,borderRadius:2,background:isHomeGoal?"var(--ac)":"var(--or)",flexShrink:0}}/>
                        <div style={{flex:1}}>
                          <div style={{display:"flex",alignItems:"center",gap:4}}>
                            <span style={{fontFamily:"var(--fm)",fontSize:10,color:isHomeGoal?"var(--ac)":"var(--or)"}}>{teamAbbr}</span>
                            <span style={{fontWeight:700,color:"var(--text)"}}>{scorerName}</span>
                            {scorer.seasonTotal&&<span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)"}}>({scorer.seasonTotal})</span>}
                            {isPP&&<span style={{fontFamily:"var(--fm)",fontSize:9,color:"var(--ye)",padding:"1px 4px",borderRadius:2,background:"rgba(245,200,66,.1)"}}>PP</span>}
                            {isSH&&<span style={{fontFamily:"var(--fm)",fontSize:9,color:"var(--ac)",padding:"1px 4px",borderRadius:2,background:"rgba(79,195,247,.1)"}}>SH</span>}
                            {isEN&&<span style={{fontFamily:"var(--fm)",fontSize:9,color:"var(--text3)",padding:"1px 4px",borderRadius:2,background:"var(--bg4)"}}>EN</span>}
                          </div>
                          {assists.length>0&&<div style={{fontSize:11,color:"var(--text3)"}}>Assists: {assists.join(', ')}</div>}
                        </div>
                        <div style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",flexShrink:0}}>
                          {g.visitingTeamGoals||0}–{g.homeTeamGoals||0}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Penalties */}
              {allPenalties.length>0&&(
                <div>
                  <div style={{fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)",marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                    Penalties<div style={{flex:1,height:1,background:"var(--border)"}}/>
                  </div>
                  {allPenalties.map((p,i)=>{
                    const player=p.takenBy||p.player||{};
                    const playerName=player.firstName?`${player.firstName} ${player.lastName}`:(p.team?.abbreviation?`${p.team.abbreviation} Bench`:'Bench');
                    const teamAbbr=p.team?.abbreviation||'';
                    return(
                      <div key={i} style={{display:"flex",gap:10,padding:"4px 0",borderBottom:"1px solid var(--border)",fontSize:12}}>
                        <div style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",width:50,textAlign:"right"}}>{p.period} {p.time||''}</div>
                        <div style={{flex:1}}>
                          <span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",marginRight:4}}>{teamAbbr}</span>
                          <span style={{fontWeight:500}}>{playerName}</span>
                          <span style={{color:"var(--ye)",marginLeft:6}}>{p.description||p.penaltyName||''}</span>
                          <span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",marginLeft:4}}>{p.minutes||p.penaltyMinutes||''}min</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}

          {/* ── SKATERS TAB ── */}
          {tab==="skaters"&&(
            <>
              {[{label:aInfo.abbreviation||'AWAY',skaters:aSkaters,side:"away"},{label:hInfo.abbreviation||'HOME',skaters:hSkaters,side:"home"}].map(({label,skaters,side})=>(
                <div key={label} style={{marginBottom:20}}>
                  <div style={{fontFamily:"var(--fm)",fontSize:11,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text2)",marginBottom:6,display:"flex",alignItems:"center",gap:8,fontWeight:600}}>
                    {label} Skaters — {skaters.length}<div style={{flex:1,height:1,background:"var(--border)"}}/>
                  </div>
                  <div style={{overflowX:"auto",border:"1px solid var(--border)",borderRadius:6}}>
                    <table style={{width:"100%",minWidth:560,borderCollapse:"collapse"}}>
                      <thead><tr>
                        {skCols.map(c=><SkTh key={c.key} col={c.key} side={side}/>)}
                      </tr></thead>
                      <tbody>
                        {sortSkaters(skaters,side).map((s,i)=><SkaterRow key={i} s={s} idx={i}/>)}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </>
          )}

          {/* ── GOALIES TAB ── */}
          {tab==="goalies"&&(
            <>
              {[{label:aInfo.abbreviation||'AWAY',goalies:aGoalies},{label:hInfo.abbreviation||'HOME',goalies:hGoalies}].map(({label,goalies})=>(
                <div key={label} style={{marginBottom:20}}>
                  <div style={{fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)",marginBottom:6,display:"flex",alignItems:"center",gap:8}}>
                    {label} Goalies<div style={{flex:1,height:1,background:"var(--border)"}}/>
                  </div>
                  <div style={{border:"1px solid var(--border)",borderRadius:6,overflow:"hidden"}}>
                    <table style={{width:"100%",borderCollapse:"collapse"}}>
                      <thead><tr style={{borderBottom:"1px solid var(--border2)"}}>
                        {["#","Goalie","SA","SVS","GA","SV%","TOI"].map(h=>(
                          <th key={h} style={{padding:"6px 6px",fontSize:9,fontFamily:"var(--fm)",color:"var(--text3)",textAlign:h==="#"?"center":h==="Goalie"?"left":"center",width:h==="#"?28:h==="Goalie"?undefined:h==="SV%"||h==="TOI"?48:36}}>{h}</th>
                        ))}
                      </tr></thead>
                      <tbody>
                        {[...goalies].sort((a,b)=>(b.starting||0)-(a.starting||0)||(parseInt(b.stats?.shotsAgainst)||0)-(parseInt(a.stats?.shotsAgainst)||0)).map((g,i)=><GoalieRow key={i} g={g}/>)}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </>
          )}

          {/* Auto-refresh note */}
          {isInProgress&&<div style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",marginTop:12}}>Auto-refreshing every 20 seconds</div>}
          <div style={{textAlign:"center",fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",marginTop:isInProgress?4:12}}><span style={{color:"var(--ye)"}}>★</span> = Starting lineup</div>
        </div>
      </div>
    </div>,
    document.body
  );
}
 
// ─── TEAM STATS TAB (LIVE FROM API) ───────────────────────────────────────
function TeamStatsTab({teamId,onPlayer}){
  const [data,setData]=useState(null);
  const [rec,setRec]=useState(null);
  const [loading,setLoading]=useState(true);
  const HT_MAP_REV={bos:'1',min:'2',mtl:'3',ny:'4',ott:'5',tor:'6',sea:'8',van:'9'};
  const htId=HT_MAP_REV[teamId];

  useEffect(()=>{
    setLoading(true);
    Promise.all([
      fetch(`/api/team-stats?team=${htId}`).then(r=>r.json()),
      fetch('/api/standings').then(r=>r.json()),
    ]).then(([stats,stData])=>{
      setData(stats);
      const teams=stData?.teams||[];
      const myTeam=teams.find(t=>String(t.team_id)===htId);
      if(myTeam){
        const w=parseInt(myTeam.wins)||0;
        const otw=(parseInt(myTeam.ot_wins)||0)+(parseInt(myTeam.shootout_wins)||0);
        const l=parseInt(myTeam.losses)||0;
        const otl=(parseInt(myTeam.ot_losses)||0)+(parseInt(myTeam.shootout_losses)||0);
        const regW=w-otw;
        const gp=parseInt(myTeam.games_played)||0;
        const pts=parseInt(myTeam.points)||(regW*3+otw*2+otl);
        const goalsFor=parseInt(myTeam.goals_for)||0;
        const goalsAgainst=parseInt(myTeam.goals_against)||0;
        setRec({w:regW,otw,l,otl,gp,pts,gf:goalsFor,ga:goalsAgainst,diff:goalsFor-goalsAgainst});
      }
      setLoading(false);
    }).catch(()=>setLoading(false));
  },[teamId]);

  const StatCard=({label,value,sub,color})=>(
    <div style={{background:"var(--bg3)",borderRadius:6,padding:"10px 14px",border:"1px solid var(--border)",flex:"1 1 100px",minWidth:100}}>
      <div style={{fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1px",textTransform:"uppercase",color:"var(--text3)",marginBottom:4}}>{label}</div>
      <div style={{fontSize:22,fontWeight:700,fontFamily:"var(--fm)",color:color||"var(--text)"}}>{value}</div>
      {sub&&<div style={{fontSize:10,color:"var(--text3)",marginTop:2}}>{sub}</div>}
    </div>
  );

  const LeaderList=({leaders,label})=>{
    if(!leaders||!leaders.length) return null;
    return(
      <div style={{marginBottom:14}}>
        <div style={{fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1px",textTransform:"uppercase",color:"var(--text3)",marginBottom:6}}>{label}</div>
        {leaders.map((p,i)=>(
          <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 0",borderBottom:"1px solid var(--border)",cursor:"pointer"}} onClick={()=>{if(p.id)onPlayer(p.id);}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontFamily:"var(--fm)",fontSize:11,color:"var(--text3)",width:16}}>{i+1}.</span>
              <span style={{color:"var(--ac)",fontSize:13,fontWeight:500}}>{p.name}</span>
            </div>
            <span style={{fontFamily:"var(--fm)",fontSize:13,fontWeight:700}}>{p.val}</span>
          </div>
        ))}
      </div>
    );
  };

  if(loading) return <div style={{padding:30,textAlign:"center",color:"var(--text3)",fontFamily:"var(--fm)",fontSize:12}}>Loading team stats…</div>;
  if(!data) return <div style={{padding:30,textAlign:"center",color:"var(--text3)"}}>Failed to load stats</div>;

  const gp=rec?.gp||data.gp||1;
  const gf=rec?.gf||data.gf||0;
  const ga=rec?.ga||data.ga||0;
  const diff=rec?.diff||(gf-ga);

  return(
    <div style={{padding:"12px"}}>
      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:16}}>
        {rec?(
          <>
            <StatCard label="Record" value={`${rec.w}-${rec.otw}-${rec.l}-${rec.otl}`} sub={`${rec.gp} GP · ${rec.pts} pts`}/>
            <StatCard label="Goals For" value={rec.gf} color={diff>0?"var(--gr)":"var(--rd)"} sub={`${(rec.gf/Math.max(gp,1)).toFixed(2)} / game`}/>
            <StatCard label="Goals Against" value={rec.ga} color={rec.ga/Math.max(gp,1)<2?"var(--gr)":rec.ga/Math.max(gp,1)<2.5?"var(--ye)":"var(--rd)"} sub={`${(rec.ga/Math.max(gp,1)).toFixed(2)} / game`}/>
            <StatCard label="Diff" value={diff>0?`+${diff}`:String(diff)} color={diff>0?"var(--gr)":"var(--rd)"}/>
          </>
        ):(
          <>
            <StatCard label="Record" value={`${data.w}-${data.l}-${data.otl}`} sub={`${gp} GP`}/>
            <StatCard label="Goals For" value={gf} sub={`${(gf/Math.max(gp,1)).toFixed(2)} / game`}/>
            <StatCard label="Goals Against" value={ga} sub={`${(ga/Math.max(gp,1)).toFixed(2)} / game`}/>
            <StatCard label="Diff" value={diff>0?`+${diff}`:String(diff)} color={diff>0?"var(--gr)":"var(--rd)"}/>
          </>
        )}
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:16}}>
        <StatCard label="Shots For" value={data.shots||0} sub={`${((data.shots||0)/Math.max(gp,1)).toFixed(1)} / game`}/>
        <StatCard label="Shots Against" value={data.sa||0} sub={`${((data.sa||0)/Math.max(gp,1)).toFixed(1)} / game`}/>
        <StatCard label="Saves" value={data.svs||0}/>
        <StatCard label="Save %" value={data.svPct>0?`.${Math.round(data.svPct*1000)}`:"—"} color={data.svPct>=.92?"var(--gr)":data.svPct>=.90?"var(--ye)":"var(--rd)"}/>
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:16}}>
        <StatCard label="Shooting %" value={data.shotPct>0?`${data.shotPct.toFixed(1)}%`:"—"}/>
        <StatCard label="Faceoff %" value={data.foPct>0?`${data.foPct.toFixed(1)}%`:"—"} sub={`${data.foW||0}/${data.foAtt||0}`}/>
        <StatCard label="Hits" value={data.hits||0} sub={`${((data.hits||0)/Math.max(gp,1)).toFixed(1)} / game`}/>
        <StatCard label="Blocks" value={data.blocks||0} sub={`${((data.blocks||0)/Math.max(gp,1)).toFixed(1)} / game`}/>
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:16}}>
        <StatCard label="PP Goals" value={data.ppg||0} sub={`${data.ppa||0} PP assists`}/>
        <StatCard label="SH Goals" value={data.shg||0} sub={`${data.sha||0} SH assists`}/>
        <StatCard label="PIM" value={data.pim||0} sub={`${((data.pim||0)/Math.max(gp,1)).toFixed(1)} / game`}/>
        <StatCard label="Shutouts" value={data.so||0}/>
      </div>

      {data.leaders&&(
        <div className="crd" style={{marginTop:8}}>
          <div className="crd-h"><span className="crd-t">Team Leaders</span></div>
          <div style={{padding:"12px 14px",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:16}}>
            <LeaderList leaders={data.leaders.pts} label="Points"/>
            <LeaderList leaders={data.leaders.goals} label="Goals"/>
            <LeaderList leaders={data.leaders.assists} label="Assists"/>
            <LeaderList leaders={data.leaders.hits} label="Hits"/>
            <LeaderList leaders={data.leaders.blocks} label="Blocks"/>
          </div>
        </div>
      )}
    </div>
  );
}

function ContractBar({player}){
  const startYear = parseInt(player.exp) - player.yrs;
  const currentYear = 2025;
  const years = Array.from({length: player.yrs}, (_, i) => startYear + 1 + i);
  return(
    <div className="cbar-wrap">
      <div className="cbar-track">
        {years.map((yr, i) => {
          const label = `${yr}-${String(yr+1).slice(2)}`;
          const cls = yr === currentYear ? 'current' : yr < currentYear ? 'past' : 'future';
          return(
            <div key={yr} className={`cbar-seg ${cls}`}>
              {cls === 'current' ? '▶' : yr < currentYear ? '✓' : ''}
            </div>
          );
        })}
      </div>
      <div className="cbar-labels">
        {years.map(yr => (
          <div key={yr} className="cbar-lbl">{yr}-{String(yr+1).slice(2)}</div>
        ))}
      </div>
      <div className="cbar-sal">{fmt(player.sal)} cap hit per season · {player.yrs} year{player.yrs>1?'s':''} · Expires {player.exp}</div>
    </div>
  );
}
 
function AdvPill({val,lo,hi}){
  if(val===null||val===undefined||isNaN(val)) return <span className="adv-pill adv-md">—</span>;
  const cls=val>=hi?"adv-hi":val<=lo?"adv-lo":"adv-md";
  return <span className={`adv-pill ${cls}`}>{val}%</span>;
}
 
// ─── PLAYER POPUP ─────────────────────────────────────────────────────────────
function PlayerPopup({pid,onClose,onProfile}){
  const p=gP(pid);
  const t=gT(p?.team);
  if(!p) return null;
  return(
    <div className="pop-overlay" onClick={onClose}>
      <div className="pop" onClick={e=>e.stopPropagation()}>
        <div className="pop-num-bg">#{p.num}</div>
        <button className="pop-close" onClick={onClose}>✕</button>
        <div className="pop-pos">{p.sub} · #{p.num} · {t?.name}</div>
        <div className="pop-name">{p.name}<InjuryBadge player={p}/></div>
        <div className="pop-grid">
          {[
            {l:"Cap Hit", v:fmtSal(p).text,  c:fmtSal(p).color},
            {l:"Status",  v:p.status,    c:p.status==="UFA"?"var(--rd)":p.status==="RFA"?"var(--ye)":"var(--gr)"},
            {l:"Age",     v:p.age,       c:"var(--text)"},
            {l:"Clause",  v:p.clause,    c:p.clause!=="—"?"var(--ye)":"var(--text3)"},
          ].map(s=>(
            <div key={s.l} className="pop-stat">
              <div className="pop-stat-l">{s.l}</div>
              <div className="pop-stat-v" style={{color:s.c,fontSize:s.l==="Clause"?13:16}}>{s.v}</div>
            </div>
          ))}
        </div>
        <div className="pop-btns">
          <button className="pop-btn-profile" onClick={()=>{onProfile(pid);onClose();}}>→ Full Profile</button>
          <button className="pop-btn-close" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
 
// ─── SLOT CARD ────────────────────────────────────────────────────────────────
function SlotCard({posLabel,pid,isDragOver,onDragStart,onDragOver,onDrop,onDragEnd,onTap}){
  const p=pid?gP(pid):null;
  const holdRef=useRef(null);
  const [pressing,setPressing]=useState(false);
 
  const handlePD=(e)=>{
    if(!p) return;
    setPressing(true);
    holdRef.current=setTimeout(()=>{setPressing(false);onDragStart({pid});},280);
  };
  const handlePU=()=>{
    if(holdRef.current) clearTimeout(holdRef.current);
    if(pressing&&p){setPressing(false);onTap(pid);}
  };
  const handlePL=()=>{if(holdRef.current)clearTimeout(holdRef.current);setPressing(false);};
 
  return(
    <div
      className={`slot${!p?" empty-slot":""}${isDragOver?" drag-over":""}`}
      onPointerDown={handlePD} onPointerUp={handlePU} onPointerLeave={handlePL}
      draggable={!!p}
      onDragStart={e=>{if(p){e.dataTransfer.effectAllowed="move";onDragStart({pid});}}}
      onDragOver={e=>{e.preventDefault();onDragOver();}}
      onDrop={e=>{e.preventDefault();onDrop();}}
      onDragEnd={onDragEnd}
      style={{touchAction:"none"}}
    >
      {/* LEFT: circle photo */}
      <div style={{flexShrink:0}}>
        {p?.photoUrl
          ? <img src={p.photoUrl} alt={p.name} style={{width:46,height:46,borderRadius:"50%",objectFit:"cover",objectPosition:"top center",border:"2px solid var(--border2)",display:"block"}} onError={e=>e.target.style.display="none"}/>
          : <div style={{width:46,height:46,borderRadius:"50%",background:"var(--bg5)",border:"1px dashed var(--border)"}}/>
        }
      </div>
      {/* MIDDLE: all info */}
      <div style={{flex:1,minWidth:0,overflow:"hidden",padding:"0 4px"}}>
        <div style={{display:"flex",gap:3,alignItems:"center",marginBottom:3}}>
          <div className="slot-pos" style={{fontSize:10}}>{posLabel}</div>
          {p&&p.sub&&p.sub!==posLabel&&<div style={{fontSize:9,fontFamily:"var(--fm)",color:"var(--text3)"}}>{p.sub}</div>}
          {!p&&<div style={{fontSize:10,color:"var(--text3)",fontStyle:"italic"}}>Empty</div>}
        </div>
        {p&&<>
          <div style={{fontWeight:700,fontSize:13,color:"var(--text)",lineHeight:1.2,marginBottom:3,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{p.name}</div>
          <div style={{fontFamily:"var(--fm)",fontSize:11,color:fmtSal(p).color,fontWeight:600,marginBottom:2}}>{fmtSal(p).text}</div>
          <div style={{fontFamily:"var(--fm)",fontSize:9,color:"var(--text3)",whiteSpace:"nowrap"}}>
            {p.yrs&&p.exp?`YR ${Math.min(p.yrs,Math.max(1,2026-(parseInt(p.exp)-p.yrs)))} of ${p.yrs} `:""}
            <span style={{color:p.status==="UFA"?"var(--rd)":p.status==="RFA"?"var(--ye)":"var(--gr)"}}>{p.status}</span>
          </div>
        </>}
      </div>
      {/* RIGHT: big faded number */}
      <div className="slot-num-bg" style={{fontFamily:"var(--fm)",fontSize:28,fontWeight:900,lineHeight:1,flexShrink:0,minWidth:30,textAlign:"right"}}>
        {p?p.num:""}
      </div>
    </div>
  );
}
 
// ─── LINE BUILDER ─────────────────────────────────────────────────────────────
function LineBuilder({players,onProfile}){
  const [lines,setLines]=useState(()=>buildLines(players));
  const [dragSrc,setDragSrc]=useState(null);
  const [hoverKey,setHoverKey]=useState(null);
  const [popup,setPopup]=useState(null);
  const [ghostPos,setGhostPos]=useState(null);
  const [ghostName,setGhostName]=useState("");
 
  // Rebuild if players array changes
  const prevKey=useRef("");
  const curKey=players.map(p=>p.id).sort().join(",");
  if(prevKey.current!==curKey){prevKey.current=curKey;setLines(buildLines(players));setDragSrc(null);}
 
  useEffect(()=>{
    const mm=e=>{if(dragSrc)setGhostPos({x:e.clientX+14,y:e.clientY-18});};
    window.addEventListener("mousemove",mm);
    return()=>window.removeEventListener("mousemove",mm);
  },[dragSrc]);
 
  const used=new Set([...lines.fL.flat(),...lines.dL.flat(),...lines.gL].filter(Boolean));
  const bench=players.filter(p=>!used.has(p.id));
 
  const startDrag=({pid,fromLt,fromLi,fromSi})=>{
    setGhostName(gP(pid)?.name||"");
    setDragSrc({pid,fromLt,fromLi,fromSi});
  };
  const endDrag=()=>{setDragSrc(null);setHoverKey(null);setGhostPos(null);};
 
  const doSwap=(toLt,toLi,toSi)=>{
    if(!dragSrc) return;
    const dragPlayer = gP(dragSrc.pid);
    if(dragPlayer){
      const isGoalie = dragPlayer.pos==="G";
      if(isGoalie && toLt!=="g") return;
      if(!isGoalie && toLt==="g") return;
    }
    const nl=JSON.parse(JSON.stringify(lines));
    const getArr=(lt,li)=>lt==="g"?nl.gL:lt==="f"?nl.fL[li]:nl.dL[li];
    const toArr=getArr(toLt,toLi);
    const displaced=toArr[toSi];
    toArr[toSi]=dragSrc.pid;
    if(dragSrc.fromLt!==undefined){
      const fromArr=getArr(dragSrc.fromLt,dragSrc.fromLi);
      fromArr[dragSrc.fromSi]=displaced;
    }
    setLines(nl);endDrag();
  };
 
  const mk=(lt,li,si)=>`${lt}-${li}-${si}`;
  const fLbl=["LW","C","RW"],dLbl=["LD","RD"];
  const lN=["1st","2nd","3rd","4th"],pN=["1st","2nd","3rd"];
 
  return(
    <div>
      {popup&&<PlayerPopup pid={popup} onClose={()=>setPopup(null)} onProfile={onProfile}/>}
      {dragSrc&&ghostPos&&(
        <div className="drag-ghost" style={{left:ghostPos.x,top:ghostPos.y}}>{ghostName}</div>
      )}
      <div className="lines-wrap">
        <div>
          <div className="pos-hdr">Forwards</div>
          {lines.fL.map((line,li)=>(
            <div key={li} className="line-row fwd">
              <div className="line-num">{lN[li]} Line</div>
              {line.map((pid,si)=>(
                <SlotCard key={si} posLabel={fLbl[si]} pid={pid}
                  isDragOver={hoverKey===mk("f",li,si)&&!!dragSrc}
                  onDragStart={({pid:p})=>startDrag({pid:p,fromLt:"f",fromLi:li,fromSi:si})}
                  onDragOver={()=>{const dp=gP(dragSrc?.pid);if(!dp||dp.pos!=="G")setHoverKey(mk("f",li,si));}}
                  onDrop={()=>doSwap("f",li,si)}
                  onDragEnd={endDrag}
                  onTap={setPopup}/>
              ))}
            </div>
          ))}
        </div>
        <div>
          <div className="pos-hdr">Defence</div>
          {lines.dL.map((line,li)=>(
            <div key={li} className="line-row def">
              <div className="line-num">{pN[li]} Pair</div>
              {line.map((pid,si)=>(
                <SlotCard key={si} posLabel={dLbl[si]} pid={pid}
                  isDragOver={hoverKey===mk("d",li,si)&&!!dragSrc}
                  onDragStart={({pid:p})=>startDrag({pid:p,fromLt:"d",fromLi:li,fromSi:si})}
                  onDragOver={()=>{const dp=gP(dragSrc?.pid);if(!dp||dp.pos!=="G")setHoverKey(mk("d",li,si));}}
                  onDrop={()=>doSwap("d",li,si)}
                  onDragEnd={endDrag}
                  onTap={setPopup}/>
              ))}
            </div>
          ))}
        </div>
        <div>
          <div className="pos-hdr">Goalies</div>
          <div className="line-row goal">
            <div className="line-num">Depth</div>
            {lines.gL.map((pid,si)=>(
              <SlotCard key={si} posLabel={si===0?"STARTER":"BACKUP"} pid={pid}
                isDragOver={hoverKey===mk("g",0,si)&&!!dragSrc}
                onDragStart={({pid:p})=>startDrag({pid:p,fromLt:"g",fromLi:0,fromSi:si})}
                onDragOver={()=>{const dp=gP(dragSrc?.pid);if(!dp||dp.pos==="G")setHoverKey(mk("g",0,si));}}
                onDrop={()=>doSwap("g",0,si)}
                onDragEnd={endDrag}
                onTap={setPopup}/>
            ))}
          </div>
        </div>
      </div>
      {bench.length>0&&(
        <div className="bench-wrap">
          <div className="bench-hdr">Bench — drag onto a slot to place · tap to view info</div>
          <div className="bench-grid">
            {bench.map(p=>(
              <div key={p.id}
                className={`bench-chip ${dragSrc?.pid===p.id?"is-dragging":""}`}
                draggable
                onDragStart={e=>{e.dataTransfer.effectAllowed="move";startDrag({pid:p.id});}}
                onDragEnd={endDrag}
                onClick={()=>setPopup(p.id)}>
                <span className={`bx b-${p.pos.toLowerCase()}`}>{p.pos}</span>
                <span className="bench-num">#{p.num}</span>
                <span style={{fontWeight:500}}>{p.name}</span>
                <span style={{fontFamily:"var(--fm)",fontSize:10,color:fmtSal(p).color}}>{fmtSal(p).text}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
 
// ─── PAGES ────────────────────────────────────────────────────────────────────
function HomePage({players,skaterStats,goalieStats,onTeam,onPlayer}){
  const activePlrs=players.filter(p=>p.hasPlayed);
  const ufas=activePlrs.filter(p=>p.status==="UFA").length;
  const avgSal=activePlrs.length?Math.round(activePlrs.reduce((a,p)=>a+p.sal,0)/activePlrs.length):0;

  // Live standings from HockeyTech divisionstandings API
  const [standings,setStandings]=useState([]);
  useEffect(()=>{
    fetch('/api/standings').then(r=>r.json()).then(data=>{
      const teams=data?.teams||[];
      const HT_MAP={'1':'bos','2':'min','3':'mtl','4':'ny','5':'ott','6':'tor','8':'sea','9':'van'};
      const built=teams.map(t=>{
        const teamId=HT_MAP[String(t.team_id)]||'';
        const team=TEAMS.find(x=>x.id===teamId)||{};
        const w=parseInt(t.wins)||0;
        const otw=(parseInt(t.ot_wins)||0)+(parseInt(t.shootout_wins)||0);
        const l=parseInt(t.losses)||0;
        const otl=(parseInt(t.ot_losses)||0)+(parseInt(t.shootout_losses)||0);
        const regW=w-otw; // regulation wins
        const pts=regW*3 + otw*2 + otl;
        const gp=parseInt(t.games_played)||0;
        const gf=parseInt(t.goals_for)||0;
        const ga=parseInt(t.goals_against)||0;
        const pct=parseFloat(t.percentage)||0;
        return{
          ...team, rank:parseInt(t.rank)||0, clinched:t.clinched||'',
          gp, w:regW, otw, l, otl, pts:parseInt(t.points)||pts,
          gf, ga, diff:gf-ga, pct,
        };
      }).sort((a,b)=>a.rank-b.rank);
      setStandings(built);
    }).catch(()=>{});
  },[]);

  // League leaders from DB stats
  const curSkaters = (skaterStats||[]).filter(s=>s.season==='2025-26');
  const topPts = [...curSkaters].map(s=>({...s,pts:(s.g||0)+(s.a||0)})).sort((a,b)=>b.pts-a.pts).slice(0,10);
  const topG = [...curSkaters].sort((a,b)=>(b.g||0)-(a.g||0)).slice(0,10);
  const topA = [...curSkaters].sort((a,b)=>(b.a||0)-(a.a||0)).slice(0,10);

  const LeaderTable = ({title,rows,valField})=>(
    <div className="crd" style={{flex:"1 1 300px",minWidth:280}}>
      <div className="crd-h"><span className="crd-t">{title}</span></div>
      <table style={{width:"100%"}}>
        <thead><tr><th style={{width:30}}>#</th><th>Player</th><th>Team</th><th style={{textAlign:"right"}}>
          {valField==='pts'?'PTS':valField==='g'?'G':'A'}
        </th></tr></thead>
        <tbody>
          {rows.map((s,i)=>{
            const pl = _PLAYERS.find(p=>p.id===s.player_id);
            if(!pl) return null;
            const tm = gT(pl.team);
            const val = valField==='pts' ? (s.g||0)+(s.a||0) : (s[valField]||0);
            return(
              <tr key={i} onClick={()=>onPlayer(pl.id)} style={{cursor:"pointer"}}>
                <td className="m" style={{color:"var(--text3)"}}>{i+1}</td>
                <td className="b" style={{color:"var(--ac)"}}>{pl.name}</td>
                <td>{tm?<span style={{fontFamily:"var(--fm)",fontSize:10,color:tColor(tm),background:"var(--bg4)",padding:"1px 5px",borderRadius:3}}>{tm.abbr}</span>:""}</td>
                <td className="m" style={{textAlign:"right",fontWeight:700}}>{val}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  return(
    <div className="fu">
      <div className="ph"><h1>League Overview — 2025–26</h1><span className="ph-sub">{activePlrs.length} active players · 8 teams</span></div>
      <div className="sstrip">
        {[{l:"Cap Limit",v:"$1.3M",c:"c-ac",n:"Per team"},{l:"Avg Salary",v:fmt(avgSal),c:"",n:"League-wide"},{l:"Pending UFAs",v:ufas,c:"c-rd",n:"Free agents"},{l:"$100K+ Deals",v:players.filter(p=>p.sal>=100000).length,c:"c-gr",n:"Six-figure"},{l:"Teams",v:8,c:"",n:"2025–26 season"}].map(s=>(
          <div key={s.l} className="sc"><div className="sc-l">{s.l}</div><div className={`sc-v ${s.c}`}>{s.v}</div><div className="sc-n">{s.n}</div></div>
        ))}
      </div>

      <div className="ph"><h1>Teams</h1><span className="ph-sub">Click a team to view roster &amp; lines</span></div>
      <div className="tgrid">
        {TEAMS.map(t=>{
          const active=players.filter(p=>p.team===t.id&&p.hasPlayed);
          const spent=active.reduce((a,p)=>a+p.sal,0),space=CAP_LIMIT-spent;
          const sc=space<30000?"c-rd":space<100000?"c-ye":"c-gr";
          return(
            <div key={t.id} className="tcard" style={{"--tc":tColor(t)}} onClick={()=>onTeam(t.id)}>
              <div className="tc-name">{t.name}</div>
              <div className="tc-row"><span className="tc-lbl">Cap Hit</span><span className="tc-val">{fmt(spent)}</span></div>
              <CapBar spent={spent} cap={CAP_LIMIT} h={4}/>
              <div className="tc-row" style={{marginTop:5}}>
                <span className="tc-lbl">Space</span>
                <span className={`tc-val ${sc}`} style={{fontSize:12,fontWeight:600}}>{space>=0?fmt(space):`−${fmt(Math.abs(space))}`}</span>
              </div>
              <div className="tc-row"><span className="tc-lbl">Active</span><span className="tc-val">{active.length}p</span></div>
            </div>
          );
        })}
      </div>

      {/* STANDINGS */}
      <div className="crd" style={{marginTop:20,marginBottom:16}}>
        <div className="crd-h"><span className="crd-t">Standings</span></div>
        <div className="tbl-scroll">
          {standings.length>0?(
            <>
            <table style={{width:"100%"}}>
              <thead><tr>
                <th style={{width:30}}>#</th>
                <th>Team</th>
                <th className="m">GP</th>
                <th className="m">W</th>
                <th className="m">OTW</th>
                <th className="m">L</th>
                <th className="m">OTL</th>
                <th className="m">PTS</th>
                <th className="m">GF</th>
                <th className="m">GA</th>
                <th className="m">DIFF</th>
              </tr></thead>
              <tbody>
                {standings.map((t,i)=>{
                  const inPlayoffs=i<4;
                  const isClinched=t.clinched==='x';
                  const isEliminated=t.clinched==='e';
                  return(
                    <tr key={t.id||i} onClick={()=>t.id&&onTeam(t.id)} style={{cursor:"pointer",background:inPlayoffs?"rgba(79,195,247,.04)":"transparent"}}>
                      <td className="m" style={{color:inPlayoffs?"var(--ac)":"var(--text3)",fontWeight:inPlayoffs?700:400}}>{t.rank||i+1}</td>
                      <td>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          {t.logo&&<img src={t.logo} alt="" style={{width:22,height:22,objectFit:"contain"}}/>}
                          <span className="b" style={{color:tColor(t)}}>
                            {isClinched&&<span style={{color:"var(--gr)",fontFamily:"var(--fm)",fontSize:11,marginRight:4}}>x –</span>}
                            {isEliminated&&<span style={{color:"var(--rd)",fontFamily:"var(--fm)",fontSize:11,marginRight:4}}>e –</span>}
                            {t.name}
                          </span>
                        </div>
                      </td>
                      <td className="m">{t.gp}</td>
                      <td className="m" style={{fontWeight:600}}>{t.w}</td>
                      <td className="m" style={{color:"var(--text2)"}}>{t.otw}</td>
                      <td className="m">{t.l}</td>
                      <td className="m">{t.otl}</td>
                      <td className="m" style={{fontWeight:700,color:"var(--ac)"}}>{t.pts}</td>
                      <td className="m">{t.gf}</td>
                      <td className="m">{t.ga}</td>
                      <td className="m" style={{color:t.diff>0?"var(--gr)":t.diff<0?"var(--rd)":"var(--text3)",fontWeight:600}}>
                        {t.diff>0?`+${t.diff}`:t.diff}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div style={{padding:"6px 14px",fontSize:10,color:"var(--text3)",fontFamily:"var(--fm)",display:"flex",gap:16,flexWrap:"wrap"}}>
              <span>Top 4 qualify for playoffs</span>
              <span>Points: 3 for W, 2 for OTW, 1 for OTL</span>
              {standings.some(t=>t.clinched==='x')&&<span style={{color:"var(--gr)"}}>x = Clinched playoff spot</span>}
              {standings.some(t=>t.clinched==='e')&&<span style={{color:"var(--rd)"}}>e = Eliminated</span>}
            </div>
            </>
          ):(
            <div style={{padding:20,textAlign:"center",color:"var(--text3)",fontFamily:"var(--fm)",fontSize:12}}>Loading standings...</div>
          )}
        </div>
      </div>

      {/* LEAGUE LEADERS */}
      {curSkaters.length>0 && (
        <>
          <div className="ph" style={{marginTop:16}}><h1>League Leaders</h1></div>
          <div style={{display:"flex",flexWrap:"wrap",gap:12}}>
            <LeaderTable title="Points" rows={topPts} valField="pts"/>
            <LeaderTable title="Goals" rows={topG} valField="g"/>
            <LeaderTable title="Assists" rows={topA} valField="a"/>
          </div>
        </>
      )}
    </div>
  );
}
 
function TeamPage({players,teamId,onBack,onPlayer}){
  const t=gT(teamId);
  const teamPlayers=players.filter(p=>p.team===teamId);
  const activePlayers=teamPlayers.filter(p=>p.hasPlayed);
  const inactivePlayers=teamPlayers.filter(p=>!p.hasPlayed);
  const fwds=activePlayers.filter(p=>p.pos==="F").sort((a,b)=>b.sal-a.sal);
  const defs=activePlayers.filter(p=>p.pos==="D").sort((a,b)=>b.sal-a.sal);
  const goalies=activePlayers.filter(p=>p.pos==="G").sort((a,b)=>b.sal-a.sal);
  const spent=activePlayers.reduce((a,p)=>a+p.sal,0),space=CAP_LIMIT-spent;
  const [tab,setTab]=useState("roster");
  const [draftPicks,setDraftPicks]=useState([]);
  const [draftYears,setDraftYears]=useState([]);
  const [pickYear,setPickYear]=useState(2025);
  const [trades,setTrades]=useState([]);
  const [tradeYear,setTradeYear]=useState("all");

  // Fetch trades for this team
  useEffect(()=>{
    supabase.from('trades')
      .select('*')
      .or(`team1.eq.${teamId},team2.eq.${teamId}`)
      .order('trade_date', {ascending:false})
      .then(({data})=>{ if(data) setTrades(data); });
  },[teamId]);

  // Fetch draft picks
  useEffect(()=>{
    supabase.from('draft_picks')
      .select('*')
      .or(`current_owner.eq.${teamId},original_team.eq.${teamId}`)
      .order('year', {ascending:false})
      .order('round')
      .order('pick_overall')
      .then(({data})=>{
        if(data) {
          setDraftPicks(data);
          const years = [...new Set(data.map(d=>d.year))].sort((a,b)=>b-a);
          setDraftYears(years);
          if(years.length) setPickYear(years[0]);
        }
      });
  },[teamId]);
 
  const Sec=({title,list})=>(
    <>
      <tr><td colSpan={8} style={{padding:"12px 0 6px",borderBottom:"none"}}>
        <div style={{fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1.8px",textTransform:"uppercase",color:"var(--text3)",display:"flex",alignItems:"center",gap:8}}>
          {title}<div style={{flex:1,height:1,background:"var(--border)"}}/><span>{list.length}p</span>
        </div>
      </td></tr>
      <tr className="sec-hdr"><th>#</th><th>Player</th><th>Pos</th><th style={{textAlign:"right"}}>Salary</th><th>Yrs</th><th>Exp</th><th>Status</th><th>Clause</th></tr>
      {list.map(p=>(
        <tr key={p.id} onClick={()=>onPlayer(p.id)} style={{cursor:"pointer"}}>
          <td className="m" style={{color:"var(--text3)"}}>#{p.num}</td>
          <td className="b" style={{color:"var(--ac)"}}>{p.name}<InjuryBadge player={p}/></td>
          <td><Badge type={p.pos}/></td>
          <td className="m" style={{textAlign:"right",color:fmtSal(p).color,fontVariantNumeric:"tabular-nums"}}>{fmtSal(p).text}</td>
          <td className="m">{p.yrs}y</td>
          <td className="m">{p.exp}</td>
          <td><Badge type={p.status}/></td>
          <td style={{fontSize:11,color:"var(--text3)"}}>{p.clause}</td>
        </tr>
      ))}
    </>
  );
 
  return(
    <div className="fu">
      <button className="back" onClick={onBack}>← All Teams</button>
      <div className="tdh" style={{"--tc":tColor(t)}}>
        <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
          <div style={{display:"flex",alignItems:"center",gap:18}}>
            {t.logo&&<img src={t.logo} alt={t.abbr} style={{width:120,height:120,objectFit:"contain"}} onError={e=>e.target.style.display="none"}/>}
            <div className="tdn" style={{fontSize:36}}>{t.name}</div>
          </div>
          <NextGame teamId={teamId}/>
        </div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap",marginTop:4}}>
          {t.coach&&<div className="coach-badge"><span className="coach-lbl">HC</span><span>{t.coach}</span></div>}
          {t.gm&&<div className="coach-badge"><span className="coach-lbl">GM</span><span>{t.gm}</span></div>}
        </div>
        <div className="tds">
          {(()=>{
            const undisclosed=teamPlayers.filter(p=>!p.sal||p.sal===0).length;
            const estimated=teamPlayers.filter(p=>p.sal>0&&p.isEstimate).length;
            return [{l:"Cap Hit",v:fmt(spent),c:"var(--text)"},{l:"Space",v:fmt(space),c:space<30000?"var(--rd)":space<100000?"var(--ye)":"var(--gr)"},{l:"Limit",v:fmt(CAP_LIMIT),c:"var(--text2)"},{l:"Active",v:activePlayers.length,c:"var(--text2)"}].map(s=>(
              <div key={s.l}><div className="tds-l">{s.l}</div><div className="tds-v" style={{color:s.c}}>{s.v}</div></div>
            ));
          })()}
        </div>
        {(()=>{
          const undisclosed=activePlayers.filter(p=>!p.sal||p.sal===0).length;
          const estimated=activePlayers.filter(p=>p.sal>0&&p.isEstimate).length;
          const confirmed=activePlayers.length-undisclosed-estimated;
          return (undisclosed>0||estimated>0) ? (
            <div style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",marginTop:4,display:"flex",gap:12,flexWrap:"wrap"}}>
              {confirmed>0&&<span>{confirmed} confirmed</span>}
              {estimated>0&&<span style={{color:"var(--ye)"}}>{estimated} est.</span>}
              {undisclosed>0&&<span style={{color:"var(--text3)"}}>{undisclosed} undisclosed</span>}
            </div>
          ) : null;
        })()}
        <CapBar spent={spent} cap={CAP_LIMIT} h={5}/>
      </div>
      <div className="crd" style={{marginBottom:14}}>
        <div className="crd-h">
          <span className="crd-t">{t.name}</span>
          <div className="tab-group">
            <button className={`tab-btn ${tab==="lines"?"on":""}`} onClick={()=>setTab("lines")}>Lines</button>
            <button className={`tab-btn ${tab==="roster"?"on":""}`} onClick={()=>setTab("roster")}>Roster</button>
            <button className={`tab-btn ${tab==="stats"?"on":""}`} onClick={()=>setTab("stats")}>Stats</button>
            <button className={`tab-btn ${tab==="picks"?"on":""}`} onClick={()=>setTab("picks")}>Picks</button>
            <button className={`tab-btn ${tab==="trades"?"on":""}`} onClick={()=>setTab("trades")}>Trades</button>
          </div>
        </div>
        {tab==="lines"&&<LineBuilder players={activePlayers.filter(p=>!p.injuryStatus)} onProfile={onPlayer}/>}
        {tab==="roster"&&(
          <div style={{padding:14}}>
            <div className="tbl-scroll">
              <table style={{tableLayout:"fixed",width:"100%"}}>
                <colgroup>
                  <col style={{width:"5%"}}/>
                  <col style={{width:"28%"}}/>
                  <col style={{width:"6%"}}/>
                  <col style={{width:"13%"}}/>
                  <col style={{width:"6%"}}/>
                  <col style={{width:"8%"}}/>
                  <col style={{width:"10%"}}/>
                  <col style={{width:"8%"}}/>
                </colgroup>
                <tbody>
                  <Sec title="Forwards" list={fwds}/>
                  <Sec title="Defence" list={defs}/>
                  <Sec title="Goalies" list={goalies}/>
                  {inactivePlayers.length>0&&(
                    <Sec title={`Reserve / No GP (${inactivePlayers.length})`} list={inactivePlayers.sort((a,b)=>b.sal-a.sal)}/>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {tab==="stats"&&<TeamStatsTab teamId={teamId} onPlayer={onPlayer}/>}
        {tab==="picks"&&(
          <div>
            <div style={{padding:"10px 12px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid var(--border)"}}>
              <span style={{fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)"}}>
                {pickYear<=2025?"Draft Results":"Future Picks"}
              </span>
              <select className="sel" value={pickYear} onChange={e=>setPickYear(parseInt(e.target.value))} style={{fontSize:12}}>
                {draftYears.map(yr=><option key={yr} value={yr}>{yr} {yr<=2025?"Draft":"Picks"}</option>)}
              </select>
            </div>
            <div className="pk-list">
              {draftPicks.filter(pk=>pk.year===pickYear && (pk.current_owner===teamId || pk.original_team===teamId)).map((pk,i)=>{
                const rosterPlayer = pk.player_name ? (()=>{
                  const norm = s => (s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z ]/g,'').trim();
                  const draftName = norm(pk.player_name);
                  let match = players.find(p => norm(p.name) === draftName);
                  if(match) return match;
                  const parts = draftName.split(' ');
                  if(parts.length >= 2){
                    const last = parts[parts.length-1];
                    const firstInit = parts[0][0];
                    match = players.find(p => {
                      const pn = norm(p.name);
                      return pn.includes(last) && pn[0] === firstInit;
                    });
                    if(match) return match;
                    const lastMatches = players.filter(p => norm(p.name).includes(last));
                    if(lastMatches.length === 1) return lastMatches[0];
                  }
                  return null;
                })() : null;

                return(
                <div key={i} className="pk-row" style={{flexDirection:"column",alignItems:"stretch",gap:3}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{fontFamily:"var(--fm)",fontSize:11,fontWeight:500}}>
                        {pk.pick_overall ? `#${pk.pick_overall} Overall · ` : ""}Round {pk.round}
                      </div>
                      {pk.player_name && (
                        rosterPlayer
                          ? <div style={{fontSize:13,fontWeight:600,color:"var(--ac)",marginTop:2,cursor:"pointer"}} onClick={()=>onPlayer(rosterPlayer.id)}>{pk.player_name}</div>
                          : <div style={{fontSize:13,fontWeight:600,color:"var(--text)",marginTop:2}}>{pk.player_name}</div>
                      )}
                      {pk.player_school&&<div style={{fontSize:10,color:"var(--text3)"}}>{pk.player_school}</div>}
                    </div>
                    <Badge type={pk.player_pos||"Pick"}/>
                  </div>
                  {pk.is_traded && pk.original_team !== teamId && (
                    <div style={{fontSize:10,color:"var(--ac)",background:"rgba(79,195,247,.06)",padding:"3px 6px",borderRadius:3}}>
                      via {(gT(pk.original_team)?.abbr||pk.original_team||'').toUpperCase()}
                      {pk.acquired_via ? ` · ${pk.acquired_via}` : ""}
                    </div>
                  )}
                  {!pk.player_name && !pk.is_traded && pk.original_team===teamId && (
                    <div style={{fontSize:10,color:"var(--text3)"}}>Own pick</div>
                  )}
                  {!pk.player_name && !pk.is_traded && pk.original_team!==teamId && (
                    <div style={{fontSize:10,color:"var(--ac)"}}>
                      Acquired from {(gT(pk.original_team)?.abbr||pk.original_team||'').toUpperCase()}
                      {pk.acquired_via ? ` · ${pk.acquired_via}` : ""}
                    </div>
                  )}
                  {!pk.player_name && pk.is_traded && pk.original_team===teamId && (
                    <div style={{fontSize:10,color:"var(--ye)",background:"rgba(245,200,66,.06)",padding:"3px 6px",borderRadius:3}}>
                      Traded to {(gT(pk.current_owner)?.abbr||'').toUpperCase()}
                      {pk.acquired_via ? ` · ${pk.acquired_via}` : ""}
                    </div>
                  )}
                </div>
              );})}
              {draftPicks.filter(pk=>pk.year===pickYear).length===0&&(
                <div style={{fontSize:12,color:"var(--text3)",padding:"8px 0"}}>No picks for {pickYear}</div>
              )}
            </div>
          </div>
        )}
        {tab==="trades"&&(()=>{
          const seasons=[...new Set(trades.map(t=>t.season||'Unknown'))].sort((a,b)=>b.localeCompare(a));
          return(
          <div>
            <div style={{padding:"10px 12px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid var(--border)"}}>
              <span style={{fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)"}}>
                Trade History
              </span>
              <select className="sel" value={tradeYear} onChange={e=>setTradeYear(e.target.value)} style={{fontSize:12}}>
                <option value="all">All Years</option>
                {seasons.map(s=><option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div style={{padding:"10px 12px"}}>
              {trades.filter(tr=>tradeYear==='all'||tr.season===tradeYear).length===0&&(
                <div style={{fontSize:12,color:"var(--text3)",padding:"8px 0"}}>No trades on record</div>
              )}
              {(()=>{
                const filtered=trades.filter(tr=>tradeYear==='all'||tr.season===tradeYear);
                const bySeason={};
                filtered.forEach(tr=>{
                  const s=tr.season||'Unknown';
                  if(!bySeason[s]) bySeason[s]=[];
                  bySeason[s].push(tr);
                });
                const linkPlayers=(text)=>{
                  if(!text||text==='—') return <span style={{color:"var(--text3)"}}>—</span>;
                  const parts=text.split(',').map(s=>s.trim());
                  return parts.map((part,i)=>{
                    const cleanName=part.replace(/\s*\(.*?\)\s*/g,'').trim();
                    const norm=s=>(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
                    const match=_PLAYERS.find(p=>norm(p.name)===norm(cleanName));
                    return(
                      <span key={i}>
                        {i>0&&<span style={{color:"var(--text3)"}}>, </span>}
                        {match
                          ? <span style={{color:"var(--ac)",cursor:"pointer",fontWeight:500}} onClick={()=>onPlayer(match.id)}>{part}</span>
                          : <span>{part}</span>}
                      </span>
                    );
                  });
                };
                return Object.entries(bySeason).sort((a,b)=>b[0].localeCompare(a[0])).map(([season,trs])=>(
                  <div key={season} style={{marginBottom:16}}>
                    {tradeYear==='all'&&(
                      <div style={{fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)",marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                        {season}<div style={{flex:1,height:1,background:"var(--border)"}}/>
                      </div>
                    )}
                    {trs.map((tr,i)=>{
                      const isTeam1=tr.team1===teamId;
                      const otherTeam=isTeam1?gT(tr.team2):gT(tr.team1);
                      const acquired=isTeam1?tr.team2_sends:tr.team1_sends;
                      const gave=isTeam1?tr.team1_sends:tr.team2_sends;
                      const d=new Date(tr.trade_date);
                      const dateStr=d.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
                      return(
                        <div key={i} style={{background:"var(--bg3)",borderRadius:6,padding:"10px 12px",marginBottom:6,border:"1px solid var(--border)"}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                            <span style={{fontFamily:"var(--fm)",fontSize:12,fontWeight:600,color:tColor(otherTeam)}}>
                              Trade with {otherTeam?.name||tr.team2}
                            </span>
                            <span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)"}}>{dateStr}</span>
                          </div>
                          <div style={{display:"flex",gap:16,fontSize:12}}>
                            <div style={{flex:1}}>
                              <div style={{fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1px",textTransform:"uppercase",color:"var(--gr)",marginBottom:3}}>Acquired</div>
                              <div style={{color:"var(--text)"}}>{linkPlayers(acquired)}</div>
                            </div>
                            <div style={{flex:1}}>
                              <div style={{fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1px",textTransform:"uppercase",color:"var(--rd)",marginBottom:3}}>Traded Away</div>
                              <div style={{color:"var(--text)"}}>{linkPlayers(gave)}</div>
                            </div>
                          </div>
                          {tr.notes&&<div style={{fontSize:10,color:"var(--text3)",marginTop:4}}>{tr.notes}</div>}
                        </div>
                      );
                    })}
                  </div>
                ));
              })()}
            </div>
          </div>);
        })()}
      </div>
      <div className="crd">
        <div className="crd-h"><span className="crd-t">Cap by Position</span></div>
        <div style={{padding:"12px 14px",display:"flex",flexDirection:"column",gap:9}}>
          {["F","D","G"].map(pos=>{
            const grp=activePlayers.filter(p=>p.pos===pos),s=grp.reduce((a,p)=>a+p.sal,0);
            return(
              <div key={pos}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}>
                  <span style={{color:"var(--text3)"}}>{pos==="F"?"Forwards":pos==="D"?"Defence":"Goalies"}</span>
                  <span style={{fontFamily:"var(--fm)",fontSize:11}}>{fmt(s)} <span style={{color:"var(--text3)"}}>· {grp.length}p</span></span>
                </div>
                <CapBar spent={s} cap={CAP_LIMIT} h={3}/>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
 
function PlayerPage({players,playerId,onBack,backLabel}){
  const p=gP(playerId);
  const t=gT(p.team);
  const [season,setSeason]=useState("2025-26");
  const [allStats,setAllStats]=useState([]);
  const [availableSeasons,setAvailableSeasons]=useState(["2025-26"]);
  const isG=p.pos==="G";
 
  useEffect(()=>{
    const table = isG ? "stats_goalies" : "stats_skaters";
    supabase.from(table).select("*").eq("player_id", p.id).order("season", {ascending:false})
      .then(({data})=>{
        if(data && data.length > 0) {
          const deduped = [];
          const seen = new Map();
          for (const row of data) {
            const team = row.team_id || row.team_name || '';
            const key = `${row.season}|${team}`;
            if (!seen.has(key)) {
              seen.set(key, row);
            } else {
              const existing = seen.get(key);
              if ((row.gp || 0) > (existing.gp || 0)) {
                seen.set(key, row);
              }
            }
          }
          deduped.push(...seen.values());

          setAllStats(deduped);
          const seasons = [...new Set(deduped.map(s=>s.season))];
          seasons.sort((a,b)=>{
            const aPlay = a.includes("playoff");
            const bPlay = b.includes("playoff");
            const aYear = a.replace("-playoffs","").replace("-playoff","");
            const bYear = b.replace("-playoffs","").replace("-playoff","");
            if(aYear !== bYear) return bYear.localeCompare(aYear);
            return aPlay ? 1 : -1;
          });
          setAvailableSeasons(["Career", ...seasons]);
          const firstRegular = seasons.find(s => !s.includes("playoff"));
          if(firstRegular) setSeason(firstRegular);
        }
      });
  },[p.id]);
 
  const seasonRows = season === "Career" ? [] : allStats.filter(s=>s.season===season);
  const currentStats = seasonRows.length > 0 ? seasonRows[0] : null;
  
  const regularStats = allStats.filter(s=>!s.season.includes("playoff"));
  const playoffStats = allStats.filter(s=>s.season.includes("playoff"));

  const buildCareer = (rows) => {
    if (!rows.length) return null;
    if (isG) return {
      gp: rows.reduce((a,s)=>a+(s.gp||0),0),
      w:  rows.reduce((a,s)=>a+(s.w||0),0),
      l:  rows.reduce((a,s)=>a+(s.l||0),0),
      otl:rows.reduce((a,s)=>a+(s.otl||0),0),
      so: rows.reduce((a,s)=>a+(s.so||0),0),
      ga: rows.reduce((a,s)=>a+(s.ga||0),0),
      gaa: +(rows.reduce((a,s)=>a+(s.gaa||0),0)/rows.length).toFixed(2),
      sv_pct: +(rows.reduce((a,s)=>a+(s.sv_pct||0),0)/rows.length).toFixed(3),
    };
    const totalShots = rows.reduce((a,s)=>a+(s.shots||0),0);
    const totalGoals = rows.reduce((a,s)=>a+(s.g||0),0);
    return {
      gp:  rows.reduce((a,s)=>a+(s.gp||0),0),
      g:   totalGoals,
      a:   rows.reduce((a,s)=>a+(s.a||0),0),
      pts: rows.reduce((a,s)=>a+((s.g||0)+(s.a||0)),0),
      plus_minus: rows.reduce((a,s)=>a+(s.plus_minus||0),0),
      pim: rows.reduce((a,s)=>a+(s.pim||0),0),
      shots: totalShots,
      pp_g: rows.reduce((a,s)=>a+(s.pp_g||0),0),
      pp_a: rows.reduce((a,s)=>a+(s.pp_a||0),0),
      sh_g: rows.reduce((a,s)=>a+(s.sh_g||0),0),
      sh_a: rows.reduce((a,s)=>a+(s.sh_a||0),0),
      hits: rows.reduce((a,s)=>a+(s.hits||0),0),
      blocks: rows.reduce((a,s)=>a+(s.blocks||0),0),
      fo_w: rows.reduce((a,s)=>a+(s.fo_w||0),0),
      fo_att: rows.reduce((a,s)=>a+(s.fo_att||0),0),
      shot_pct: (totalShots < totalGoals || totalShots === 0) ? null : +((totalGoals/totalShots)*100).toFixed(1),
    };
  };
  const careerStats = buildCareer(regularStats);
  const careerPlayoffStats = buildCareer(playoffStats);
 
  const displayStats = season==="Career" ? careerStats : currentStats;
  const stats = displayStats;
  const hasStats = !!stats;

  const getTeamForStat = (statRow) => {
    if(statRow?.team_id) return statRow.team_id;
    if(statRow?.team_name) {
      const code = statRow.team_name.toLowerCase().trim();
      const found = TEAMS.find(t => t.id === code || t.abbr.toLowerCase() === code);
      if(found) return found.id;
    }
    return p.team;
  };

  const currentYear=2026;
  const startYear=parseInt(p.exp)-p.yrs;
  const years=Array.from({length:p.yrs},(_,i)=>startYear+1+i);

  const fmtSeason = (s) => {
    if(s === "Career") return "Career";
    if(s.includes("playoff")) return s.replace("-playoffs","-PO").replace("-playoff","-PO");
    return s;
  };

  return(
    <div className="fu">
      <button className="back" onClick={onBack}>← {backLabel||"Back"}</button>
 
      <div className="player-hero" style={{borderLeft:`3px solid ${tColor(t)}`,position:"relative",overflow:"hidden",minHeight:120,paddingRight:100}}>
        {t.logo&&<img src={t.logo} alt="" style={{position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",width:260,height:260,objectFit:"contain",opacity:0.12,pointerEvents:"none",userSelect:"none"}} />}
        <div className="p-num-bg">#{p.num}</div>
        {p.photoUrl&&(
          <div className="player-photo-wrap">
            <img className="player-photo-img" src={p.photoUrl} alt={p.name} onError={e=>{e.target.style.display="none"}}/>
          </div>
        )}
        <div style={{display:"flex",gap:6,marginBottom:8,alignItems:"center",flexWrap:"wrap"}}>
          <Badge type={p.pos}/>
          <span className={`slot-sc ${scls(p.status)}`} style={{padding:"2px 8px",borderRadius:3,fontFamily:"var(--fm)",fontSize:10,fontWeight:600}}>{p.status}</span>
          {p.clause!=="—"&&<span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--ye)",background:"rgba(245,200,66,.08)",padding:"2px 6px",borderRadius:3}}>⚠ {p.clause}</span>}
          {p.isEstimate&&<span style={{fontFamily:"var(--fm)",fontSize:9,color:"var(--text3)",background:"var(--bg4)",padding:"2px 5px",borderRadius:3,border:"1px solid var(--border)"}}>est. min</span>}
          {p.source&&!p.isEstimate&&p.source.includes('THN')&&<span style={{fontFamily:"var(--fm)",fontSize:9,color:"var(--ac)",background:"rgba(79,195,247,.08)",padding:"2px 5px",borderRadius:3}}>verified</span>}
        </div>
        <div className="p-name">{p.name}<InjuryBadge player={p}/></div>
        <div className="p-sub">
          <span style={{color:tColor(t),fontWeight:600}}>{t.name}</span>
          <span>·</span><span>{p.sub}</span>
          <span>·</span><span style={{fontFamily:"var(--fm)"}}>#{p.num}</span>
          {p.ht&&<><span>·</span><span>H {p.ht}</span></>}
          {p.wt&&<><span>·</span><span>W {p.wt} lbs</span></>}
          {p.shoots&&<><span>·</span><span>{isG?"CATCHES":"SHOOTS"} {p.shoots}</span></>}
        </div>
        <div style={{marginBottom:10,maxWidth:260}}>
          <div style={{display:"flex",gap:3,marginBottom:3}}>
            {years.map((yr,i)=>{
              const cur=yr===currentYear,past=yr<currentYear;
              return <div key={yr} style={{flex:1,height:6,borderRadius:3,background:past?"var(--bg5)":cur?"var(--gr)":"rgba(67,217,140,.25)",boxShadow:cur?"0 0 6px rgba(67,217,140,.4)":undefined}}/>;
            })}
          </div>
          <div style={{display:"flex",gap:3}}>
            {years.map(yr=>(
              <div key={yr} style={{flex:1,fontSize:8,fontFamily:"var(--fm)",color:yr===currentYear?"var(--gr)":"var(--text3)",textAlign:"center",fontWeight:yr===currentYear?700:400}}>
                {yr-1}-{String(yr).slice(2)}
              </div>
            ))}
          </div>
        </div>
        {p.dob&&<div style={{fontSize:12,color:"var(--text3)",marginBottom:8}}>
          Birthday: {new Date(p.dob).toLocaleDateString("en-CA",{month:"long",day:"numeric",year:"numeric"})} · Age {Math.floor((new Date()-new Date(p.dob))/(365.25*24*60*60*1000))}
        </div>}
        <div className="p-stats-row">
          {[
            {l:"Cap Hit",    v:fmtSal(p).text,                    c:fmtSal(p).color},
            {l:"Contract",   v:`Year ${Math.min(p.yrs, Math.max(1, currentYear-(parseInt(p.exp)-p.yrs)))} of ${p.yrs}`,      c:"var(--text)"},
            {l:"Expires",    v:p.exp,                               c:"var(--text2)"},
            {l:"Status",     v:p.status,                            c:p.status==="UFA"?"var(--rd)":p.status==="RFA"?"var(--ye)":"var(--gr)"},
          ].map(s=>(
            <div key={s.l} className="pstat">
              <div className="pstat-l">{s.l}</div>
              <div className="pstat-v" style={{color:s.c,fontSize:14}}>{s.v}</div>
            </div>
          ))}
        </div>
      </div>
 
      <div className="pdgrid" style={{marginBottom:14}}>
        <div className="pcc">
          <span className="slbl">Profile</span>
          {[
            {k:"Date of Birth", v:p.dob?new Date(p.dob).toLocaleDateString("en-CA",{month:"long",day:"numeric",year:"numeric"}):"—"},
            {k:"Age",           v:p.dob?Math.floor((new Date()-new Date(p.dob))/(365.25*24*60*60*1000)):(p.age||"—")},
            {k:"Height",        v:p.ht||"—"},
            {k:isG?"Catches":"Shoots", v:p.shoots||"—"},
            {k:"Birthplace",    v:p.hometown||"—"},
            {k:"Nationality",   v:p.nationality||"—"},
          ].map(r=>(
            <div key={r.k} className="pcc-r"><span className="pcc-k">{r.k}</span><span className="pcc-v">{r.v}</span></div>
          ))}
        </div>
        <div className="pcc">
          <span className="slbl">Contract Details</span>
          {[
            {k:"Cap Hit",    v:fmtSal(p).text, style:{color:fmtSal(p).color}},
            {k:"Term",       v:`${p.yrs} year${p.yrs!==1?"s":""}`},
            {k:"Expires",    v:p.exp},
            {k:"Status",     v:p.status},
            {k:"Clause",     v:p.clause},
            {k:"Agent",      v:p.agent||"—"},
            {k:"Team",       v:t.name},
            {k:"Source",     v:p.isEstimate?"est. minimum - undisclosed":p.source?.match(/\[(.*?)\]/)?.[1]||"Disclosed"},
          ].map(r=>(
            <div key={r.k} className="pcc-r">
              <span className="pcc-k">{r.k}</span>
              <span className="pcc-v" style={{...r.style,color:r.style?.color||(r.k==="Source"?(p.isEstimate?"var(--text3)":"var(--ac)"):undefined),fontSize:r.k==="Source"?10:undefined}}>{r.v}</span>
            </div>
          ))}
        </div>
      </div>
 
      <div className="crd" style={{marginBottom:14}}>
        <div className="crd-h">
          <span className="crd-t">Stats</span>
          <select className="sel" value={season} onChange={e=>setSeason(e.target.value)} style={{fontSize:11}}>
            {availableSeasons.map(s=>(
              <option key={s} value={s}>{fmtSeason(s)}</option>
            ))}
          </select>
        </div>

        {season !== "Career" && (
          <div className="tbl-scroll">
            {!hasStats ? (
              <div style={{padding:"20px 14px",textAlign:"center",color:"var(--text3)",fontFamily:"var(--fm)",fontSize:12}}>
                No stats available for {fmtSeason(season)}
              </div>
            ) : isG ? (
              <table className="pstats-tbl">
                <thead><tr>
                  <th className="season-col">Season</th><th className="team-col">Team</th>
                  <th className="stat-col">GP</th><th className="stat-col">W</th><th className="stat-col">L</th><th className="stat-col">OTL</th>
                  <th className="stat-col">GA</th><th className="stat-col">GAA</th><th className="stat-col">SVS</th><th className="stat-col">SA</th>
                  <th className="stat-col-wide">SV%</th><th className="stat-col">SO</th><th className="stat-col-wide">MIN</th><th className="stat-col-wide">SO%</th>
                </tr></thead>
                <tbody>{seasonRows.map((sr,ri)=>{
                  const tid=getTeamForStat(sr);const tm=gT(tid);
                  return(<tr key={ri}>
                  <td className="pstats-season season-col">{fmtSeason(season)}</td>
                  <td className="team-col">{tm?<span className="pstats-team-badge" style={{color:tColor(tm)}}>{tm.abbr}</span>:"—"}</td>
                  <td className="m b">{sr.gp}</td><td className="m">{sr.w||0}</td><td className="m">{sr.l||0}</td><td className="m">{sr.otl||0}</td>
                  <td className="m">{sr.ga||0}</td>
                  <td className="m" style={{color:(sr.gaa||0)<2.2?"var(--gr)":(sr.gaa||0)<2.8?"var(--ye)":"var(--rd)"}}>{sr.gaa||0}</td>
                  <td className="m">{sr.svs||0}</td><td className="m">{sr.sa||0}</td>
                  <td className="m" style={{color:(sr.sv_pct||0)>=.92?"var(--gr)":(sr.sv_pct||0)>=.90?"var(--ye)":"var(--rd)"}}>
                    {(sr.sv_pct||0)>0 ? `.${Math.round((sr.sv_pct)*1000)}` : "—"}
                  </td>
                  <td className="m">{sr.so||0}</td><td className="m">{sr.min||"—"}</td><td className="m">{sr.so_pct ? sr.so_pct.toFixed(3) : "—"}</td>
                </tr>);})}</tbody>
              </table>
            ) : (
              <table className="pstats-tbl">
                <thead><tr>
                  <th className="season-col">Season</th><th className="team-col">Team</th>
                  <th className="stat-col">GP</th><th className="stat-col">G</th><th className="stat-col">A</th><th className="stat-col">PTS</th>
                  <th className="stat-col">+/-</th><th className="stat-col">PIM</th><th className="stat-col">FOW</th><th className="stat-col">FO</th>
                  <th className="stat-col-wide">FO%</th><th className="stat-col">PPG</th><th className="stat-col">PPA</th><th className="stat-col">SHG</th>
                  <th className="stat-col">SHA</th><th className="stat-col">BLK</th><th className="stat-col">HIT</th><th className="stat-col">SOG</th>
                  <th className="stat-col-wide">SH%</th><th className="stat-col-wide">TOI/G</th>
                </tr></thead>
                <tbody>{seasonRows.map((sr,ri)=>{
                  const tid=getTeamForStat(sr);const tm=gT(tid);
                  return(<tr key={ri}>
                  <td className="pstats-season season-col">{fmtSeason(season)}</td>
                  <td className="team-col">{tm?<span className="pstats-team-badge" style={{color:tColor(tm)}}>{tm.abbr}</span>:"—"}</td>
                  <td className="m b">{sr.gp}</td><td className="m">{sr.g}</td><td className="m">{sr.a}</td>
                  <td className="m" style={{color:"var(--ac)",fontWeight:700}}>{(sr.g||0)+(sr.a||0)}</td>
                  <td className="m" style={{color:(sr.plus_minus||0)>=0?"var(--gr)":"var(--rd)"}}>{(sr.plus_minus||0)>=0?"+":""}{sr.plus_minus||0}</td>
                  <td className="m">{sr.pim||0}</td><td className="m">{sr.fo_w||0}</td><td className="m">{sr.fo_att||0}</td>
                  <td className="m">{sr.fo_pct ? `${sr.fo_pct}%` : "—"}</td>
                  <td className="m">{sr.pp_g||0}</td><td className="m">{sr.pp_a||0}</td><td className="m">{sr.sh_g||0}</td><td className="m">{sr.sh_a||0}</td>
                  <td className="m">{sr.blocks||0}</td><td className="m">{sr.hits||0}</td><td className="m">{sr.shots||0}</td>
                  <td className="m">{sr.shot_pct != null ? `${sr.shot_pct}%` : "—"}</td>
                  <td className="m">{sr.toi_pg||"—"}</td>
                </tr>);})}</tbody>
              </table>
            )}
          </div>
        )}

        {season === "Career" && (
          <div className="tbl-scroll">
            {allStats.length === 0 ? (
              <div style={{padding:"20px 14px",textAlign:"center",color:"var(--text3)",fontFamily:"var(--fm)",fontSize:12}}>
                No career stats available
              </div>
            ) : isG ? (
              <table className="pstats-tbl">
                <thead><tr>
                  <th className="season-col">Season</th><th className="team-col">Team</th>
                  <th className="stat-col">GP</th><th className="stat-col">W</th><th className="stat-col">L</th><th className="stat-col">OTL</th>
                  <th className="stat-col">GA</th><th className="stat-col">GAA</th><th className="stat-col">SVS</th><th className="stat-col">SA</th>
                  <th className="stat-col-wide">SV%</th><th className="stat-col">SO</th><th className="stat-col-wide">MIN</th><th className="stat-col-wide">SO%</th>
                </tr></thead>
                <tbody>
                  {allStats.map((s,i)=>{
                    const isPlayoff = s.season.includes("playoff");
                    const tid = getTeamForStat(s); const tm = gT(tid);
                    return(
                      <tr key={i} className={isPlayoff?"pstats-playoff":""}>
                        <td className={`pstats-season season-col${isPlayoff?" pstats-playoff":""}`}>{fmtSeason(s.season)}</td>
                        <td className="team-col">{tm?<span className="pstats-team-badge" style={{color:tColor(tm)}}>{tm.abbr}</span>:"—"}</td>
                        <td className="m">{s.gp}</td><td className="m">{s.w||0}</td><td className="m">{s.l||0}</td><td className="m">{s.otl||0}</td>
                        <td className="m">{s.ga||0}</td>
                        <td className="m" style={{color:(s.gaa||0)<2.2?"var(--gr)":(s.gaa||0)<2.8?"var(--ye)":"var(--rd)"}}>{s.gaa||0}</td>
                        <td className="m">{s.svs||0}</td><td className="m">{s.sa||0}</td>
                        <td className="m" style={{color:(s.sv_pct||0)>=.92?"var(--gr)":(s.sv_pct||0)>=.90?"var(--ye)":"var(--rd)"}}>
                          {(s.sv_pct||0)>0 ? `.${Math.round((s.sv_pct)*1000)}` : "—"}
                        </td>
                        <td className="m">{s.so||0}</td><td className="m">{s.min||"—"}</td><td className="m">{s.so_pct ? s.so_pct.toFixed(3) : "—"}</td>
                      </tr>
                    );
                  })}
                  {careerStats && (
                    <tr className="pstats-career">
                      <td className="season-col" style={{fontWeight:700}}>Career</td><td className="team-col">—</td>
                      <td className="m">{careerStats.gp}</td><td className="m">{careerStats.w}</td><td className="m">{careerStats.l}</td><td className="m">{careerStats.otl}</td>
                      <td className="m">{careerStats.ga||0}</td>
                      <td className="m" style={{color:(careerStats.gaa||0)<2.2?"var(--gr)":(careerStats.gaa||0)<2.8?"var(--ye)":"var(--rd)"}}>{careerStats.gaa}</td>
                      <td className="m">—</td><td className="m">—</td>
                      <td className="m" style={{color:(careerStats.sv_pct||0)>=.92?"var(--gr)":(careerStats.sv_pct||0)>=.90?"var(--ye)":"var(--rd)"}}>
                        {(careerStats.sv_pct||0)>0 ? `.${Math.round((careerStats.sv_pct)*1000)}` : "—"}
                      </td>
                      <td className="m">{careerStats.so}</td><td className="m">—</td><td className="m">—</td>
                    </tr>
                  )}
                  {careerPlayoffStats && (
                    <tr className="pstats-career" style={{opacity:0.8}}>
                      <td className="season-col pstats-playoff" style={{fontWeight:700}}>Playoffs</td><td className="team-col">—</td>
                      <td className="m">{careerPlayoffStats.gp}</td><td className="m">{careerPlayoffStats.w}</td><td className="m">{careerPlayoffStats.l}</td><td className="m">{careerPlayoffStats.otl}</td>
                      <td className="m">{careerPlayoffStats.ga||0}</td>
                      <td className="m" style={{color:(careerPlayoffStats.gaa||0)<2.2?"var(--gr)":(careerPlayoffStats.gaa||0)<2.8?"var(--ye)":"var(--rd)"}}>{careerPlayoffStats.gaa}</td>
                      <td className="m">—</td><td className="m">—</td>
                      <td className="m" style={{color:(careerPlayoffStats.sv_pct||0)>=.92?"var(--gr)":(careerPlayoffStats.sv_pct||0)>=.90?"var(--ye)":"var(--rd)"}}>
                        {(careerPlayoffStats.sv_pct||0)>0 ? `.${Math.round((careerPlayoffStats.sv_pct)*1000)}` : "—"}
                      </td>
                      <td className="m">{careerPlayoffStats.so}</td><td className="m">—</td><td className="m">—</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              <table className="pstats-tbl">
                <thead><tr>
                  <th className="season-col">Season</th><th className="team-col">Team</th>
                  <th className="stat-col">GP</th><th className="stat-col">G</th><th className="stat-col">A</th><th className="stat-col">PTS</th>
                  <th className="stat-col">+/-</th><th className="stat-col">PIM</th><th className="stat-col">FOW</th><th className="stat-col">FO</th>
                  <th className="stat-col-wide">FO%</th><th className="stat-col">PPG</th><th className="stat-col">PPA</th><th className="stat-col">SHG</th>
                  <th className="stat-col">SHA</th><th className="stat-col">BLK</th><th className="stat-col">HIT</th><th className="stat-col">SOG</th>
                  <th className="stat-col-wide">SH%</th><th className="stat-col-wide">TOI/G</th>
                </tr></thead>
                <tbody>
                  {allStats.map((s,i)=>{
                    const isPlayoff = s.season.includes("playoff");
                    const tid = getTeamForStat(s); const tm = gT(tid);
                    const pts = (s.g||0)+(s.a||0);
                    return(
                      <tr key={i} className={isPlayoff?"pstats-playoff":""}>
                        <td className={`pstats-season season-col${isPlayoff?" pstats-playoff":""}`}>{fmtSeason(s.season)}</td>
                        <td className="team-col">{tm?<span className="pstats-team-badge" style={{color:tColor(tm)}}>{tm.abbr}</span>:"—"}</td>
                        <td className="m">{s.gp}</td><td className="m">{s.g}</td><td className="m">{s.a}</td>
                        <td className="m" style={{color:"var(--ac)",fontWeight:700}}>{pts}</td>
                        <td className="m" style={{color:(s.plus_minus||0)>=0?"var(--gr)":"var(--rd)"}}>{(s.plus_minus||0)>=0?"+":""}{s.plus_minus||0}</td>
                        <td className="m">{s.pim||0}</td><td className="m">{s.fo_w||0}</td><td className="m">{s.fo_att||0}</td>
                        <td className="m">{s.fo_pct ? `${s.fo_pct}%` : "—"}</td>
                        <td className="m">{s.pp_g||0}</td><td className="m">{s.pp_a||0}</td><td className="m">{s.sh_g||0}</td><td className="m">{s.sh_a||0}</td>
                        <td className="m">{s.blocks||0}</td><td className="m">{s.hits||0}</td><td className="m">{s.shots||0}</td>
                        <td className="m">{s.shot_pct != null ? `${s.shot_pct}%` : "—"}</td>
                        <td className="m">{s.toi_pg||"—"}</td>
                      </tr>
                    );
                  })}
                  {careerStats && (
                    <tr className="pstats-career">
                      <td className="season-col" style={{fontWeight:700}}>Career</td><td className="team-col">—</td>
                      <td className="m">{careerStats.gp}</td><td className="m">{careerStats.g}</td><td className="m">{careerStats.a}</td>
                      <td className="m" style={{color:"var(--ac)",fontWeight:700}}>{careerStats.pts}</td>
                      <td className="m" style={{color:(careerStats.plus_minus||0)>=0?"var(--gr)":"var(--rd)"}}>{(careerStats.plus_minus||0)>=0?"+":""}{careerStats.plus_minus||0}</td>
                      <td className="m">{careerStats.pim}</td><td className="m">{careerStats.fo_w||0}</td><td className="m">{careerStats.fo_att||0}</td>
                      <td className="m">—</td><td className="m">{careerStats.pp_g}</td><td className="m">{careerStats.pp_a||0}</td>
                      <td className="m">{careerStats.sh_g}</td><td className="m">{careerStats.sh_a||0}</td>
                      <td className="m">{careerStats.blocks||0}</td><td className="m">{careerStats.hits||0}</td><td className="m">{careerStats.shots}</td>
                      <td className="m">{careerStats.shot_pct != null ? `${careerStats.shot_pct}%` : "—"}</td>
                      <td className="m">—</td>
                    </tr>
                  )}
                  {careerPlayoffStats && (
                    <tr className="pstats-career" style={{opacity:0.8}}>
                      <td className="season-col pstats-playoff" style={{fontWeight:700}}>Playoffs</td><td className="team-col">—</td>
                      <td className="m">{careerPlayoffStats.gp}</td><td className="m">{careerPlayoffStats.g}</td><td className="m">{careerPlayoffStats.a}</td>
                      <td className="m" style={{color:"var(--ye)",fontWeight:700}}>{careerPlayoffStats.pts}</td>
                      <td className="m" style={{color:(careerPlayoffStats.plus_minus||0)>=0?"var(--gr)":"var(--rd)"}}>{(careerPlayoffStats.plus_minus||0)>=0?"+":""}{careerPlayoffStats.plus_minus||0}</td>
                      <td className="m">{careerPlayoffStats.pim}</td><td className="m">{careerPlayoffStats.fo_w||0}</td><td className="m">{careerPlayoffStats.fo_att||0}</td>
                      <td className="m">—</td><td className="m">{careerPlayoffStats.pp_g}</td><td className="m">{careerPlayoffStats.pp_a||0}</td>
                      <td className="m">{careerPlayoffStats.sh_g}</td><td className="m">{careerPlayoffStats.sh_a||0}</td>
                      <td className="m">{careerPlayoffStats.blocks||0}</td><td className="m">{careerPlayoffStats.hits||0}</td><td className="m">{careerPlayoffStats.shots}</td>
                      <td className="m">{careerPlayoffStats.shot_pct != null ? `${careerPlayoffStats.shot_pct}%` : "—"}</td>
                      <td className="m">—</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
 
      <div className="crd">
        <div className="crd-h"><span className="crd-t">Transaction History</span></div>
        {(p.transactions||[]).map((tx,i)=>(
          <div key={i} className="tx">
            <div className="tx-dot" style={{background:txCol(tx.type)}}/>
            <div style={{flex:1}}><div className="tx-type" style={{color:txCol(tx.type)}}>{tx.type}</div><div className="tx-detail">{tx.detail}</div></div>
            <div className="tx-date">{tx.date}</div>
          </div>
        ))}
        {(!p.transactions||p.transactions.length===0)&&(
          <div style={{padding:"14px",fontSize:12,color:"var(--text3)"}}>No transactions on record</div>
        )}
      </div>
    </div>
  );
}
 
 
function PlayersPage({players,skaterStats,goalieStats,onPlayer}){
  const [tab,setTab]=useState("contracts");
  const [q,setQ]=useState("");
  const [pos,setPos]=useState("All");
  const [tm,setTm]=useState("All");
  const [st,setSt]=useState("All");
  const [sort,setSort]=useState({col:"sal",dir:-1});
  const [season,setSeason]=useState("2025-26");
  const [dbSkaters,setDbSkaters]=useState([]);
  const [dbGoalies,setDbGoalies]=useState([]);
  const [availSeasons,setAvailSeasons]=useState(["2025-26"]);
  const [statsLoading,setStatsLoading]=useState(false);

  // Fetch available seasons
  useEffect(()=>{
    supabase.from('stats_skaters').select('season').then(({data})=>{
      if(data){
        const seasons=[...new Set(data.map(r=>r.season))].sort((a,b)=>{
          const aY=a.replace(/-playoffs?/,''), bY=b.replace(/-playoffs?/,'');
          if(aY!==bY) return bY.localeCompare(aY);
          return a.includes('playoff')?1:-1;
        });
        if(seasons.length) setAvailSeasons(seasons);
      }
    });
  },[]);

  // Fetch stats when season changes
  useEffect(()=>{
    if(tab==="contracts") return;
    setStatsLoading(true);
    Promise.all([
      supabase.from('stats_skaters').select('*,players(id,first_name,last_name,team_id,pos,sub_pos,num,photo_url)').eq('season',season),
      supabase.from('stats_goalies').select('*,players(id,first_name,last_name,team_id,pos,sub_pos,num,photo_url)').eq('season',season),
    ]).then(([skRes,gRes])=>{
      const sk=(skRes.data||[]).map(s=>{
        const p=s.players||{};
        const name=`${p.first_name||''} ${p.last_name||''}`.trim();
        const team=s.team_id||p.team_id||'';
        return{id:s.player_id,name,team,pos:p.pos||'F',sub:p.sub_pos||p.pos||'F',num:p.num,
          stats:{gp:s.gp||0,g:s.g||0,a:s.a||0,pts:(s.g||0)+(s.a||0),pm:s.plus_minus||0,pim:s.pim||0,
            shots:s.shots||0,spct:s.shot_pct||0,ppg:s.pp_g||0,shg:s.sh_g||0,gwg:s.gw_g||0}};
      });
      const gl=(gRes.data||[]).map(s=>{
        const p=s.players||{};
        const name=`${p.first_name||''} ${p.last_name||''}`.trim();
        const team=s.team_id||p.team_id||'';
        return{id:s.player_id,name,team,pos:'G',num:p.num,
          stats:{gp:s.gp||0,w:s.w||0,l:s.l||0,otl:s.otl||0,ga:s.ga||0,
            gaa:s.gaa||0,svp:s.sv_pct||0,so:s.so||0}};
      });
      setDbSkaters(sk);
      setDbGoalies(gl);
      setStatsLoading(false);
    });
  },[season,tab]);

  const tg=col=>setSort(s=>s.col===col?{...s,dir:-s.dir}:{col,dir:-1});

  // Contract rows
  const contractRows=useMemo(()=>{
    let arr=players.filter(p=>{
      if(q&&!p.name.toLowerCase().includes(q.toLowerCase())) return false;
      if(pos!=="All"&&p.pos!==pos) return false;
      if(tm!=="All"&&p.team!==tm) return false;
      if(st!=="All"&&p.status!==st) return false;
      return true;
    });
    arr.sort((a,b)=>sort.col==="name"?sort.dir*a.name.localeCompare(b.name):sort.dir*((a[sort.col]||0)-(b[sort.col]||0)));
    return arr;
  },[players,q,pos,tm,st,sort]);

  // Stats rows
  const filtStats=(arr)=>arr.filter(p=>(!q||p.name.toLowerCase().includes(q.toLowerCase()))&&(tm==="All"||p.team===tm));
  const sortStats=(arr)=>[...arr].sort((a,b)=>{const av=a.stats[sort.col]??0,bv=b.stats[sort.col]??0;return sort.dir*(typeof av==="string"?av.localeCompare(bv):av-bv);});
  const filtS=useMemo(()=>sortStats(filtStats(dbSkaters)),[dbSkaters,q,tm,sort]);
  const filtG=useMemo(()=>filtStats(dbGoalies).sort((a,b)=>sort.dir*((b.stats.w||0)-(a.stats.w||0))),[dbGoalies,q,tm,sort]);

  const Th=({col,right,children})=>(
    <th className={right?"r":""} onClick={()=>tg(col)} style={{color:sort.col===col?"var(--ac)":undefined}}>
      {children}{sort.col===col?(sort.dir===-1?" ↓":" ↑"):""}
    </th>
  );

  const handleTab=(t)=>{
    setTab(t);
    if(t==="contracts") setSort({col:"sal",dir:-1});
    else if(t==="skaters") setSort({col:"pts",dir:-1});
    else if(t==="goalies") setSort({col:"w",dir:-1});
  };

  const fmtS=s=>s.includes("playoff")?s.replace("-playoffs","-PO").replace("-playoff","-PO"):s;
  const count=tab==="contracts"?contractRows.length:tab==="skaters"?filtS.length:filtG.length;

  return(
    <div className="fu">
      <div className="ph"><h1>Players</h1><span className="ph-sub">{count} results</span></div>
      <div className="crd">
        <div className="stats-toolbar">
          <div className="tab-group">
            <button className={`tab-btn ${tab==="contracts"?"on":""}`} onClick={()=>handleTab("contracts")}>Contracts</button>
            <button className={`tab-btn ${tab==="skaters"?"on":""}`} onClick={()=>handleTab("skaters")}>Skaters</button>
            <button className={`tab-btn ${tab==="goalies"?"on":""}`} onClick={()=>handleTab("goalies")}>Goalies</button>
          </div>
          <input className="ts" placeholder="Search players..." value={q} onChange={e=>setQ(e.target.value)} style={{maxWidth:200,minWidth:100,flex:"unset"}}/>
          {tab==="contracts"&&<select className="sel" value={pos} onChange={e=>setPos(e.target.value)}><option>All</option><option>F</option><option>D</option><option>G</option></select>}
          <select className="sel" value={tm} onChange={e=>setTm(e.target.value)}><option value="All">All Teams</option>{TEAMS.map(t=><option key={t.id} value={t.id}>{t.abbr}</option>)}</select>
          {tab==="contracts"&&<select className="sel" value={st} onChange={e=>setSt(e.target.value)}><option>All</option><option>Signed</option><option>RFA</option><option>UFA</option></select>}
          {tab!=="contracts"&&<select className="yr-sel" value={season} onChange={e=>setSeason(e.target.value)}>{availSeasons.map(s=><option key={s} value={s}>{fmtS(s)}</option>)}</select>}
        </div>

        {/* CONTRACTS TAB */}
        {tab==="contracts"&&(
          <div className="tbl-scroll">
            <table>
              <thead><tr>
                <th style={{width:26}}>#</th><th>No.</th><Th col="name">Player</Th><th>Team</th><th>Pos</th>
                <Th col="age">Age</Th><Th col="sal" right>Salary</Th><th>Yrs</th><th>Exp</th>
                <th>Status</th><th>Clause</th><th>Agent</th>
              </tr></thead>
              <tbody>
                {contractRows.map((p,i)=>{
                  const t=gT(p.team);
                  return(
                    <tr key={p.id} onClick={()=>onPlayer(p.id)}>
                      <td className="m" style={{color:"var(--text3)"}}>{i+1}</td>
                      <td className="m" style={{color:"var(--text3)"}}>#{p.num}</td>
                      <td className="b" style={{color:"var(--ac)"}}>{p.name}<InjuryBadge player={p}/></td>
                      <td><span style={{fontFamily:"var(--fm)",fontSize:10,color:tColor(t),background:"var(--bg4)",padding:"1px 5px",borderRadius:3}}>{t.abbr}</span></td>
                      <td><Badge type={p.pos}/></td>
                      <td className="m">{p.age}</td>
                      <td className="sal-col" style={{color:fmtSal(p).color}}>{fmtSal(p).text}</td>
                      <td className="m">{p.yrs}y</td>
                      <td className="m">{p.exp}</td>
                      <td><Badge type={p.status}/></td>
                      <td style={{fontSize:11,color:"var(--text3)"}}>{p.clause}</td>
                      <td style={{fontSize:11,color:"var(--text3)"}}>{p.agent}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* SKATERS TAB */}
        {tab==="skaters"&&(
          <>
            {statsLoading&&<div style={{padding:"30px",textAlign:"center",color:"var(--text3)",fontFamily:"var(--fm)",fontSize:12}}>Loading stats…</div>}
            {!statsLoading&&<div className="tbl-scroll"><table>
              <thead><tr>
                <th style={{width:26}}>#</th><Th col="name">Player</Th><th>Team</th><th>Pos</th>
                <Th col="gp">GP</Th><Th col="g">G</Th><Th col="a">A</Th><Th col="pts" right>Pts</Th>
                <Th col="pm">+/-</Th><Th col="pim">PIM</Th><Th col="shots" right>SOG</Th>
                <Th col="spct" right>S%</Th><Th col="ppg">PPG</Th><Th col="shg">SHG</Th>
              </tr></thead>
              <tbody>
                {filtS.length===0&&<tr><td colSpan={14} style={{textAlign:"center",padding:20,color:"var(--text3)"}}>No stats for this season</td></tr>}
                {filtS.map((p,i)=>{const s=p.stats,t=gT(p.team);return(
                  <tr key={`${p.id}-${i}`} onClick={()=>onPlayer(p.id)}>
                    <td className="m" style={{color:"var(--text3)"}}>{i+1}</td>
                    <td className="b" style={{color:"var(--ac)"}}>{p.name}<InjuryBadge player={p}/></td>
                    <td>{t?<span style={{fontFamily:"var(--fm)",fontSize:10,color:tColor(t),background:"var(--bg4)",padding:"1px 5px",borderRadius:3}}>{t.abbr}</span>:"—"}</td>
                    <td><Badge type={p.pos}/></td>
                    <td className="m">{s.gp}</td><td className="m">{s.g}</td><td className="m">{s.a}</td>
                    <td className="m r" style={{color:"var(--ac)",fontWeight:600}}>{s.pts}</td>
                    <td className="m" style={{color:s.pm>=0?"var(--gr)":"var(--rd)"}}>{s.pm>=0?"+":""}{s.pm}</td>
                    <td className="m">{s.pim}</td><td className="m r">{s.shots}</td>
                    <td className="m r">{s.spct?s.spct+"%":"—"}</td>
                    <td className="m">{s.ppg}</td><td className="m">{s.shg}</td>
                  </tr>
                );})}
              </tbody>
            </table></div>}
          </>
        )}

        {/* GOALIES TAB */}
        {tab==="goalies"&&(
          <>
            {statsLoading&&<div style={{padding:"30px",textAlign:"center",color:"var(--text3)",fontFamily:"var(--fm)",fontSize:12}}>Loading stats…</div>}
            {!statsLoading&&<div className="tbl-scroll"><table>
              <thead><tr>
                <th style={{width:26}}>#</th><th>Goalie</th><th>Team</th>
                <th>GP</th><th>W</th><th>L</th><th>OTL</th>
                <th className="r">GA</th><th className="r">GAA</th><th className="r">SV%</th><th className="r">SO</th>
              </tr></thead>
              <tbody>
                {filtG.length===0&&<tr><td colSpan={11} style={{textAlign:"center",padding:20,color:"var(--text3)"}}>No stats for this season</td></tr>}
                {filtG.map((p,i)=>{const s=p.stats,t=gT(p.team);return(
                  <tr key={`${p.id}-${i}`} onClick={()=>onPlayer(p.id)}>
                    <td className="m" style={{color:"var(--text3)"}}>{i+1}</td>
                    <td className="b" style={{color:"var(--ac)"}}>{p.name}<InjuryBadge player={p}/></td>
                    <td>{t?<span style={{fontFamily:"var(--fm)",fontSize:10,color:tColor(t),background:"var(--bg4)",padding:"1px 5px",borderRadius:3}}>{t.abbr}</span>:"—"}</td>
                    <td className="m">{s.gp}</td>
                    <td className="m" style={{color:"var(--gr)",fontWeight:600}}>{s.w}</td>
                    <td className="m">{s.l}</td><td className="m">{s.otl}</td><td className="m r">{s.ga}</td>
                    <td className="m r" style={{color:s.gaa<2.2?"var(--gr)":s.gaa<2.8?"var(--ye)":"var(--rd)"}}>{s.gaa}</td>
                    <td className="m r" style={{color:s.svp>=.92?"var(--gr)":s.svp>=.90?"var(--ye)":"var(--rd)"}}>
                      {s.svp>0?`.${Math.round(s.svp*1000)}`:"—"}</td>
                    <td className="m r">{s.so}</td>
                  </tr>
                );})}
              </tbody>
            </table></div>}
          </>
        )}
      </div>
    </div>
  );
}
 
function TradePage({players}){
  const [tA,setTA]=useState("bos");const [tB,setTB]=useState("min");
  const [selA,setSelA]=useState([]);const [selB,setSelB]=useState([]);
  const [pkA,setPkA]=useState([]);const [pkB,setPkB]=useState([]);
  const [allPicks,setAllPicks]=useState([]);
  const [panelViewA,setPanelViewA]=useState("All");
  const [panelViewB,setPanelViewB]=useState("All");

  useEffect(()=>{
    supabase.from('draft_picks').select('*').gte('year',2026).order('year').order('round')
      .then(({data})=>{ if(data) setAllPicks(data); });
  },[]);

  const tog=(id,side)=>{if(side==="A")setSelA(s=>s.includes(id)?s.filter(x=>x!==id):[...s,id]);else setSelB(s=>s.includes(id)?s.filter(x=>x!==id):[...s,id]);};
  const togPk=(pkKey,side)=>{if(side==="A")setPkA(s=>s.includes(pkKey)?s.filter(x=>x!==pkKey):[...s,pkKey]);else setPkB(s=>s.includes(pkKey)?s.filter(x=>x!==pkKey):[...s,pkKey]);};
  const salA=selA.reduce((a,id)=>a+(gP(id)?.sal||0),0);
  const salB=selB.reduce((a,id)=>a+(gP(id)?.sal||0),0);
  const tAActive=players.filter(p=>p.team===tA&&p.hasPlayed);
  const tBActive=players.filter(p=>p.team===tB&&p.hasPlayed);
  const spentA=tAActive.reduce((a,p)=>a+p.sal,0);
  const spentB=tBActive.reduce((a,p)=>a+p.sal,0);
  const newA=spentA-salA+salB,newB=spentB-salB+salA;
  const spaceA=CAP_LIMIT-newA,spaceB=CAP_LIMIT-newB;
  const has=selA.length||selB.length||pkA.length||pkB.length;

  // Check NMC/NTC on selected players
  const nmcWarns=[];
  [...selA,...selB].forEach(id=>{
    const p=gP(id);
    if(p&&p.clause&&p.clause!=='—') nmcWarns.push(`${p.name} has ${p.clause}`);
  });

  const capOk=newA<=CAP_LIMIT&&newB<=CAP_LIMIT;
  const hasBothSides=(selA.length>0||pkA.length>0)&&(selB.length>0||pkB.length>0);

  // Position group renderer
  const PosGroup=({label,list,sel,side})=>{
    if(!list.length) return null;
    return(
      <>
        <div style={{padding:"6px 13px 3px",fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)",display:"flex",alignItems:"center",gap:8}}>
          {label}<div style={{flex:1,height:1,background:"var(--border)"}}/><span style={{fontSize:9}}>{list.length}</span>
        </div>
        {list.sort((a,b)=>b.sal-a.sal).map(p=>(
          <div key={p.id} className={`trpr ${sel.includes(p.id)?"on":""}`} onClick={()=>tog(p.id,side)}>
            <div style={{display:"flex",alignItems:"center",gap:8,flex:1,minWidth:0}}>
              {p.photoUrl
                ? <img src={p.photoUrl} alt="" style={{width:28,height:28,borderRadius:"50%",objectFit:"cover",objectPosition:"top center",flexShrink:0}} onError={e=>e.target.style.display="none"}/>
                : <div style={{width:28,height:28,borderRadius:"50%",background:"var(--bg5)",flexShrink:0}}/>
              }
              <div style={{minWidth:0}}>
                <div className="trpn" style={{display:"flex",alignItems:"center",gap:5}}>
                  <span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)"}}>#{p.num}</span>
                  <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</span>
                  {p.clause&&p.clause!=='—'&&<span style={{fontSize:8,color:"var(--ye)",fontFamily:"var(--fm)"}}>⚠{p.clause}</span>}
                </div>
                <div className="trpi">{p.sub||p.pos} · {p.yrs}yr · <span style={{color:p.status==="UFA"?"var(--rd)":p.status==="RFA"?"var(--ye)":"var(--gr)"}}>{p.status}</span></div>
              </div>
            </div>
            <div className="trps" style={{color:fmtSal(p).color,flexShrink:0}}>{fmtSal(p).text}</div>
          </div>
        ))}
      </>
    );
  };

  const Panel=({side})=>{
    const tid=side==="A"?tA:tB;
    const setT=side==="A"?(v=>{setTA(v);setSelA([]);setPkA([]);setPanelViewA("All")}):(v=>{setTB(v);setSelB([]);setPkB([]);setPanelViewB("All")});
    const teamPs=players.filter(p=>p.team===tid);
    const fwds=teamPs.filter(p=>p.pos==="F");
    const defs=teamPs.filter(p=>p.pos==="D");
    const goalies=teamPs.filter(p=>p.pos==="G");
    const sel=side==="A"?selA:selB;
    const picks=allPicks.filter(pk=>pk.current_owner===tid);
    const selPk=side==="A"?pkA:pkB;
    const other=side==="A"?tB:tA;
    const selCount=sel.length;
    const pkCount=selPk.length;
    const selSal=sel.reduce((a,id)=>a+(gP(id)?.sal||0),0);
    const tm=gT(tid);

    return(
      <div className="trpanel">
        <div className="trph">
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            {tm?.logo&&<img src={tm.logo} alt="" style={{width:18,height:18,objectFit:"contain"}}/>}
            <span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)"}}>{side==="A"?"TEAM A":"TEAM B"}</span>
          </div>
          <span style={{fontFamily:"var(--fm)",fontSize:10,color:selCount||pkCount?"var(--ac)":"var(--text3)"}}>{selCount}p · {pkCount}pk{selSal>0?` · ${fmt(selSal)}`:""}</span>
        </div>
        <div style={{padding:"0 9px"}}><select className="trsel" value={tid} onChange={e=>setT(e.target.value)}>{TEAMS.filter(t=>t.id!==other).map(t=><option key={t.id} value={t.id}>{t.name}</option>)}</select></div>

        {/* Single filter dropdown */}
        {(()=>{
          const view = side==="A" ? panelViewA : panelViewB;
          const setView = side==="A" ? setPanelViewA : setPanelViewB;
          return(
          <>
          <div style={{padding:"6px 9px",borderBottom:"1px solid var(--border)"}}>
            <select className="sel" value={view} onChange={e=>setView(e.target.value)} style={{width:"100%",fontSize:12,padding:"6px 8px"}}>
              <option value="All">All Players & Picks</option>
              <option value="F">Forwards ({fwds.length})</option>
              <option value="D">Defence ({defs.length})</option>
              <option value="G">Goalies ({goalies.length})</option>
              <option value="Picks">Draft Picks ({picks.length})</option>
            </select>
          </div>
          <div style={{maxHeight:520,overflowY:"auto"}}>
            {(view==="All"||view==="F")&&fwds.length>0&&<PosGroup label="Forwards" list={fwds} sel={sel} side={side}/>}
            {(view==="All"||view==="D")&&defs.length>0&&<PosGroup label="Defence" list={defs} sel={sel} side={side}/>}
            {(view==="All"||view==="G")&&goalies.length>0&&<PosGroup label="Goalies" list={goalies} sel={sel} side={side}/>}
            {(view==="All"||view==="Picks")&&(
              <>
                {view==="All"&&picks.length>0&&(
                  <div style={{padding:"6px 13px 3px",fontFamily:"var(--fm)",fontSize:9,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)",display:"flex",alignItems:"center",gap:8}}>
                    Draft Picks<div style={{flex:1,height:1,background:"var(--border)"}}/><span style={{fontSize:9}}>{picks.length}</span>
                  </div>
                )}
                {picks.length===0&&view==="Picks"&&<div style={{padding:"20px 13px",fontSize:12,color:"var(--text3)",textAlign:"center"}}>No future picks available</div>}
                {picks.map((pk,i)=>{
                  const pkKey=`${tid}-${pk.year}-${pk.round}-${i}`;
                  return(
                    <div key={pkKey} className={`trpr ${selPk.includes(pkKey)?"on":""}`} onClick={()=>togPk(pkKey,side)}>
                      <div>
                        <div className="trpn">{pk.year} Round {pk.round}</div>
                        <div className="trpi">{pk.original_team!==tid?`via ${(gT(pk.original_team)?.abbr||'').toUpperCase()}`:"Own pick"}</div>
                      </div>
                      <Badge type="Pick"/>
                    </div>
                  );
                })}
              </>
            )}
          </div>
          </>
          );
        })()}
      </div>
    );
  };

  // Helper to resolve picks from keys
  const resolvePicks = (selPk, tid) => {
    const teamPicks = allPicks.filter(pk=>pk.current_owner===tid);
    return selPk.map(key=>{
      const parts=key.split('-');
      const idx=parseInt(parts[3]);
      return teamPicks[idx] ? {...teamPicks[idx], _key:key} : null;
    }).filter(Boolean);
  };

  // Build rejection reasons
  const reasons = [];
  if(hasBothSides){
    if(newA>CAP_LIMIT) reasons.push(`${gT(tA)?.abbr} would be $${(newA-CAP_LIMIT).toLocaleString()} over the cap`);
    if(newB>CAP_LIMIT) reasons.push(`${gT(tB)?.abbr} would be $${(newB-CAP_LIMIT).toLocaleString()} over the cap`);
    nmcWarns.forEach(w=>reasons.push(`${w} — player must consent`));
  }
  const tradeOk = hasBothSides && capOk;

  return(
    <div className="fu">
      <div className="ph"><h1>Trade Simulator</h1><span className="ph-sub">Select players &amp; picks · check cap compliance</span></div>

      <div className="trlayout"><Panel side="A"/><div className="trarr">⇄</div><Panel side="B"/></div>

      {/* ── TRADE RESULT ── */}
      {has?(
        <div className="trresult">
          {/* Two-column trade offer */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:0,marginBottom:14,border:"1px solid var(--border)",borderRadius:6,overflow:"hidden"}}>

            {/* TEAM A sends */}
            {[{tid:tA,sel:selA,setSel:setSelA,selPk:pkA,setPk:setPkA,label:"sends"},{tid:tB,sel:selB,setSel:setSelB,selPk:pkB,setPk:setPkB,label:"sends"}].map(({tid,sel,setSel,selPk,setPk,label},ci)=>{
              const tm=gT(tid);
              const ps=sel.map(id=>gP(id)).filter(Boolean);
              const pks=resolvePicks(selPk,tid);
              const totalSal=ps.reduce((a,p)=>a+p.sal,0);
              return(
                <div key={tid} style={{borderRight:ci===0?"1px solid var(--border)":"none"}}>
                  <div style={{padding:"8px 12px",background:"var(--bg3)",borderBottom:"1px solid var(--border)",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      {tm?.logo&&<img src={tm.logo} alt="" style={{width:18,height:18,objectFit:"contain"}}/>}
                      <span style={{fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"var(--text3)"}}>{tm?.abbr} {label}</span>
                    </div>
                    {totalSal>0&&<span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--ac)"}}>{fmt(totalSal)}</span>}
                  </div>
                  <div style={{padding:"6px 8px",display:"flex",flexDirection:"column",gap:3,minHeight:50}}>
                    {ps.length===0&&pks.length===0&&(
                      <div style={{padding:"12px 0",textAlign:"center",fontSize:11,color:"var(--text3)",fontStyle:"italic"}}>No assets selected</div>
                    )}
                    {ps.map(p=>(
                      <div key={p.id} style={{display:"flex",alignItems:"center",gap:6,padding:"5px 6px",borderRadius:4,background:"var(--bg3)",fontSize:12}}>
                        {p.photoUrl
                          ? <img src={p.photoUrl} alt="" style={{width:24,height:24,borderRadius:"50%",objectFit:"cover",objectPosition:"top center",flexShrink:0}} onError={e=>e.target.style.display="none"}/>
                          : <Badge type={p.pos}/>
                        }
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontWeight:600,fontSize:12,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{p.name}</div>
                          <div style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)"}}>{p.sub||p.pos} · <span style={{color:fmtSal(p).color}}>{fmtSal(p).text}</span></div>
                        </div>
                        <button onClick={()=>setSel(s=>s.filter(x=>x!==p.id))} style={{fontSize:12,color:"var(--rd)",padding:"2px 6px",borderRadius:3,flexShrink:0,transition:"background .1s"}}
                          onMouseEnter={e=>e.target.style.background="rgba(239,83,80,.1)"}
                          onMouseLeave={e=>e.target.style.background="transparent"}>✕</button>
                      </div>
                    ))}
                    {pks.map((pk,i)=>(
                      <div key={pk._key} style={{display:"flex",alignItems:"center",gap:6,padding:"5px 6px",borderRadius:4,background:"var(--bg3)",fontSize:12}}>
                        <Badge type="Pick"/>
                        <div style={{flex:1}}>
                          <div style={{fontWeight:500}}>{pk.year} Round {pk.round}</div>
                          {pk.original_team!==tid&&<div style={{fontSize:10,color:"var(--text3)"}}>via {(gT(pk.original_team)?.abbr||'').toUpperCase()}</div>}
                        </div>
                        <button onClick={()=>setPk(s=>s.filter(x=>x!==pk._key))} style={{fontSize:12,color:"var(--rd)",padding:"2px 6px",borderRadius:3,flexShrink:0,transition:"background .1s"}}
                          onMouseEnter={e=>e.target.style.background="rgba(239,83,80,.1)"}
                          onMouseLeave={e=>e.target.style.background="transparent"}>✕</button>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Cap impact */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
            {[{tid:tA,spent:spentA,newCap:newA,space:spaceA},{tid:tB,spent:spentB,newCap:newB,space:spaceB}].map(({tid,spent,newCap,space})=>{
              const tm=gT(tid);
              const over=space<0;
              return(
                <div key={tid} style={{background:"var(--bg3)",borderRadius:6,padding:"10px 12px",border:"1px solid var(--border)"}}>
                  <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                    {tm?.logo&&<img src={tm.logo} alt="" style={{width:16,height:16,objectFit:"contain"}}/>}
                    <span style={{fontFamily:"var(--fm)",fontSize:10,letterSpacing:"1px",textTransform:"uppercase",color:"var(--text3)"}}>{tm?.abbr} Cap Impact</span>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}>
                    <span style={{color:"var(--text3)"}}>Before</span>
                    <span style={{fontFamily:"var(--fm)",fontSize:11}}>{fmt(spent)}</span>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}>
                    <span style={{color:"var(--text3)"}}>After</span>
                    <span style={{fontFamily:"var(--fm)",fontSize:11,fontWeight:700,color:over?"var(--rd)":"var(--text)"}}>{fmt(newCap)}</span>
                  </div>
                  <CapBar spent={newCap} cap={CAP_LIMIT} h={4}/>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginTop:4}}>
                    <span style={{color:"var(--text3)",fontFamily:"var(--fm)"}}>Limit: {fmt(CAP_LIMIT)}</span>
                    <span style={{fontFamily:"var(--fm)",fontWeight:600,color:over?"var(--rd)":space<50000?"var(--ye)":"var(--gr)"}}>
                      {over?`Over by ${fmt(Math.abs(space))}`:`${fmt(space)} left`}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Verdict */}
          {!hasBothSides?(
            <div className="verdict" style={{background:"rgba(79,195,247,.06)",color:"var(--ac)",border:"1px solid rgba(79,195,247,.15)"}}>
              Select assets from both teams to evaluate the trade
            </div>
          ): tradeOk ? (
            <div className="verdict v-ok" style={{display:"flex",flexDirection:"column",gap:4}}>
              <div style={{fontWeight:700}}>✓ Trade Accepted</div>
              <div style={{fontSize:11,opacity:.85}}>Both teams stay under the $1.34M salary cap</div>
              {nmcWarns.length>0&&<div style={{fontSize:11,color:"var(--ye)",marginTop:2}}>Note: {nmcWarns.length} clause restriction{nmcWarns.length>1?'s':''} — player consent required</div>}
            </div>
          ) : (
            <div className="verdict v-bad" style={{display:"flex",flexDirection:"column",gap:4}}>
              <div style={{fontWeight:700}}>✗ Trade Rejected</div>
              {reasons.map((r,i)=>(
                <div key={i} style={{fontSize:11,display:"flex",alignItems:"flex-start",gap:5}}>
                  <span style={{flexShrink:0}}>•</span>
                  <span>{r}</span>
                </div>
              ))}
            </div>
          )}

          {/* Clear all button */}
          <div style={{textAlign:"center",marginTop:10}}>
            <button onClick={()=>{setSelA([]);setSelB([]);setPkA([]);setPkB([]);}} style={{fontSize:11,color:"var(--text3)",padding:"6px 16px",borderRadius:4,border:"1px solid var(--border)",background:"var(--bg3)",transition:"all .12s"}}
              onMouseEnter={e=>{e.target.style.color="var(--rd)";e.target.style.borderColor="var(--rd)";}}
              onMouseLeave={e=>{e.target.style.color="var(--text3)";e.target.style.borderColor="var(--border)";}}>
              Clear Trade
            </button>
          </div>
        </div>
      ):(
        <div style={{textAlign:"center",padding:"32px 20px",color:"var(--text3)"}}>
          <div style={{fontSize:24,marginBottom:8}}>⇄</div>
          <div style={{fontFamily:"var(--fm)",fontSize:12}}>Select players or picks from both panels to simulate a trade</div>
        </div>
      )}
    </div>
  );
}
 
function ArmchairPage({players,onPlayer}){
  const [selTeam,setSelTeam]=useState("bos");
  const [roster,setRoster]=useState([]);
  const [tab,setTab]=useState("roster");
  useEffect(()=>{
    if(players.length && roster.length===0) setRoster(players.filter(p=>p.team==="bos").map(p=>p.id));
  },[players]);
  const changeTeam=id=>{setSelTeam(id);setRoster(players.filter(p=>p.team===id).map(p=>p.id));};
  const rp=players.filter(p=>roster.includes(p.id)).sort((a,b)=>b.sal-a.sal);
  const fa=players.filter(p=>(p.status==="UFA"||p.status==="RFA")&&!roster.includes(p.id));
  const spent=rp.reduce((a,p)=>a+p.sal,0),space=CAP_LIMIT-spent,over=space<0;
  return(
    <div className="fu">
      <div className="ph"><h1>Armchair GM</h1><span className="ph-sub">Build a roster · arrange lines · live cap</span></div>
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:14,flexWrap:"wrap"}}>
        <select value={selTeam} onChange={e=>changeTeam(e.target.value)} className="sel" style={{fontSize:13,padding:"7px 9px"}}>
          {TEAMS.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
        <div className="tab-group">
          <button className={`tab-btn ${tab==="lines"?"on":""}`} onClick={()=>setTab("lines")}>Lines</button>
          <button className={`tab-btn ${tab==="roster"?"on":""}`} onClick={()=>setTab("roster")}>Roster</button>
        </div>
      </div>
      <div className="agm-sum">
        <div style={{fontSize:11,color:"var(--text3)"}}>Total Cap Hit — {rp.length} players</div>
        <div className="agm-num" style={{color:over?"var(--rd)":"var(--text)"}}>{fmt(spent)}</div>
        <CapBar spent={spent} cap={CAP_LIMIT} h={5}/>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginTop:5,fontFamily:"var(--fm)"}}>
          <span style={{color:"var(--text3)"}}>Limit: {fmt(CAP_LIMIT)}</span>
          <span style={{color:over?"var(--rd)":"var(--gr)"}}>{over?`Over by ${fmt(Math.abs(space))}`:`${fmt(space)} available`}</span>
        </div>
        <div className={`alert ${over?"alert-bad":"alert-ok"}`}>{over?"⚠ Over cap — remove players to comply":"✓ Roster is cap-compliant"}</div>
      </div>
      {tab==="lines"&&(
        <div className="crd" style={{marginBottom:14}}>
          <div className="crd-h">
            <span className="crd-t">Line Combinations</span>
            <span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)"}}>Tap = info · Drag = swap</span>
          </div>
          <LineBuilder players={rp} onProfile={onPlayer}/>
          <div style={{padding:"10px 14px",borderTop:"1px solid var(--border)",display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
            <span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",letterSpacing:"1px",textTransform:"uppercase",flexShrink:0}}>Add FA:</span>
            {fa.slice(0,6).map(p=>(
              <button key={p.id} disabled={over}
                style={{display:"flex",alignItems:"center",gap:4,padding:"4px 9px",borderRadius:4,background:"var(--bg4)",border:"1px solid var(--border2)",fontSize:11,cursor:over?"not-allowed":"pointer",opacity:over?.5:1}}
                onClick={()=>setRoster(r=>[...r,p.id])}>
                <span className={`bx b-${p.pos.toLowerCase()}`}>{p.pos}</span>
                #{p.num} {p.name}
              </button>
            ))}
          </div>
        </div>
      )}
      {tab==="roster"&&(
        <div className="agm-layout">
          <div>
            <span className="slbl">Current Roster ({rp.length} players)</span>
            <div className="crd">
              {rp.map(p=>(
                <div key={p.id} className="agm-row">
                  <span style={{fontFamily:"var(--fm)",fontSize:10,color:"var(--text3)",width:28}}>#{p.num}</span>
                  <Badge type={p.pos}/>
                  <span style={{flex:1,fontSize:12,fontWeight:500,color:"var(--ac)",cursor:"pointer"}} onClick={()=>onPlayer(p.id)}>{p.name}</span>
                  <span style={{fontFamily:"var(--fm)",fontSize:11,color:fmtSal(p).color}}>{fmtSal(p).text}</span>
                  <button style={{fontSize:10,padding:"2px 6px",borderRadius:3,color:"var(--rd)"}} onClick={()=>setRoster(r=>r.filter(x=>x!==p.id))}>✕</button>
                </div>
              ))}
            </div>
          </div>
          <div>
            <span className="slbl">Available Free Agents</span>
            <div className="crd">
              {fa.slice(0,20).map(p=>(
                <div key={p.id} className="agm-fa">
                  <div onClick={()=>onPlayer(p.id)}>
                    <div style={{fontWeight:500,fontSize:12,color:"var(--ac)"}}>#{p.num} {p.name}</div>
                    <div style={{fontSize:10,color:"var(--text3)",marginTop:1}}>{p.pos} · {gT(p.team)?.abbr} · <span style={{color:fmtSal(p).color}}>{fmtSal(p).text}</span></div>
                  </div>
                  <button className="agm-add" disabled={over} onClick={()=>setRoster(r=>[...r,p.id])}>+ Add</button>
                </div>
              ))}
              {!fa.length&&<div style={{padding:"12px 13px",fontSize:12,color:"var(--text3)"}}>All available players are on roster.</div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
 
function CBAPage(){
  const [open,setOpen]=useState(null);
  return(
    <div className="fu">
      <div className="ph"><h1>CBA Guide</h1><span className="ph-sub">PWHL Collective Bargaining Agreement explained</span></div>
      <div style={{maxWidth:740}}>
        {CBA_RULES.map((r,i)=>(
          <div key={i} className="cba-item">
            <div className="cba-q" onClick={()=>setOpen(open===i?null:i)}>
              <span>{r.q}</span><span className={`cba-chev ${open===i?"op":""}`}>▼</span>
            </div>
            {open===i&&<div className="cba-a">{r.a}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
 
// ─── APP ──────────────────────────────────────────────────────────────────────
export default function App(){
  const [page,setPage]=useState("home");
  const [teamId,setTeamId]=useState(null);
  const [playerId,setPlayerId]=useState(null);
  const [from,setFrom]=useState(null);
  const [dbPlayers,setDbPlayers]=useState(null);
  const [dbSkaterStats,setDbSkaterStats]=useState([]);
  const [dbGoalieStats,setDbGoalieStats]=useState([]);
  const [playedSet,setPlayedSet]=useState(new Set());
  const [loading,setLoading]=useState(true);
  const [theme,setTheme]=useState(()=>{try{return localStorage.getItem('pwhlcap-theme')||'dark'}catch{return 'dark'}});
  const [mobNav,setMobNav]=useState(false);
 
  useEffect(()=>{
    document.documentElement.setAttribute('data-theme',theme);
    try{localStorage.setItem('pwhlcap-theme',theme)}catch{}
  },[theme]);
  const toggleTheme=()=>setTheme(t=>t==='dark'?'light':'dark');
 
  useEffect(()=>{
    Promise.all([
      dbFetchPlayers(),
      dbFetchSkaterStats('2025-26'),
      dbFetchGoalieStats('2025-26'),
      supabase.from('contracts').select('player_id, salary, years, end_year, start_year, status, clause, notes').eq('is_active', true),
    ]).then(([players, skaters, goalies, contractsRes])=>{
      const dbContracts = {};
      if (contractsRes?.data) {
        contractsRes.data.forEach(c => {
          dbContracts[c.player_id] = c;
          dbContracts[String(c.player_id)] = c;
        });
      }
 
      if (players) {
        const mapped = players.map(p => {
          const appPlayer = dbPlayerToApp(p, CONTRACT_DATA);
          return appPlayer;
        });
        const mappedWithContracts = mapped.map(p => {
          const dbContract = dbContracts[p.id] || dbContracts[String(p.id)];
 
          if (dbContract) {
            const endYrRaw = dbContract.end_year || '2025-26';
            const endYr = endYrRaw.includes('-')
              ? String(2000 + parseInt(endYrRaw.split('-')[1]))
              : String(parseInt(endYrRaw));
            return {
              ...p,
              sal:        dbContract.salary || 0,
              yrs:        dbContract.years  || 1,
              exp:        endYr,
              clause:     dbContract.clause || '—',
              status:     dbContract.status || 'RFA',
              source:     dbContract.notes  || '',
              isEstimate: (dbContract.notes || '').includes('est.'),
              transactions: [{
                date:   dbContract.start_year || '2025-26',
                type:   dbContract.status === 'Signed' ? 'Signed' : 'RFA',
                detail: `${dbContract.notes || 'Contract'} · $${dbContract.salary?.toLocaleString()}`
              }],
            };
          }
          return p;
        });
        setDbPlayers(mappedWithContracts);
      }
      const playedIds = new Set();
      if (skaters) skaters.filter(s=>s.season==='2025-26').forEach(s=>playedIds.add(s.player_id));
      if (goalies) goalies.filter(s=>s.season==='2025-26').forEach(s=>playedIds.add(s.player_id));
      setPlayedSet(playedIds);
      setDbSkaterStats(skaters || []);
      setDbGoalieStats(goalies || []);
      window.__allSkaterStats = skaters || [];
      window.__allGoalieStats = goalies || [];
      setLoading(false);
    }).catch(err=>{
      console.error('DB load error:', err);
      setLoading(false);
    });
  },[]);
 
  const ACTIVE_PLAYERS = (dbPlayers || PLAYERS).map(p=>({
    ...p,
    hasPlayed: playedSet.has(p.id),
  }));
  _PLAYERS = ACTIVE_PLAYERS;
  _THEME = theme;
 
  const go=(p,extra=null,fromCtx=null,pushState=true)=>{
    setPage(p);
    if(p==="team") setTeamId(extra);
    if(p==="player"){setPlayerId(extra);setFrom(fromCtx);}
    window.scrollTo(0,0);
    if(pushState){
      const state={p,extra,fromCtx};
      const url=p==="home"?"/":p==="team"?`/team/${extra}`:p==="player"?`/player/${extra}`:`/${p}`;
      window.history.pushState(state, "", url);
    }
  };
 
  useEffect(()=>{
    const path = window.location.pathname;
    const match = path.match(/^\/(\w+)(?:\/(.+))?/);
    if(match) {
      const [, pg, extra] = match;
      if(pg==="team" && extra) { setPage("team"); setTeamId(extra); }
      else if(pg==="player" && extra) { setPage("player"); setPlayerId(parseInt(extra)||extra); }
      else if(["players","stats","trade","armchair","cba"].includes(pg)) { setPage(pg==="stats"?"players":pg); }
    }

    const onPop=(e)=>{
      if(!e.state) { setPage("home"); return; }
      const {p,extra,fromCtx}=e.state;
      setPage(p);
      if(p==="team") setTeamId(extra);
      if(p==="player"){setPlayerId(extra);setFrom(fromCtx);}
      window.scrollTo(0,0);
    };
    window.addEventListener("popstate", onPop);
    return ()=>window.removeEventListener("popstate", onPop);
  },[]);
 
  const goPlayer=(pid,ctx)=>go("player",pid,ctx||{page,teamId,label:"Back"});
 
  const goBack=()=>{
    window.history.back();
  };
 
  const backLabel=from?.page==="team"?(gT(from.teamId)?.name||"Team"):
    from?.page==="armchair"?"Armchair GM":
    from?.page==="stats"?"Players":
    from?.page==="players"?"Players":"Back";
 
  const NAV=[
    {id:"home",l:"Overview"},
    {id:"players",l:"Players"},
    {id:"trade",l:"Trade Sim"},
    {id:"armchair",l:"Armchair GM"},
    {id:"cba",l:"CBA Guide"},
  ];
 
  const goNav=(id)=>{go(id);setMobNav(false);};

  return(
    <>
      <style>{CSS}</style>
      <div className="shell">
        <header className="bar">
          <div className="bar-inner">
            <div className="logo" onClick={()=>goNav("home")}><div className="logo-dot"/>PWHL<em>CAP</em></div>
            <nav className="nav-desk" style={{display:"flex",gap:0,alignItems:"stretch"}}>
              {NAV.map(n=><button key={n.id} className={`nb ${page===n.id||(page==="team"&&n.id==="home")?"on":""}`} onClick={()=>goNav(n.id)}>{n.l}</button>)}
            </nav>
            <span className="stag">{loading?"Loading…":"2025–26"}</span>
            <button className="theme-toggle" onClick={toggleTheme} title={theme==='dark'?'Switch to light mode':'Switch to dark mode'}>
              {theme==='dark'?'☀':'🌙'}
            </button>
            <div className="ham" onClick={()=>setMobNav(!mobNav)}>
              <span/><span/><span/>
            </div>
          </div>
        </header>
        <div className={`mob-nav ${mobNav?"open":""}`}>
          {NAV.map(n=><button key={n.id} className={page===n.id?"on":""} onClick={()=>goNav(n.id)}>{n.l}</button>)}
        </div>
        <main className="main">
          {loading&&(
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"60px 20px",gap:16}}>
              <div style={{width:32,height:32,border:"3px solid var(--border2)",borderTop:"3px solid var(--ac)",borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/>
              <div style={{fontFamily:"var(--fm)",fontSize:12,color:"var(--text3)",letterSpacing:"1px"}}>Loading roster data…</div>
            </div>
          )}
          {!loading&&page==="home"    &&<HomePage    players={ACTIVE_PLAYERS} skaterStats={dbSkaterStats} goalieStats={dbGoalieStats} onTeam={id=>go("team",id)} onPlayer={pid=>goPlayer(pid,{page:"home",label:"Home"})}/>}
          {!loading&&page==="team"    &&<TeamPage    players={ACTIVE_PLAYERS} teamId={teamId} onBack={()=>go("home")} onPlayer={pid=>goPlayer(pid,{page:"team",teamId,label:gT(teamId)?.name})}/>}
          {!loading&&page==="player"  &&<PlayerPage  players={ACTIVE_PLAYERS} playerId={playerId} onBack={goBack} backLabel={backLabel}/>}
          {!loading&&page==="players" &&<PlayersPage players={ACTIVE_PLAYERS} skaterStats={dbSkaterStats} goalieStats={dbGoalieStats} onPlayer={pid=>goPlayer(pid,{page:"players",label:"Players"})}/>}
          {!loading&&page==="trade"   &&<TradePage   players={ACTIVE_PLAYERS}/>}
          {!loading&&page==="armchair"&&<ArmchairPage players={ACTIVE_PLAYERS} onPlayer={pid=>goPlayer(pid,{page:"armchair",label:"Armchair GM"})}/>}
          {!loading&&page==="cba"     &&<CBAPage/>}
        </main>
        <footer className="foot">
          PWHLCap.com &nbsp;·&nbsp; Unofficial PWHL salary cap resource &nbsp;·&nbsp;
          <a href="mailto:corrections@pwhlcap.com">Suggest a correction</a> &nbsp;·&nbsp; Not affiliated with the PWHL
        </footer>
      </div>
    </>
  );
}